function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype
                ? "symbol"
                : typeof obj;
        };
    }
    return _typeof(obj);
} /*! jQuery v3.5.1 | (c) JS Foundation and other contributors | jquery.org/license */
!(function (e, t) {
    "use strict";
    "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && "object" == _typeof(module.exports)
        ? (module.exports = e.document
              ? t(e, !0)
              : function (e) {
                    if (!e.document) throw new Error("jQuery requires a window with a document");
                    return t(e);
                })
        : t(e);
})("undefined" != typeof window ? window : this, function (C, e) {
    "use strict";
    var t = [],
        r = Object.getPrototypeOf,
        s = t.slice,
        g = t.flat
            ? function (e) {
                  return t.flat.call(e);
              }
            : function (e) {
                  return t.concat.apply([], e);
              },
        u = t.push,
        i = t.indexOf,
        n = {},
        o = n.toString,
        v = n.hasOwnProperty,
        a = v.toString,
        l = a.call(Object),
        y = {},
        m = function m(e) {
            return "function" == typeof e && "number" != typeof e.nodeType;
        },
        x = function x(e) {
            return null != e && e === e.window;
        },
        E = C.document,
        c = { type: !0, src: !0, nonce: !0, noModule: !0 };
    function b(e, t, n) {
        var r,
            i,
            o = (n = n || E).createElement("script");
        if (((o.text = e), t))
            for (r in c) {
                (i = t[r] || (t.getAttribute && t.getAttribute(r))) && o.setAttribute(r, i);
            }
        n.head.appendChild(o).parentNode.removeChild(o);
    }
    function w(e) {
        return null == e
            ? e + ""
            : "object" == _typeof(e) || "function" == typeof e
              ? n[o.call(e)] || "object"
              : _typeof(e);
    }
    var f = "3.5.1",
        S = function S(e, t) {
            return new S.fn.init(e, t);
        };
    function p(e) {
        var t = !!e && "length" in e && e.length,
            n = w(e);
        return !m(e) && !x(e) && ("array" === n || 0 === t || ("number" == typeof t && 0 < t && t - 1 in e));
    }
    (S.fn = S.prototype =
        {
            jquery: f,
            constructor: S,
            length: 0,
            toArray: function toArray() {
                return s.call(this);
            },
            get: function get(e) {
                return null == e ? s.call(this) : e < 0 ? this[e + this.length] : this[e];
            },
            pushStack: function pushStack(e) {
                var t = S.merge(this.constructor(), e);
                return (t.prevObject = this), t;
            },
            each: function each(e) {
                return S.each(this, e);
            },
            map: function map(n) {
                return this.pushStack(
                    S.map(this, function (e, t) {
                        return n.call(e, t, e);
                    })
                );
            },
            slice: function slice() {
                return this.pushStack(s.apply(this, arguments));
            },
            first: function first() {
                return this.eq(0);
            },
            last: function last() {
                return this.eq(-1);
            },
            even: function even() {
                return this.pushStack(
                    S.grep(this, function (e, t) {
                        return (t + 1) % 2;
                    })
                );
            },
            odd: function odd() {
                return this.pushStack(
                    S.grep(this, function (e, t) {
                        return t % 2;
                    })
                );
            },
            eq: function eq(e) {
                var t = this.length,
                    n = +e + (e < 0 ? t : 0);
                return this.pushStack(0 <= n && n < t ? [this[n]] : []);
            },
            end: function end() {
                return this.prevObject || this.constructor();
            },
            push: u,
            sort: t.sort,
            splice: t.splice,
        }),
        (S.extend = S.fn.extend =
            function () {
                var e,
                    t,
                    n,
                    r,
                    i,
                    o,
                    a = arguments[0] || {},
                    s = 1,
                    u = arguments.length,
                    l = !1;
                for (
                    "boolean" == typeof a && ((l = a), (a = arguments[s] || {}), s++),
                        "object" == _typeof(a) || m(a) || (a = {}),
                        s === u && ((a = this), s--);
                    s < u;
                    s++
                ) {
                    if (null != (e = arguments[s]))
                        for (t in e) {
                            (r = e[t]),
                                "__proto__" !== t &&
                                    a !== r &&
                                    (l && r && (S.isPlainObject(r) || (i = Array.isArray(r)))
                                        ? ((n = a[t]),
                                          (o = i && !Array.isArray(n) ? [] : i || S.isPlainObject(n) ? n : {}),
                                          (i = !1),
                                          (a[t] = S.extend(l, o, r)))
                                        : void 0 !== r && (a[t] = r));
                        }
                }
                return a;
            }),
        S.extend({
            expando: "jQuery" + (f + Math.random()).replace(/\D/g, ""),
            isReady: !0,
            error: function error(e) {
                throw new Error(e);
            },
            noop: function noop() {},
            isPlainObject: function isPlainObject(e) {
                var t, n;
                return (
                    !(!e || "[object Object]" !== o.call(e)) &&
                    (!(t = r(e)) ||
                        ("function" == typeof (n = v.call(t, "constructor") && t.constructor) && a.call(n) === l))
                );
            },
            isEmptyObject: function isEmptyObject(e) {
                var t;
                for (t in e) {
                    return !1;
                }
                return !0;
            },
            globalEval: function globalEval(e, t, n) {
                b(e, { nonce: t && t.nonce }, n);
            },
            each: function each(e, t) {
                var n,
                    r = 0;
                if (p(e)) {
                    for (n = e.length; r < n; r++) {
                        if (!1 === t.call(e[r], r, e[r])) break;
                    }
                } else
                    for (r in e) {
                        if (!1 === t.call(e[r], r, e[r])) break;
                    }
                return e;
            },
            makeArray: function makeArray(e, t) {
                var n = t || [];
                return null != e && (p(Object(e)) ? S.merge(n, "string" == typeof e ? [e] : e) : u.call(n, e)), n;
            },
            inArray: function inArray(e, t, n) {
                return null == t ? -1 : i.call(t, e, n);
            },
            merge: function merge(e, t) {
                for (var n = +t.length, r = 0, i = e.length; r < n; r++) {
                    e[i++] = t[r];
                }
                return (e.length = i), e;
            },
            grep: function grep(e, t, n) {
                for (var r = [], i = 0, o = e.length, a = !n; i < o; i++) {
                    !t(e[i], i) !== a && r.push(e[i]);
                }
                return r;
            },
            map: function map(e, t, n) {
                var r,
                    i,
                    o = 0,
                    a = [];
                if (p(e))
                    for (r = e.length; o < r; o++) {
                        null != (i = t(e[o], o, n)) && a.push(i);
                    }
                else
                    for (o in e) {
                        null != (i = t(e[o], o, n)) && a.push(i);
                    }
                return g(a);
            },
            guid: 1,
            support: y,
        }),
        "function" == typeof Symbol && (S.fn[Symbol.iterator] = t[Symbol.iterator]),
        S.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
            n["[object " + t + "]"] = t.toLowerCase();
        });
    var d = (function (n) {
        var e,
            d,
            b,
            o,
            i,
            h,
            f,
            g,
            w,
            u,
            l,
            T,
            C,
            a,
            E,
            v,
            s,
            c,
            y,
            S = "sizzle" + 1 * new Date(),
            p = n.document,
            k = 0,
            r = 0,
            m = ue(),
            x = ue(),
            A = ue(),
            N = ue(),
            D = function D(e, t) {
                return e === t && (l = !0), 0;
            },
            j = {}.hasOwnProperty,
            t = [],
            q = t.pop,
            L = t.push,
            H = t.push,
            O = t.slice,
            P = function P(e, t) {
                for (var n = 0, r = e.length; n < r; n++) {
                    if (e[n] === t) return n;
                }
                return -1;
            },
            R =
                "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            M = "[\\x20\\t\\r\\n\\f]",
            I = "(?:\\\\[\\da-fA-F]{1,6}" + M + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
            W =
                "\\[" +
                M +
                "*(" +
                I +
                ")(?:" +
                M +
                "*([*^$|!~]?=)" +
                M +
                "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
                I +
                "))|)" +
                M +
                "*\\]",
            F =
                ":(" +
                I +
                ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
                W +
                ")*)|.*)\\)|)",
            B = new RegExp(M + "+", "g"),
            $ = new RegExp("^" + M + "+|((?:^|[^\\\\])(?:\\\\.)*)" + M + "+$", "g"),
            _ = new RegExp("^" + M + "*," + M + "*"),
            z = new RegExp("^" + M + "*([>+~]|" + M + ")" + M + "*"),
            U = new RegExp(M + "|>"),
            X = new RegExp(F),
            V = new RegExp("^" + I + "$"),
            G = {
                ID: new RegExp("^#(" + I + ")"),
                CLASS: new RegExp("^\\.(" + I + ")"),
                TAG: new RegExp("^(" + I + "|[*])"),
                ATTR: new RegExp("^" + W),
                PSEUDO: new RegExp("^" + F),
                CHILD: new RegExp(
                    "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
                        M +
                        "*(even|odd|(([+-]|)(\\d*)n|)" +
                        M +
                        "*(?:([+-]|)" +
                        M +
                        "*(\\d+)|))" +
                        M +
                        "*\\)|)",
                    "i"
                ),
                bool: new RegExp("^(?:" + R + ")$", "i"),
                needsContext: new RegExp(
                    "^" +
                        M +
                        "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
                        M +
                        "*((?:-\\d)?\\d*)" +
                        M +
                        "*\\)|)(?=[^-]|$)",
                    "i"
                ),
            },
            Y = /HTML$/i,
            Q = /^(?:input|select|textarea|button)$/i,
            J = /^h\d$/i,
            K = /^[^{]+\{\s*\[native \w/,
            Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            ee = /[+~]/,
            te = new RegExp("\\\\[\\da-fA-F]{1,6}" + M + "?|\\\\([^\\r\\n\\f])", "g"),
            ne = function ne(e, t) {
                var n = "0x" + e.slice(1) - 65536;
                return (
                    t ||
                    (n < 0
                        ? String.fromCharCode(n + 65536)
                        : String.fromCharCode((n >> 10) | 55296, (1023 & n) | 56320))
                );
            },
            re = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
            ie = function ie(e, t) {
                return t
                    ? "\0" === e
                        ? "\uFFFD"
                        : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " "
                    : "\\" + e;
            },
            oe = function oe() {
                T();
            },
            ae = be(
                function (e) {
                    return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
                },
                { dir: "parentNode", next: "legend" }
            );
        try {
            H.apply((t = O.call(p.childNodes)), p.childNodes), t[p.childNodes.length].nodeType;
        } catch (e) {
            H = {
                apply: t.length
                    ? function (e, t) {
                          L.apply(e, O.call(t));
                      }
                    : function (e, t) {
                          var n = e.length,
                              r = 0;
                          while ((e[n++] = t[r++])) {}
                          e.length = n - 1;
                      },
            };
        }
        function se(t, e, n, r) {
            var i,
                o,
                a,
                s,
                u,
                l,
                c,
                f = e && e.ownerDocument,
                p = e ? e.nodeType : 9;
            if (((n = n || []), "string" != typeof t || !t || (1 !== p && 9 !== p && 11 !== p))) return n;
            if (!r && (T(e), (e = e || C), E)) {
                if (11 !== p && (u = Z.exec(t)))
                    if ((i = u[1])) {
                        if (9 === p) {
                            if (!(a = e.getElementById(i))) return n;
                            if (a.id === i) return n.push(a), n;
                        } else if (f && (a = f.getElementById(i)) && y(e, a) && a.id === i) return n.push(a), n;
                    } else {
                        if (u[2]) return H.apply(n, e.getElementsByTagName(t)), n;
                        if ((i = u[3]) && d.getElementsByClassName && e.getElementsByClassName)
                            return H.apply(n, e.getElementsByClassName(i)), n;
                    }
                if (d.qsa && !N[t + " "] && (!v || !v.test(t)) && (1 !== p || "object" !== e.nodeName.toLowerCase())) {
                    if (((c = t), (f = e), 1 === p && (U.test(t) || z.test(t)))) {
                        ((f = (ee.test(t) && ye(e.parentNode)) || e) === e && d.scope) ||
                            ((s = e.getAttribute("id")) ? (s = s.replace(re, ie)) : e.setAttribute("id", (s = S))),
                            (o = (l = h(t)).length);
                        while (o--) {
                            l[o] = (s ? "#" + s : ":scope") + " " + xe(l[o]);
                        }
                        c = l.join(",");
                    }
                    try {
                        return H.apply(n, f.querySelectorAll(c)), n;
                    } catch (e) {
                        N(t, !0);
                    } finally {
                        s === S && e.removeAttribute("id");
                    }
                }
            }
            return g(t.replace($, "$1"), e, n, r);
        }
        function ue() {
            var r = [];
            return function e(t, n) {
                return r.push(t + " ") > b.cacheLength && delete e[r.shift()], (e[t + " "] = n);
            };
        }
        function le(e) {
            return (e[S] = !0), e;
        }
        function ce(e) {
            var t = C.createElement("fieldset");
            try {
                return !!e(t);
            } catch (e) {
                return !1;
            } finally {
                t.parentNode && t.parentNode.removeChild(t), (t = null);
            }
        }
        function fe(e, t) {
            var n = e.split("|"),
                r = n.length;
            while (r--) {
                b.attrHandle[n[r]] = t;
            }
        }
        function pe(e, t) {
            var n = t && e,
                r = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
            if (r) return r;
            if (n)
                while ((n = n.nextSibling)) {
                    if (n === t) return -1;
                }
            return e ? 1 : -1;
        }
        function de(t) {
            return function (e) {
                return "input" === e.nodeName.toLowerCase() && e.type === t;
            };
        }
        function he(n) {
            return function (e) {
                var t = e.nodeName.toLowerCase();
                return ("input" === t || "button" === t) && e.type === n;
            };
        }
        function ge(t) {
            return function (e) {
                return "form" in e
                    ? e.parentNode && !1 === e.disabled
                        ? "label" in e
                            ? "label" in e.parentNode
                                ? e.parentNode.disabled === t
                                : e.disabled === t
                            : e.isDisabled === t || (e.isDisabled !== !t && ae(e) === t)
                        : e.disabled === t
                    : "label" in e && e.disabled === t;
            };
        }
        function ve(a) {
            return le(function (o) {
                return (
                    (o = +o),
                    le(function (e, t) {
                        var n,
                            r = a([], e.length, o),
                            i = r.length;
                        while (i--) {
                            e[(n = r[i])] && (e[n] = !(t[n] = e[n]));
                        }
                    })
                );
            });
        }
        function ye(e) {
            return e && "undefined" != typeof e.getElementsByTagName && e;
        }
        for (e in ((d = se.support = {}),
        (i = se.isXML =
            function (e) {
                var t = e.namespaceURI,
                    n = (e.ownerDocument || e).documentElement;
                return !Y.test(t || (n && n.nodeName) || "HTML");
            }),
        (T = se.setDocument =
            function (e) {
                var t,
                    n,
                    r = e ? e.ownerDocument || e : p;
                return (
                    r != C &&
                        9 === r.nodeType &&
                        r.documentElement &&
                        ((a = (C = r).documentElement),
                        (E = !i(C)),
                        p != C &&
                            (n = C.defaultView) &&
                            n.top !== n &&
                            (n.addEventListener
                                ? n.addEventListener("unload", oe, !1)
                                : n.attachEvent && n.attachEvent("onunload", oe)),
                        (d.scope = ce(function (e) {
                            return (
                                a.appendChild(e).appendChild(C.createElement("div")),
                                "undefined" != typeof e.querySelectorAll &&
                                    !e.querySelectorAll(":scope fieldset div").length
                            );
                        })),
                        (d.attributes = ce(function (e) {
                            return (e.className = "i"), !e.getAttribute("className");
                        })),
                        (d.getElementsByTagName = ce(function (e) {
                            return e.appendChild(C.createComment("")), !e.getElementsByTagName("*").length;
                        })),
                        (d.getElementsByClassName = K.test(C.getElementsByClassName)),
                        (d.getById = ce(function (e) {
                            return (a.appendChild(e).id = S), !C.getElementsByName || !C.getElementsByName(S).length;
                        })),
                        d.getById
                            ? ((b.filter.ID = function (e) {
                                  var t = e.replace(te, ne);
                                  return function (e) {
                                      return e.getAttribute("id") === t;
                                  };
                              }),
                              (b.find.ID = function (e, t) {
                                  if ("undefined" != typeof t.getElementById && E) {
                                      var n = t.getElementById(e);
                                      return n ? [n] : [];
                                  }
                              }))
                            : ((b.filter.ID = function (e) {
                                  var n = e.replace(te, ne);
                                  return function (e) {
                                      var t = "undefined" != typeof e.getAttributeNode && e.getAttributeNode("id");
                                      return t && t.value === n;
                                  };
                              }),
                              (b.find.ID = function (e, t) {
                                  if ("undefined" != typeof t.getElementById && E) {
                                      var n,
                                          r,
                                          i,
                                          o = t.getElementById(e);
                                      if (o) {
                                          if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
                                          (i = t.getElementsByName(e)), (r = 0);
                                          while ((o = i[r++])) {
                                              if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
                                          }
                                      }
                                      return [];
                                  }
                              })),
                        (b.find.TAG = d.getElementsByTagName
                            ? function (e, t) {
                                  return "undefined" != typeof t.getElementsByTagName
                                      ? t.getElementsByTagName(e)
                                      : d.qsa
                                        ? t.querySelectorAll(e)
                                        : void 0;
                              }
                            : function (e, t) {
                                  var n,
                                      r = [],
                                      i = 0,
                                      o = t.getElementsByTagName(e);
                                  if ("*" === e) {
                                      while ((n = o[i++])) {
                                          1 === n.nodeType && r.push(n);
                                      }
                                      return r;
                                  }
                                  return o;
                              }),
                        (b.find.CLASS =
                            d.getElementsByClassName &&
                            function (e, t) {
                                if ("undefined" != typeof t.getElementsByClassName && E)
                                    return t.getElementsByClassName(e);
                            }),
                        (s = []),
                        (v = []),
                        (d.qsa = K.test(C.querySelectorAll)) &&
                            (ce(function (e) {
                                var t;
                                (a.appendChild(e).innerHTML =
                                    "<a id='" +
                                    S +
                                    "'></a><select id='" +
                                    S +
                                    "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                                    e.querySelectorAll("[msallowcapture^='']").length &&
                                        v.push("[*^$]=" + M + "*(?:''|\"\")"),
                                    e.querySelectorAll("[selected]").length ||
                                        v.push("\\[" + M + "*(?:value|" + R + ")"),
                                    e.querySelectorAll("[id~=" + S + "-]").length || v.push("~="),
                                    (t = C.createElement("input")).setAttribute("name", ""),
                                    e.appendChild(t),
                                    e.querySelectorAll("[name='']").length ||
                                        v.push("\\[" + M + "*name" + M + "*=" + M + "*(?:''|\"\")"),
                                    e.querySelectorAll(":checked").length || v.push(":checked"),
                                    e.querySelectorAll("a#" + S + "+*").length || v.push(".#.+[+~]"),
                                    e.querySelectorAll("\\\f"),
                                    v.push("[\\r\\n\\f]");
                            }),
                            ce(function (e) {
                                e.innerHTML =
                                    "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                                var t = C.createElement("input");
                                t.setAttribute("type", "hidden"),
                                    e.appendChild(t).setAttribute("name", "D"),
                                    e.querySelectorAll("[name=d]").length && v.push("name" + M + "*[*^$|!~]?="),
                                    2 !== e.querySelectorAll(":enabled").length && v.push(":enabled", ":disabled"),
                                    (a.appendChild(e).disabled = !0),
                                    2 !== e.querySelectorAll(":disabled").length && v.push(":enabled", ":disabled"),
                                    e.querySelectorAll("*,:x"),
                                    v.push(",.*:");
                            })),
                        (d.matchesSelector = K.test(
                            (c =
                                a.matches ||
                                a.webkitMatchesSelector ||
                                a.mozMatchesSelector ||
                                a.oMatchesSelector ||
                                a.msMatchesSelector)
                        )) &&
                            ce(function (e) {
                                (d.disconnectedMatch = c.call(e, "*")), c.call(e, "[s!='']:x"), s.push("!=", F);
                            }),
                        (v = v.length && new RegExp(v.join("|"))),
                        (s = s.length && new RegExp(s.join("|"))),
                        (t = K.test(a.compareDocumentPosition)),
                        (y =
                            t || K.test(a.contains)
                                ? function (e, t) {
                                      var n = 9 === e.nodeType ? e.documentElement : e,
                                          r = t && t.parentNode;
                                      return (
                                          e === r ||
                                          !(
                                              !r ||
                                              1 !== r.nodeType ||
                                              !(n.contains
                                                  ? n.contains(r)
                                                  : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r))
                                          )
                                      );
                                  }
                                : function (e, t) {
                                      if (t)
                                          while ((t = t.parentNode)) {
                                              if (t === e) return !0;
                                          }
                                      return !1;
                                  }),
                        (D = t
                            ? function (e, t) {
                                  if (e === t) return (l = !0), 0;
                                  var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                                  return (
                                      n ||
                                      (1 &
                                          (n =
                                              (e.ownerDocument || e) == (t.ownerDocument || t)
                                                  ? e.compareDocumentPosition(t)
                                                  : 1) ||
                                      (!d.sortDetached && t.compareDocumentPosition(e) === n)
                                          ? e == C || (e.ownerDocument == p && y(p, e))
                                              ? -1
                                              : t == C || (t.ownerDocument == p && y(p, t))
                                                ? 1
                                                : u
                                                  ? P(u, e) - P(u, t)
                                                  : 0
                                          : 4 & n
                                            ? -1
                                            : 1)
                                  );
                              }
                            : function (e, t) {
                                  if (e === t) return (l = !0), 0;
                                  var n,
                                      r = 0,
                                      i = e.parentNode,
                                      o = t.parentNode,
                                      a = [e],
                                      s = [t];
                                  if (!i || !o)
                                      return e == C ? -1 : t == C ? 1 : i ? -1 : o ? 1 : u ? P(u, e) - P(u, t) : 0;
                                  if (i === o) return pe(e, t);
                                  n = e;
                                  while ((n = n.parentNode)) {
                                      a.unshift(n);
                                  }
                                  n = t;
                                  while ((n = n.parentNode)) {
                                      s.unshift(n);
                                  }
                                  while (a[r] === s[r]) {
                                      r++;
                                  }
                                  return r ? pe(a[r], s[r]) : a[r] == p ? -1 : s[r] == p ? 1 : 0;
                              })),
                    C
                );
            }),
        (se.matches = function (e, t) {
            return se(e, null, null, t);
        }),
        (se.matchesSelector = function (e, t) {
            if ((T(e), d.matchesSelector && E && !N[t + " "] && (!s || !s.test(t)) && (!v || !v.test(t))))
                try {
                    var n = c.call(e, t);
                    if (n || d.disconnectedMatch || (e.document && 11 !== e.document.nodeType)) return n;
                } catch (e) {
                    N(t, !0);
                }
            return 0 < se(t, C, null, [e]).length;
        }),
        (se.contains = function (e, t) {
            return (e.ownerDocument || e) != C && T(e), y(e, t);
        }),
        (se.attr = function (e, t) {
            (e.ownerDocument || e) != C && T(e);
            var n = b.attrHandle[t.toLowerCase()],
                r = n && j.call(b.attrHandle, t.toLowerCase()) ? n(e, t, !E) : void 0;
            return void 0 !== r
                ? r
                : d.attributes || !E
                  ? e.getAttribute(t)
                  : (r = e.getAttributeNode(t)) && r.specified
                    ? r.value
                    : null;
        }),
        (se.escape = function (e) {
            return (e + "").replace(re, ie);
        }),
        (se.error = function (e) {
            throw new Error("Syntax error, unrecognized expression: " + e);
        }),
        (se.uniqueSort = function (e) {
            var t,
                n = [],
                r = 0,
                i = 0;
            if (((l = !d.detectDuplicates), (u = !d.sortStable && e.slice(0)), e.sort(D), l)) {
                while ((t = e[i++])) {
                    t === e[i] && (r = n.push(i));
                }
                while (r--) {
                    e.splice(n[r], 1);
                }
            }
            return (u = null), e;
        }),
        (o = se.getText =
            function (e) {
                var t,
                    n = "",
                    r = 0,
                    i = e.nodeType;
                if (i) {
                    if (1 === i || 9 === i || 11 === i) {
                        if ("string" == typeof e.textContent) return e.textContent;
                        for (e = e.firstChild; e; e = e.nextSibling) {
                            n += o(e);
                        }
                    } else if (3 === i || 4 === i) return e.nodeValue;
                } else
                    while ((t = e[r++])) {
                        n += o(t);
                    }
                return n;
            }),
        ((b = se.selectors =
            {
                cacheLength: 50,
                createPseudo: le,
                match: G,
                attrHandle: {},
                find: {},
                relative: {
                    ">": { dir: "parentNode", first: !0 },
                    " ": { dir: "parentNode" },
                    "+": { dir: "previousSibling", first: !0 },
                    "~": { dir: "previousSibling" },
                },
                preFilter: {
                    ATTR: function ATTR(e) {
                        return (
                            (e[1] = e[1].replace(te, ne)),
                            (e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne)),
                            "~=" === e[2] && (e[3] = " " + e[3] + " "),
                            e.slice(0, 4)
                        );
                    },
                    CHILD: function CHILD(e) {
                        return (
                            (e[1] = e[1].toLowerCase()),
                            "nth" === e[1].slice(0, 3)
                                ? (e[3] || se.error(e[0]),
                                  (e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3]))),
                                  (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                                : e[3] && se.error(e[0]),
                            e
                        );
                    },
                    PSEUDO: function PSEUDO(e) {
                        var t,
                            n = !e[6] && e[2];
                        return G.CHILD.test(e[0])
                            ? null
                            : (e[3]
                                  ? (e[2] = e[4] || e[5] || "")
                                  : n &&
                                    X.test(n) &&
                                    (t = h(n, !0)) &&
                                    (t = n.indexOf(")", n.length - t) - n.length) &&
                                    ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                              e.slice(0, 3));
                    },
                },
                filter: {
                    TAG: function TAG(e) {
                        var t = e.replace(te, ne).toLowerCase();
                        return "*" === e
                            ? function () {
                                  return !0;
                              }
                            : function (e) {
                                  return e.nodeName && e.nodeName.toLowerCase() === t;
                              };
                    },
                    CLASS: function CLASS(e) {
                        var t = m[e + " "];
                        return (
                            t ||
                            ((t = new RegExp("(^|" + M + ")" + e + "(" + M + "|$)")) &&
                                m(e, function (e) {
                                    return t.test(
                                        ("string" == typeof e.className && e.className) ||
                                            ("undefined" != typeof e.getAttribute && e.getAttribute("class")) ||
                                            ""
                                    );
                                }))
                        );
                    },
                    ATTR: function ATTR(n, r, i) {
                        return function (e) {
                            var t = se.attr(e, n);
                            return null == t
                                ? "!=" === r
                                : !r ||
                                      ((t += ""),
                                      "=" === r
                                          ? t === i
                                          : "!=" === r
                                            ? t !== i
                                            : "^=" === r
                                              ? i && 0 === t.indexOf(i)
                                              : "*=" === r
                                                ? i && -1 < t.indexOf(i)
                                                : "$=" === r
                                                  ? i && t.slice(-i.length) === i
                                                  : "~=" === r
                                                    ? -1 < (" " + t.replace(B, " ") + " ").indexOf(i)
                                                    : "|=" === r && (t === i || t.slice(0, i.length + 1) === i + "-"));
                        };
                    },
                    CHILD: function CHILD(h, e, t, g, v) {
                        var y = "nth" !== h.slice(0, 3),
                            m = "last" !== h.slice(-4),
                            x = "of-type" === e;
                        return 1 === g && 0 === v
                            ? function (e) {
                                  return !!e.parentNode;
                              }
                            : function (e, t, n) {
                                  var r,
                                      i,
                                      o,
                                      a,
                                      s,
                                      u,
                                      l = y !== m ? "nextSibling" : "previousSibling",
                                      c = e.parentNode,
                                      f = x && e.nodeName.toLowerCase(),
                                      p = !n && !x,
                                      d = !1;
                                  if (c) {
                                      if (y) {
                                          while (l) {
                                              a = e;
                                              while ((a = a[l])) {
                                                  if (x ? a.nodeName.toLowerCase() === f : 1 === a.nodeType) return !1;
                                              }
                                              u = l = "only" === h && !u && "nextSibling";
                                          }
                                          return !0;
                                      }
                                      if (((u = [m ? c.firstChild : c.lastChild]), m && p)) {
                                          (d =
                                              (s =
                                                  (r =
                                                      (i =
                                                          (o = (a = c)[S] || (a[S] = {}))[a.uniqueID] ||
                                                          (o[a.uniqueID] = {}))[h] || [])[0] === k && r[1]) && r[2]),
                                              (a = s && c.childNodes[s]);
                                          while ((a = (++s && a && a[l]) || (d = s = 0) || u.pop())) {
                                              if (1 === a.nodeType && ++d && a === e) {
                                                  i[h] = [k, s, d];
                                                  break;
                                              }
                                          }
                                      } else if (
                                          (p &&
                                              (d = s =
                                                  (r =
                                                      (i =
                                                          (o = (a = e)[S] || (a[S] = {}))[a.uniqueID] ||
                                                          (o[a.uniqueID] = {}))[h] || [])[0] === k && r[1]),
                                          !1 === d)
                                      )
                                          while ((a = (++s && a && a[l]) || (d = s = 0) || u.pop())) {
                                              if (
                                                  (x ? a.nodeName.toLowerCase() === f : 1 === a.nodeType) &&
                                                  ++d &&
                                                  (p &&
                                                      ((i =
                                                          (o = a[S] || (a[S] = {}))[a.uniqueID] ||
                                                          (o[a.uniqueID] = {}))[h] = [k, d]),
                                                  a === e)
                                              )
                                                  break;
                                          }
                                      return (d -= v) === g || (d % g == 0 && 0 <= d / g);
                                  }
                              };
                    },
                    PSEUDO: function PSEUDO(e, o) {
                        var t,
                            a = b.pseudos[e] || b.setFilters[e.toLowerCase()] || se.error("unsupported pseudo: " + e);
                        return a[S]
                            ? a(o)
                            : 1 < a.length
                              ? ((t = [e, e, "", o]),
                                b.setFilters.hasOwnProperty(e.toLowerCase())
                                    ? le(function (e, t) {
                                          var n,
                                              r = a(e, o),
                                              i = r.length;
                                          while (i--) {
                                              e[(n = P(e, r[i]))] = !(t[n] = r[i]);
                                          }
                                      })
                                    : function (e) {
                                          return a(e, 0, t);
                                      })
                              : a;
                    },
                },
                pseudos: {
                    not: le(function (e) {
                        var r = [],
                            i = [],
                            s = f(e.replace($, "$1"));
                        return s[S]
                            ? le(function (e, t, n, r) {
                                  var i,
                                      o = s(e, null, r, []),
                                      a = e.length;
                                  while (a--) {
                                      (i = o[a]) && (e[a] = !(t[a] = i));
                                  }
                              })
                            : function (e, t, n) {
                                  return (r[0] = e), s(r, null, n, i), (r[0] = null), !i.pop();
                              };
                    }),
                    has: le(function (t) {
                        return function (e) {
                            return 0 < se(t, e).length;
                        };
                    }),
                    contains: le(function (t) {
                        return (
                            (t = t.replace(te, ne)),
                            function (e) {
                                return -1 < (e.textContent || o(e)).indexOf(t);
                            }
                        );
                    }),
                    lang: le(function (n) {
                        return (
                            V.test(n || "") || se.error("unsupported lang: " + n),
                            (n = n.replace(te, ne).toLowerCase()),
                            function (e) {
                                var t;
                                do {
                                    if ((t = E ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang")))
                                        return (t = t.toLowerCase()) === n || 0 === t.indexOf(n + "-");
                                } while ((e = e.parentNode) && 1 === e.nodeType);
                                return !1;
                            }
                        );
                    }),
                    target: function target(e) {
                        var t = n.location && n.location.hash;
                        return t && t.slice(1) === e.id;
                    },
                    root: function root(e) {
                        return e === a;
                    },
                    focus: function focus(e) {
                        return (
                            e === C.activeElement &&
                            (!C.hasFocus || C.hasFocus()) &&
                            !!(e.type || e.href || ~e.tabIndex)
                        );
                    },
                    enabled: ge(!1),
                    disabled: ge(!0),
                    checked: function checked(e) {
                        var t = e.nodeName.toLowerCase();
                        return ("input" === t && !!e.checked) || ("option" === t && !!e.selected);
                    },
                    selected: function selected(e) {
                        return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
                    },
                    empty: function empty(e) {
                        for (e = e.firstChild; e; e = e.nextSibling) {
                            if (e.nodeType < 6) return !1;
                        }
                        return !0;
                    },
                    parent: function parent(e) {
                        return !b.pseudos.empty(e);
                    },
                    header: function header(e) {
                        return J.test(e.nodeName);
                    },
                    input: function input(e) {
                        return Q.test(e.nodeName);
                    },
                    button: function button(e) {
                        var t = e.nodeName.toLowerCase();
                        return ("input" === t && "button" === e.type) || "button" === t;
                    },
                    text: function text(e) {
                        var t;
                        return (
                            "input" === e.nodeName.toLowerCase() &&
                            "text" === e.type &&
                            (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                        );
                    },
                    first: ve(function () {
                        return [0];
                    }),
                    last: ve(function (e, t) {
                        return [t - 1];
                    }),
                    eq: ve(function (e, t, n) {
                        return [n < 0 ? n + t : n];
                    }),
                    even: ve(function (e, t) {
                        for (var n = 0; n < t; n += 2) {
                            e.push(n);
                        }
                        return e;
                    }),
                    odd: ve(function (e, t) {
                        for (var n = 1; n < t; n += 2) {
                            e.push(n);
                        }
                        return e;
                    }),
                    lt: ve(function (e, t, n) {
                        for (var r = n < 0 ? n + t : t < n ? t : n; 0 <= --r; ) {
                            e.push(r);
                        }
                        return e;
                    }),
                    gt: ve(function (e, t, n) {
                        for (var r = n < 0 ? n + t : n; ++r < t; ) {
                            e.push(r);
                        }
                        return e;
                    }),
                },
            }).pseudos.nth = b.pseudos.eq),
        { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 })) {
            b.pseudos[e] = de(e);
        }
        for (e in { submit: !0, reset: !0 }) {
            b.pseudos[e] = he(e);
        }
        function me() {}
        function xe(e) {
            for (var t = 0, n = e.length, r = ""; t < n; t++) {
                r += e[t].value;
            }
            return r;
        }
        function be(s, e, t) {
            var u = e.dir,
                l = e.next,
                c = l || u,
                f = t && "parentNode" === c,
                p = r++;
            return e.first
                ? function (e, t, n) {
                      while ((e = e[u])) {
                          if (1 === e.nodeType || f) return s(e, t, n);
                      }
                      return !1;
                  }
                : function (e, t, n) {
                      var r,
                          i,
                          o,
                          a = [k, p];
                      if (n) {
                          while ((e = e[u])) {
                              if ((1 === e.nodeType || f) && s(e, t, n)) return !0;
                          }
                      } else
                          while ((e = e[u])) {
                              if (1 === e.nodeType || f)
                                  if (
                                      ((i = (o = e[S] || (e[S] = {}))[e.uniqueID] || (o[e.uniqueID] = {})),
                                      l && l === e.nodeName.toLowerCase())
                                  )
                                      e = e[u] || e;
                                  else {
                                      if ((r = i[c]) && r[0] === k && r[1] === p) return (a[2] = r[2]);
                                      if (((i[c] = a)[2] = s(e, t, n))) return !0;
                                  }
                          }
                      return !1;
                  };
        }
        function we(i) {
            return 1 < i.length
                ? function (e, t, n) {
                      var r = i.length;
                      while (r--) {
                          if (!i[r](e, t, n)) return !1;
                      }
                      return !0;
                  }
                : i[0];
        }
        function Te(e, t, n, r, i) {
            for (var o, a = [], s = 0, u = e.length, l = null != t; s < u; s++) {
                (o = e[s]) && ((n && !n(o, r, i)) || (a.push(o), l && t.push(s)));
            }
            return a;
        }
        function Ce(d, h, g, v, y, e) {
            return (
                v && !v[S] && (v = Ce(v)),
                y && !y[S] && (y = Ce(y, e)),
                le(function (e, t, n, r) {
                    var i,
                        o,
                        a,
                        s = [],
                        u = [],
                        l = t.length,
                        c =
                            e ||
                            (function (e, t, n) {
                                for (var r = 0, i = t.length; r < i; r++) {
                                    se(e, t[r], n);
                                }
                                return n;
                            })(h || "*", n.nodeType ? [n] : n, []),
                        f = !d || (!e && h) ? c : Te(c, s, d, n, r),
                        p = g ? (y || (e ? d : l || v) ? [] : t) : f;
                    if ((g && g(f, p, n, r), v)) {
                        (i = Te(p, u)), v(i, [], n, r), (o = i.length);
                        while (o--) {
                            (a = i[o]) && (p[u[o]] = !(f[u[o]] = a));
                        }
                    }
                    if (e) {
                        if (y || d) {
                            if (y) {
                                (i = []), (o = p.length);
                                while (o--) {
                                    (a = p[o]) && i.push((f[o] = a));
                                }
                                y(null, (p = []), i, r);
                            }
                            o = p.length;
                            while (o--) {
                                (a = p[o]) && -1 < (i = y ? P(e, a) : s[o]) && (e[i] = !(t[i] = a));
                            }
                        }
                    } else (p = Te(p === t ? p.splice(l, p.length) : p)), y ? y(null, t, p, r) : H.apply(t, p);
                })
            );
        }
        function Ee(e) {
            for (
                var i,
                    t,
                    n,
                    r = e.length,
                    o = b.relative[e[0].type],
                    a = o || b.relative[" "],
                    s = o ? 1 : 0,
                    u = be(
                        function (e) {
                            return e === i;
                        },
                        a,
                        !0
                    ),
                    l = be(
                        function (e) {
                            return -1 < P(i, e);
                        },
                        a,
                        !0
                    ),
                    c = [
                        function (e, t, n) {
                            var r = (!o && (n || t !== w)) || ((i = t).nodeType ? u(e, t, n) : l(e, t, n));
                            return (i = null), r;
                        },
                    ];
                s < r;
                s++
            ) {
                if ((t = b.relative[e[s].type])) c = [be(we(c), t)];
                else {
                    if ((t = b.filter[e[s].type].apply(null, e[s].matches))[S]) {
                        for (n = ++s; n < r; n++) {
                            if (b.relative[e[n].type]) break;
                        }
                        return Ce(
                            1 < s && we(c),
                            1 < s &&
                                xe(e.slice(0, s - 1).concat({ value: " " === e[s - 2].type ? "*" : "" })).replace(
                                    $,
                                    "$1"
                                ),
                            t,
                            s < n && Ee(e.slice(s, n)),
                            n < r && Ee((e = e.slice(n))),
                            n < r && xe(e)
                        );
                    }
                    c.push(t);
                }
            }
            return we(c);
        }
        return (
            (me.prototype = b.filters = b.pseudos),
            (b.setFilters = new me()),
            (h = se.tokenize =
                function (e, t) {
                    var n,
                        r,
                        i,
                        o,
                        a,
                        s,
                        u,
                        l = x[e + " "];
                    if (l) return t ? 0 : l.slice(0);
                    (a = e), (s = []), (u = b.preFilter);
                    while (a) {
                        for (o in ((n && !(r = _.exec(a))) || (r && (a = a.slice(r[0].length) || a), s.push((i = []))),
                        (n = !1),
                        (r = z.exec(a)) &&
                            ((n = r.shift()),
                            i.push({ value: n, type: r[0].replace($, " ") }),
                            (a = a.slice(n.length))),
                        b.filter)) {
                            !(r = G[o].exec(a)) ||
                                (u[o] && !(r = u[o](r))) ||
                                ((n = r.shift()), i.push({ value: n, type: o, matches: r }), (a = a.slice(n.length)));
                        }
                        if (!n) break;
                    }
                    return t ? a.length : a ? se.error(e) : x(e, s).slice(0);
                }),
            (f = se.compile =
                function (e, t) {
                    var n,
                        v,
                        y,
                        m,
                        x,
                        r,
                        i = [],
                        o = [],
                        a = A[e + " "];
                    if (!a) {
                        t || (t = h(e)), (n = t.length);
                        while (n--) {
                            (a = Ee(t[n]))[S] ? i.push(a) : o.push(a);
                        }
                        (a = A(
                            e,
                            ((v = o),
                            (m = 0 < (y = i).length),
                            (x = 0 < v.length),
                            (r = function r(e, t, n, _r, i) {
                                var o,
                                    a,
                                    s,
                                    u = 0,
                                    l = "0",
                                    c = e && [],
                                    f = [],
                                    p = w,
                                    d = e || (x && b.find.TAG("*", i)),
                                    h = (k += null == p ? 1 : Math.random() || 0.1),
                                    g = d.length;
                                for (i && (w = t == C || t || i); l !== g && null != (o = d[l]); l++) {
                                    if (x && o) {
                                        (a = 0), t || o.ownerDocument == C || (T(o), (n = !E));
                                        while ((s = v[a++])) {
                                            if (s(o, t || C, n)) {
                                                _r.push(o);
                                                break;
                                            }
                                        }
                                        i && (k = h);
                                    }
                                    m && ((o = !s && o) && u--, e && c.push(o));
                                }
                                if (((u += l), m && l !== u)) {
                                    a = 0;
                                    while ((s = y[a++])) {
                                        s(c, f, t, n);
                                    }
                                    if (e) {
                                        if (0 < u)
                                            while (l--) {
                                                c[l] || f[l] || (f[l] = q.call(_r));
                                            }
                                        f = Te(f);
                                    }
                                    H.apply(_r, f), i && !e && 0 < f.length && 1 < u + y.length && se.uniqueSort(_r);
                                }
                                return i && ((k = h), (w = p)), c;
                            }),
                            m ? le(r) : r)
                        )).selector = e;
                    }
                    return a;
                }),
            (g = se.select =
                function (e, t, n, r) {
                    var i,
                        o,
                        a,
                        s,
                        u,
                        l = "function" == typeof e && e,
                        c = !r && h((e = l.selector || e));
                    if (((n = n || []), 1 === c.length)) {
                        if (
                            2 < (o = c[0] = c[0].slice(0)).length &&
                            "ID" === (a = o[0]).type &&
                            9 === t.nodeType &&
                            E &&
                            b.relative[o[1].type]
                        ) {
                            if (!(t = (b.find.ID(a.matches[0].replace(te, ne), t) || [])[0])) return n;
                            l && (t = t.parentNode), (e = e.slice(o.shift().value.length));
                        }
                        i = G.needsContext.test(e) ? 0 : o.length;
                        while (i--) {
                            if (((a = o[i]), b.relative[(s = a.type)])) break;
                            if (
                                (u = b.find[s]) &&
                                (r = u(a.matches[0].replace(te, ne), (ee.test(o[0].type) && ye(t.parentNode)) || t))
                            ) {
                                if ((o.splice(i, 1), !(e = r.length && xe(o)))) return H.apply(n, r), n;
                                break;
                            }
                        }
                    }
                    return (l || f(e, c))(r, t, !E, n, !t || (ee.test(e) && ye(t.parentNode)) || t), n;
                }),
            (d.sortStable = S.split("").sort(D).join("") === S),
            (d.detectDuplicates = !!l),
            T(),
            (d.sortDetached = ce(function (e) {
                return 1 & e.compareDocumentPosition(C.createElement("fieldset"));
            })),
            ce(function (e) {
                return (e.innerHTML = "<a href='#'></a>"), "#" === e.firstChild.getAttribute("href");
            }) ||
                fe("type|href|height|width", function (e, t, n) {
                    if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
                }),
            (d.attributes &&
                ce(function (e) {
                    return (
                        (e.innerHTML = "<input/>"),
                        e.firstChild.setAttribute("value", ""),
                        "" === e.firstChild.getAttribute("value")
                    );
                })) ||
                fe("value", function (e, t, n) {
                    if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
                }),
            ce(function (e) {
                return null == e.getAttribute("disabled");
            }) ||
                fe(R, function (e, t, n) {
                    var r;
                    if (!n)
                        return !0 === e[t]
                            ? t.toLowerCase()
                            : (r = e.getAttributeNode(t)) && r.specified
                              ? r.value
                              : null;
                }),
            se
        );
    })(C);
    (S.find = d),
        (S.expr = d.selectors),
        (S.expr[":"] = S.expr.pseudos),
        (S.uniqueSort = S.unique = d.uniqueSort),
        (S.text = d.getText),
        (S.isXMLDoc = d.isXML),
        (S.contains = d.contains),
        (S.escapeSelector = d.escape);
    var h = function h(e, t, n) {
            var r = [],
                i = void 0 !== n;
            while ((e = e[t]) && 9 !== e.nodeType) {
                if (1 === e.nodeType) {
                    if (i && S(e).is(n)) break;
                    r.push(e);
                }
            }
            return r;
        },
        T = function T(e, t) {
            for (var n = []; e; e = e.nextSibling) {
                1 === e.nodeType && e !== t && n.push(e);
            }
            return n;
        },
        k = S.expr.match.needsContext;
    function A(e, t) {
        return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
    }
    var N = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function D(e, n, r) {
        return m(n)
            ? S.grep(e, function (e, t) {
                  return !!n.call(e, t, e) !== r;
              })
            : n.nodeType
              ? S.grep(e, function (e) {
                    return (e === n) !== r;
                })
              : "string" != typeof n
                ? S.grep(e, function (e) {
                      return -1 < i.call(n, e) !== r;
                  })
                : S.filter(n, e, r);
    }
    (S.filter = function (e, t, n) {
        var r = t[0];
        return (
            n && (e = ":not(" + e + ")"),
            1 === t.length && 1 === r.nodeType
                ? S.find.matchesSelector(r, e)
                    ? [r]
                    : []
                : S.find.matches(
                      e,
                      S.grep(t, function (e) {
                          return 1 === e.nodeType;
                      })
                  )
        );
    }),
        S.fn.extend({
            find: function find(e) {
                var t,
                    n,
                    r = this.length,
                    i = this;
                if ("string" != typeof e)
                    return this.pushStack(
                        S(e).filter(function () {
                            for (t = 0; t < r; t++) {
                                if (S.contains(i[t], this)) return !0;
                            }
                        })
                    );
                for (n = this.pushStack([]), t = 0; t < r; t++) {
                    S.find(e, i[t], n);
                }
                return 1 < r ? S.uniqueSort(n) : n;
            },
            filter: function filter(e) {
                return this.pushStack(D(this, e || [], !1));
            },
            not: function not(e) {
                return this.pushStack(D(this, e || [], !0));
            },
            is: function is(e) {
                return !!D(this, "string" == typeof e && k.test(e) ? S(e) : e || [], !1).length;
            },
        });
    var j,
        q = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    ((S.fn.init = function (e, t, n) {
        var r, i;
        if (!e) return this;
        if (((n = n || j), "string" == typeof e)) {
            if (
                !(r = "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length ? [null, e, null] : q.exec(e)) ||
                (!r[1] && t)
            )
                return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
            if (r[1]) {
                if (
                    ((t = t instanceof S ? t[0] : t),
                    S.merge(this, S.parseHTML(r[1], t && t.nodeType ? t.ownerDocument || t : E, !0)),
                    N.test(r[1]) && S.isPlainObject(t))
                )
                    for (r in t) {
                        m(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
                    }
                return this;
            }
            return (i = E.getElementById(r[2])) && ((this[0] = i), (this.length = 1)), this;
        }
        return e.nodeType
            ? ((this[0] = e), (this.length = 1), this)
            : m(e)
              ? void 0 !== n.ready
                  ? n.ready(e)
                  : e(S)
              : S.makeArray(e, this);
    }).prototype = S.fn),
        (j = S(E));
    var L = /^(?:parents|prev(?:Until|All))/,
        H = { children: !0, contents: !0, next: !0, prev: !0 };
    function O(e, t) {
        while ((e = e[t]) && 1 !== e.nodeType) {}
        return e;
    }
    S.fn.extend({
        has: function has(e) {
            var t = S(e, this),
                n = t.length;
            return this.filter(function () {
                for (var e = 0; e < n; e++) {
                    if (S.contains(this, t[e])) return !0;
                }
            });
        },
        closest: function closest(e, t) {
            var n,
                r = 0,
                i = this.length,
                o = [],
                a = "string" != typeof e && S(e);
            if (!k.test(e))
                for (; r < i; r++) {
                    for (n = this[r]; n && n !== t; n = n.parentNode) {
                        if (
                            n.nodeType < 11 &&
                            (a ? -1 < a.index(n) : 1 === n.nodeType && S.find.matchesSelector(n, e))
                        ) {
                            o.push(n);
                            break;
                        }
                    }
                }
            return this.pushStack(1 < o.length ? S.uniqueSort(o) : o);
        },
        index: function index(e) {
            return e
                ? "string" == typeof e
                    ? i.call(S(e), this[0])
                    : i.call(this, e.jquery ? e[0] : e)
                : this[0] && this[0].parentNode
                  ? this.first().prevAll().length
                  : -1;
        },
        add: function add(e, t) {
            return this.pushStack(S.uniqueSort(S.merge(this.get(), S(e, t))));
        },
        addBack: function addBack(e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
        },
    }),
        S.each(
            {
                parent: function parent(e) {
                    var t = e.parentNode;
                    return t && 11 !== t.nodeType ? t : null;
                },
                parents: function parents(e) {
                    return h(e, "parentNode");
                },
                parentsUntil: function parentsUntil(e, t, n) {
                    return h(e, "parentNode", n);
                },
                next: function next(e) {
                    return O(e, "nextSibling");
                },
                prev: function prev(e) {
                    return O(e, "previousSibling");
                },
                nextAll: function nextAll(e) {
                    return h(e, "nextSibling");
                },
                prevAll: function prevAll(e) {
                    return h(e, "previousSibling");
                },
                nextUntil: function nextUntil(e, t, n) {
                    return h(e, "nextSibling", n);
                },
                prevUntil: function prevUntil(e, t, n) {
                    return h(e, "previousSibling", n);
                },
                siblings: function siblings(e) {
                    return T((e.parentNode || {}).firstChild, e);
                },
                children: function children(e) {
                    return T(e.firstChild);
                },
                contents: function contents(e) {
                    return null != e.contentDocument && r(e.contentDocument)
                        ? e.contentDocument
                        : (A(e, "template") && (e = e.content || e), S.merge([], e.childNodes));
                },
            },
            function (r, i) {
                S.fn[r] = function (e, t) {
                    var n = S.map(this, i, e);
                    return (
                        "Until" !== r.slice(-5) && (t = e),
                        t && "string" == typeof t && (n = S.filter(t, n)),
                        1 < this.length && (H[r] || S.uniqueSort(n), L.test(r) && n.reverse()),
                        this.pushStack(n)
                    );
                };
            }
        );
    var P = /[^\x20\t\r\n\f]+/g;
    function R(e) {
        return e;
    }
    function M(e) {
        throw e;
    }
    function I(e, t, n, r) {
        var i;
        try {
            e && m((i = e.promise))
                ? i.call(e).done(t).fail(n)
                : e && m((i = e.then))
                  ? i.call(e, t, n)
                  : t.apply(void 0, [e].slice(r));
        } catch (e) {
            n.apply(void 0, [e]);
        }
    }
    (S.Callbacks = function (r) {
        var e, n;
        r =
            "string" == typeof r
                ? ((e = r),
                  (n = {}),
                  S.each(e.match(P) || [], function (e, t) {
                      n[t] = !0;
                  }),
                  n)
                : S.extend({}, r);
        var i,
            t,
            o,
            a,
            s = [],
            u = [],
            l = -1,
            c = function c() {
                for (a = a || r.once, o = i = !0; u.length; l = -1) {
                    t = u.shift();
                    while (++l < s.length) {
                        !1 === s[l].apply(t[0], t[1]) && r.stopOnFalse && ((l = s.length), (t = !1));
                    }
                }
                r.memory || (t = !1), (i = !1), a && (s = t ? [] : "");
            },
            f = {
                add: function add() {
                    return (
                        s &&
                            (t && !i && ((l = s.length - 1), u.push(t)),
                            (function n(e) {
                                S.each(e, function (e, t) {
                                    m(t)
                                        ? (r.unique && f.has(t)) || s.push(t)
                                        : t && t.length && "string" !== w(t) && n(t);
                                });
                            })(arguments),
                            t && !i && c()),
                        this
                    );
                },
                remove: function remove() {
                    return (
                        S.each(arguments, function (e, t) {
                            var n;
                            while (-1 < (n = S.inArray(t, s, n))) {
                                s.splice(n, 1), n <= l && l--;
                            }
                        }),
                        this
                    );
                },
                has: function has(e) {
                    return e ? -1 < S.inArray(e, s) : 0 < s.length;
                },
                empty: function empty() {
                    return s && (s = []), this;
                },
                disable: function disable() {
                    return (a = u = []), (s = t = ""), this;
                },
                disabled: function disabled() {
                    return !s;
                },
                lock: function lock() {
                    return (a = u = []), t || i || (s = t = ""), this;
                },
                locked: function locked() {
                    return !!a;
                },
                fireWith: function fireWith(e, t) {
                    return a || ((t = [e, (t = t || []).slice ? t.slice() : t]), u.push(t), i || c()), this;
                },
                fire: function fire() {
                    return f.fireWith(this, arguments), this;
                },
                fired: function fired() {
                    return !!o;
                },
            };
        return f;
    }),
        S.extend({
            Deferred: function Deferred(e) {
                var o = [
                        ["notify", "progress", S.Callbacks("memory"), S.Callbacks("memory"), 2],
                        ["resolve", "done", S.Callbacks("once memory"), S.Callbacks("once memory"), 0, "resolved"],
                        ["reject", "fail", S.Callbacks("once memory"), S.Callbacks("once memory"), 1, "rejected"],
                    ],
                    i = "pending",
                    a = {
                        state: function state() {
                            return i;
                        },
                        always: function always() {
                            return s.done(arguments).fail(arguments), this;
                        },
                        catch: function _catch(e) {
                            return a.then(null, e);
                        },
                        pipe: function pipe() {
                            var i = arguments;
                            return S.Deferred(function (r) {
                                S.each(o, function (e, t) {
                                    var n = m(i[t[4]]) && i[t[4]];
                                    s[t[1]](function () {
                                        var e = n && n.apply(this, arguments);
                                        e && m(e.promise)
                                            ? e.promise().progress(r.notify).done(r.resolve).fail(r.reject)
                                            : r[t[0] + "With"](this, n ? [e] : arguments);
                                    });
                                }),
                                    (i = null);
                            }).promise();
                        },
                        then: function then(t, n, r) {
                            var u = 0;
                            function l(i, o, a, s) {
                                return function () {
                                    var n = this,
                                        r = arguments,
                                        e = function e() {
                                            var e, t;
                                            if (!(i < u)) {
                                                if ((e = a.apply(n, r)) === o.promise())
                                                    throw new TypeError("Thenable self-resolution");
                                                (t = e && ("object" == _typeof(e) || "function" == typeof e) && e.then),
                                                    m(t)
                                                        ? s
                                                            ? t.call(e, l(u, o, R, s), l(u, o, M, s))
                                                            : (u++,
                                                              t.call(
                                                                  e,
                                                                  l(u, o, R, s),
                                                                  l(u, o, M, s),
                                                                  l(u, o, R, o.notifyWith)
                                                              ))
                                                        : (a !== R && ((n = void 0), (r = [e])),
                                                          (s || o.resolveWith)(n, r));
                                            }
                                        },
                                        t = s
                                            ? e
                                            : function () {
                                                  try {
                                                      e();
                                                  } catch (e) {
                                                      S.Deferred.exceptionHook &&
                                                          S.Deferred.exceptionHook(e, t.stackTrace),
                                                          u <= i + 1 &&
                                                              (a !== M && ((n = void 0), (r = [e])),
                                                              o.rejectWith(n, r));
                                                  }
                                              };
                                    i
                                        ? t()
                                        : (S.Deferred.getStackHook && (t.stackTrace = S.Deferred.getStackHook()),
                                          C.setTimeout(t));
                                };
                            }
                            return S.Deferred(function (e) {
                                o[0][3].add(l(0, e, m(r) ? r : R, e.notifyWith)),
                                    o[1][3].add(l(0, e, m(t) ? t : R)),
                                    o[2][3].add(l(0, e, m(n) ? n : M));
                            }).promise();
                        },
                        promise: function promise(e) {
                            return null != e ? S.extend(e, a) : a;
                        },
                    },
                    s = {};
                return (
                    S.each(o, function (e, t) {
                        var n = t[2],
                            r = t[5];
                        (a[t[1]] = n.add),
                            r &&
                                n.add(
                                    function () {
                                        i = r;
                                    },
                                    o[3 - e][2].disable,
                                    o[3 - e][3].disable,
                                    o[0][2].lock,
                                    o[0][3].lock
                                ),
                            n.add(t[3].fire),
                            (s[t[0]] = function () {
                                return s[t[0] + "With"](this === s ? void 0 : this, arguments), this;
                            }),
                            (s[t[0] + "With"] = n.fireWith);
                    }),
                    a.promise(s),
                    e && e.call(s, s),
                    s
                );
            },
            when: function when(e) {
                var n = arguments.length,
                    t = n,
                    r = Array(t),
                    i = s.call(arguments),
                    o = S.Deferred(),
                    a = function a(t) {
                        return function (e) {
                            (r[t] = this),
                                (i[t] = 1 < arguments.length ? s.call(arguments) : e),
                                --n || o.resolveWith(r, i);
                        };
                    };
                if (
                    n <= 1 &&
                    (I(e, o.done(a(t)).resolve, o.reject, !n), "pending" === o.state() || m(i[t] && i[t].then))
                )
                    return o.then();
                while (t--) {
                    I(i[t], a(t), o.reject);
                }
                return o.promise();
            },
        });
    var W = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    (S.Deferred.exceptionHook = function (e, t) {
        C.console &&
            C.console.warn &&
            e &&
            W.test(e.name) &&
            C.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t);
    }),
        (S.readyException = function (e) {
            C.setTimeout(function () {
                throw e;
            });
        });
    var F = S.Deferred();
    function B() {
        E.removeEventListener("DOMContentLoaded", B), C.removeEventListener("load", B), S.ready();
    }
    (S.fn.ready = function (e) {
        return (
            F.then(e)["catch"](function (e) {
                S.readyException(e);
            }),
            this
        );
    }),
        S.extend({
            isReady: !1,
            readyWait: 1,
            ready: function ready(e) {
                (!0 === e ? --S.readyWait : S.isReady) ||
                    ((S.isReady = !0) !== e && 0 < --S.readyWait) ||
                    F.resolveWith(E, [S]);
            },
        }),
        (S.ready.then = F.then),
        "complete" === E.readyState || ("loading" !== E.readyState && !E.documentElement.doScroll)
            ? C.setTimeout(S.ready)
            : (E.addEventListener("DOMContentLoaded", B), C.addEventListener("load", B));
    var $ = function $(e, t, n, r, i, o, a) {
            var s = 0,
                u = e.length,
                l = null == n;
            if ("object" === w(n))
                for (s in ((i = !0), n)) {
                    $(e, t, s, n[s], !0, o, a);
                }
            else if (
                void 0 !== r &&
                ((i = !0),
                m(r) || (a = !0),
                l &&
                    (a
                        ? (t.call(e, r), (t = null))
                        : ((l = t),
                          (t = function t(e, _t2, n) {
                              return l.call(S(e), n);
                          }))),
                t)
            )
                for (; s < u; s++) {
                    t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
                }
            return i ? e : l ? t.call(e) : u ? t(e[0], n) : o;
        },
        _ = /^-ms-/,
        z = /-([a-z])/g;
    function U(e, t) {
        return t.toUpperCase();
    }
    function X(e) {
        return e.replace(_, "ms-").replace(z, U);
    }
    var V = function V(e) {
        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
    };
    function G() {
        this.expando = S.expando + G.uid++;
    }
    (G.uid = 1),
        (G.prototype = {
            cache: function cache(e) {
                var t = e[this.expando];
                return (
                    t ||
                        ((t = {}),
                        V(e) &&
                            (e.nodeType
                                ? (e[this.expando] = t)
                                : Object.defineProperty(e, this.expando, { value: t, configurable: !0 }))),
                    t
                );
            },
            set: function set(e, t, n) {
                var r,
                    i = this.cache(e);
                if ("string" == typeof t) i[X(t)] = n;
                else
                    for (r in t) {
                        i[X(r)] = t[r];
                    }
                return i;
            },
            get: function get(e, t) {
                return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][X(t)];
            },
            access: function access(e, t, n) {
                return void 0 === t || (t && "string" == typeof t && void 0 === n)
                    ? this.get(e, t)
                    : (this.set(e, t, n), void 0 !== n ? n : t);
            },
            remove: function remove(e, t) {
                var n,
                    r = e[this.expando];
                if (void 0 !== r) {
                    if (void 0 !== t) {
                        n = (t = Array.isArray(t) ? t.map(X) : (t = X(t)) in r ? [t] : t.match(P) || []).length;
                        while (n--) {
                            delete r[t[n]];
                        }
                    }
                    (void 0 === t || S.isEmptyObject(r)) &&
                        (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
                }
            },
            hasData: function hasData(e) {
                var t = e[this.expando];
                return void 0 !== t && !S.isEmptyObject(t);
            },
        });
    var Y = new G(),
        Q = new G(),
        J = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        K = /[A-Z]/g;
    function Z(e, t, n) {
        var r, i;
        if (void 0 === n && 1 === e.nodeType)
            if (((r = "data-" + t.replace(K, "-$&").toLowerCase()), "string" == typeof (n = e.getAttribute(r)))) {
                try {
                    n =
                        "true" === (i = n) ||
                        ("false" !== i && ("null" === i ? null : i === +i + "" ? +i : J.test(i) ? JSON.parse(i) : i));
                } catch (e) {}
                Q.set(e, t, n);
            } else n = void 0;
        return n;
    }
    S.extend({
        hasData: function hasData(e) {
            return Q.hasData(e) || Y.hasData(e);
        },
        data: function data(e, t, n) {
            return Q.access(e, t, n);
        },
        removeData: function removeData(e, t) {
            Q.remove(e, t);
        },
        _data: function _data(e, t, n) {
            return Y.access(e, t, n);
        },
        _removeData: function _removeData(e, t) {
            Y.remove(e, t);
        },
    }),
        S.fn.extend({
            data: function data(n, e) {
                var t,
                    r,
                    i,
                    o = this[0],
                    a = o && o.attributes;
                if (void 0 === n) {
                    if (this.length && ((i = Q.get(o)), 1 === o.nodeType && !Y.get(o, "hasDataAttrs"))) {
                        t = a.length;
                        while (t--) {
                            a[t] && 0 === (r = a[t].name).indexOf("data-") && ((r = X(r.slice(5))), Z(o, r, i[r]));
                        }
                        Y.set(o, "hasDataAttrs", !0);
                    }
                    return i;
                }
                return "object" == _typeof(n)
                    ? this.each(function () {
                          Q.set(this, n);
                      })
                    : $(
                          this,
                          function (e) {
                              var t;
                              if (o && void 0 === e)
                                  return void 0 !== (t = Q.get(o, n)) ? t : void 0 !== (t = Z(o, n)) ? t : void 0;
                              this.each(function () {
                                  Q.set(this, n, e);
                              });
                          },
                          null,
                          e,
                          1 < arguments.length,
                          null,
                          !0
                      );
            },
            removeData: function removeData(e) {
                return this.each(function () {
                    Q.remove(this, e);
                });
            },
        }),
        S.extend({
            queue: function queue(e, t, n) {
                var r;
                if (e)
                    return (
                        (t = (t || "fx") + "queue"),
                        (r = Y.get(e, t)),
                        n && (!r || Array.isArray(n) ? (r = Y.access(e, t, S.makeArray(n))) : r.push(n)),
                        r || []
                    );
            },
            dequeue: function dequeue(e, t) {
                t = t || "fx";
                var n = S.queue(e, t),
                    r = n.length,
                    i = n.shift(),
                    o = S._queueHooks(e, t);
                "inprogress" === i && ((i = n.shift()), r--),
                    i &&
                        ("fx" === t && n.unshift("inprogress"),
                        delete o.stop,
                        i.call(
                            e,
                            function () {
                                S.dequeue(e, t);
                            },
                            o
                        )),
                    !r && o && o.empty.fire();
            },
            _queueHooks: function _queueHooks(e, t) {
                var n = t + "queueHooks";
                return (
                    Y.get(e, n) ||
                    Y.access(e, n, {
                        empty: S.Callbacks("once memory").add(function () {
                            Y.remove(e, [t + "queue", n]);
                        }),
                    })
                );
            },
        }),
        S.fn.extend({
            queue: function queue(t, n) {
                var e = 2;
                return (
                    "string" != typeof t && ((n = t), (t = "fx"), e--),
                    arguments.length < e
                        ? S.queue(this[0], t)
                        : void 0 === n
                          ? this
                          : this.each(function () {
                                var e = S.queue(this, t, n);
                                S._queueHooks(this, t), "fx" === t && "inprogress" !== e[0] && S.dequeue(this, t);
                            })
                );
            },
            dequeue: function dequeue(e) {
                return this.each(function () {
                    S.dequeue(this, e);
                });
            },
            clearQueue: function clearQueue(e) {
                return this.queue(e || "fx", []);
            },
            promise: function promise(e, t) {
                var n,
                    r = 1,
                    i = S.Deferred(),
                    o = this,
                    a = this.length,
                    s = function s() {
                        --r || i.resolveWith(o, [o]);
                    };
                "string" != typeof e && ((t = e), (e = void 0)), (e = e || "fx");
                while (a--) {
                    (n = Y.get(o[a], e + "queueHooks")) && n.empty && (r++, n.empty.add(s));
                }
                return s(), i.promise(t);
            },
        });
    var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        te = new RegExp("^(?:([+-])=|)(" + ee + ")([a-z%]*)$", "i"),
        ne = ["Top", "Right", "Bottom", "Left"],
        re = E.documentElement,
        ie = function ie(e) {
            return S.contains(e.ownerDocument, e);
        },
        oe = { composed: !0 };
    re.getRootNode &&
        (ie = function ie(e) {
            return S.contains(e.ownerDocument, e) || e.getRootNode(oe) === e.ownerDocument;
        });
    var ae = function ae(e, t) {
        return (
            "none" === (e = t || e).style.display || ("" === e.style.display && ie(e) && "none" === S.css(e, "display"))
        );
    };
    function se(e, t, n, r) {
        var i,
            o,
            a = 20,
            s = r
                ? function () {
                      return r.cur();
                  }
                : function () {
                      return S.css(e, t, "");
                  },
            u = s(),
            l = (n && n[3]) || (S.cssNumber[t] ? "" : "px"),
            c = e.nodeType && (S.cssNumber[t] || ("px" !== l && +u)) && te.exec(S.css(e, t));
        if (c && c[3] !== l) {
            (u /= 2), (l = l || c[3]), (c = +u || 1);
            while (a--) {
                S.style(e, t, c + l), (1 - o) * (1 - (o = s() / u || 0.5)) <= 0 && (a = 0), (c /= o);
            }
            (c *= 2), S.style(e, t, c + l), (n = n || []);
        }
        return (
            n &&
                ((c = +c || +u || 0),
                (i = n[1] ? c + (n[1] + 1) * n[2] : +n[2]),
                r && ((r.unit = l), (r.start = c), (r.end = i))),
            i
        );
    }
    var ue = {};
    function le(e, t) {
        for (var n, r, i, o, a, s, u, l = [], c = 0, f = e.length; c < f; c++) {
            (r = e[c]).style &&
                ((n = r.style.display),
                t
                    ? ("none" === n && ((l[c] = Y.get(r, "display") || null), l[c] || (r.style.display = "")),
                      "" === r.style.display &&
                          ae(r) &&
                          (l[c] =
                              ((u = a = o = void 0),
                              (a = (i = r).ownerDocument),
                              (s = i.nodeName),
                              (u = ue[s]) ||
                                  ((o = a.body.appendChild(a.createElement(s))),
                                  (u = S.css(o, "display")),
                                  o.parentNode.removeChild(o),
                                  "none" === u && (u = "block"),
                                  (ue[s] = u)))))
                    : "none" !== n && ((l[c] = "none"), Y.set(r, "display", n)));
        }
        for (c = 0; c < f; c++) {
            null != l[c] && (e[c].style.display = l[c]);
        }
        return e;
    }
    S.fn.extend({
        show: function show() {
            return le(this, !0);
        },
        hide: function hide() {
            return le(this);
        },
        toggle: function toggle(e) {
            return "boolean" == typeof e
                ? e
                    ? this.show()
                    : this.hide()
                : this.each(function () {
                      ae(this) ? S(this).show() : S(this).hide();
                  });
        },
    });
    var ce,
        fe,
        pe = /^(?:checkbox|radio)$/i,
        de = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
        he = /^$|^module$|\/(?:java|ecma)script/i;
    (ce = E.createDocumentFragment().appendChild(E.createElement("div"))),
        (fe = E.createElement("input")).setAttribute("type", "radio"),
        fe.setAttribute("checked", "checked"),
        fe.setAttribute("name", "t"),
        ce.appendChild(fe),
        (y.checkClone = ce.cloneNode(!0).cloneNode(!0).lastChild.checked),
        (ce.innerHTML = "<textarea>x</textarea>"),
        (y.noCloneChecked = !!ce.cloneNode(!0).lastChild.defaultValue),
        (ce.innerHTML = "<option></option>"),
        (y.option = !!ce.lastChild);
    var ge = {
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""],
    };
    function ve(e, t) {
        var n;
        return (
            (n =
                "undefined" != typeof e.getElementsByTagName
                    ? e.getElementsByTagName(t || "*")
                    : "undefined" != typeof e.querySelectorAll
                      ? e.querySelectorAll(t || "*")
                      : []),
            void 0 === t || (t && A(e, t)) ? S.merge([e], n) : n
        );
    }
    function ye(e, t) {
        for (var n = 0, r = e.length; n < r; n++) {
            Y.set(e[n], "globalEval", !t || Y.get(t[n], "globalEval"));
        }
    }
    (ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead),
        (ge.th = ge.td),
        y.option || (ge.optgroup = ge.option = [1, "<select multiple='multiple'>", "</select>"]);
    var me = /<|&#?\w+;/;
    function xe(e, t, n, r, i) {
        for (var o, a, s, u, l, c, f = t.createDocumentFragment(), p = [], d = 0, h = e.length; d < h; d++) {
            if ((o = e[d]) || 0 === o)
                if ("object" === w(o)) S.merge(p, o.nodeType ? [o] : o);
                else if (me.test(o)) {
                    (a = a || f.appendChild(t.createElement("div"))),
                        (s = (de.exec(o) || ["", ""])[1].toLowerCase()),
                        (u = ge[s] || ge._default),
                        (a.innerHTML = u[1] + S.htmlPrefilter(o) + u[2]),
                        (c = u[0]);
                    while (c--) {
                        a = a.lastChild;
                    }
                    S.merge(p, a.childNodes), ((a = f.firstChild).textContent = "");
                } else p.push(t.createTextNode(o));
        }
        (f.textContent = ""), (d = 0);
        while ((o = p[d++])) {
            if (r && -1 < S.inArray(o, r)) i && i.push(o);
            else if (((l = ie(o)), (a = ve(f.appendChild(o), "script")), l && ye(a), n)) {
                c = 0;
                while ((o = a[c++])) {
                    he.test(o.type || "") && n.push(o);
                }
            }
        }
        return f;
    }
    var be = /^key/,
        we = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        Te = /^([^.]*)(?:\.(.+)|)/;
    function Ce() {
        return !0;
    }
    function Ee() {
        return !1;
    }
    function Se(e, t) {
        return (
            (e ===
                (function () {
                    try {
                        return E.activeElement;
                    } catch (e) {}
                })()) ==
            ("focus" === t)
        );
    }
    function ke(e, t, n, r, i, o) {
        var a, s;
        if ("object" == _typeof(t)) {
            for (s in ("string" != typeof n && ((r = r || n), (n = void 0)), t)) {
                ke(e, s, n, r, t[s], o);
            }
            return e;
        }
        if (
            (null == r && null == i
                ? ((i = n), (r = n = void 0))
                : null == i && ("string" == typeof n ? ((i = r), (r = void 0)) : ((i = r), (r = n), (n = void 0))),
            !1 === i)
        )
            i = Ee;
        else if (!i) return e;
        return (
            1 === o &&
                ((a = i),
                ((i = function i(e) {
                    return S().off(e), a.apply(this, arguments);
                }).guid = a.guid || (a.guid = S.guid++))),
            e.each(function () {
                S.event.add(this, t, i, r, n);
            })
        );
    }
    function Ae(e, i, o) {
        o
            ? (Y.set(e, i, !1),
              S.event.add(e, i, {
                  namespace: !1,
                  handler: function handler(e) {
                      var t,
                          n,
                          r = Y.get(this, i);
                      if (1 & e.isTrigger && this[i]) {
                          if (r.length) (S.event.special[i] || {}).delegateType && e.stopPropagation();
                          else if (
                              ((r = s.call(arguments)),
                              Y.set(this, i, r),
                              (t = o(this, i)),
                              this[i](),
                              r !== (n = Y.get(this, i)) || t ? Y.set(this, i, !1) : (n = {}),
                              r !== n)
                          )
                              return e.stopImmediatePropagation(), e.preventDefault(), n.value;
                      } else
                          r.length &&
                              (Y.set(this, i, {
                                  value: S.event.trigger(S.extend(r[0], S.Event.prototype), r.slice(1), this),
                              }),
                              e.stopImmediatePropagation());
                  },
              }))
            : void 0 === Y.get(e, i) && S.event.add(e, i, Ce);
    }
    (S.event = {
        global: {},
        add: function add(t, e, n, r, i) {
            var o,
                a,
                s,
                u,
                l,
                c,
                f,
                p,
                d,
                h,
                g,
                v = Y.get(t);
            if (V(t)) {
                n.handler && ((n = (o = n).handler), (i = o.selector)),
                    i && S.find.matchesSelector(re, i),
                    n.guid || (n.guid = S.guid++),
                    (u = v.events) || (u = v.events = Object.create(null)),
                    (a = v.handle) ||
                        (a = v.handle =
                            function (e) {
                                return "undefined" != typeof S && S.event.triggered !== e.type
                                    ? S.event.dispatch.apply(t, arguments)
                                    : void 0;
                            }),
                    (l = (e = (e || "").match(P) || [""]).length);
                while (l--) {
                    (d = g = (s = Te.exec(e[l]) || [])[1]),
                        (h = (s[2] || "").split(".").sort()),
                        d &&
                            ((f = S.event.special[d] || {}),
                            (d = (i ? f.delegateType : f.bindType) || d),
                            (f = S.event.special[d] || {}),
                            (c = S.extend(
                                {
                                    type: d,
                                    origType: g,
                                    data: r,
                                    handler: n,
                                    guid: n.guid,
                                    selector: i,
                                    needsContext: i && S.expr.match.needsContext.test(i),
                                    namespace: h.join("."),
                                },
                                o
                            )),
                            (p = u[d]) ||
                                (((p = u[d] = []).delegateCount = 0),
                                (f.setup && !1 !== f.setup.call(t, r, h, a)) ||
                                    (t.addEventListener && t.addEventListener(d, a))),
                            f.add && (f.add.call(t, c), c.handler.guid || (c.handler.guid = n.guid)),
                            i ? p.splice(p.delegateCount++, 0, c) : p.push(c),
                            (S.event.global[d] = !0));
                }
            }
        },
        remove: function remove(e, t, n, r, i) {
            var o,
                a,
                s,
                u,
                l,
                c,
                f,
                p,
                d,
                h,
                g,
                v = Y.hasData(e) && Y.get(e);
            if (v && (u = v.events)) {
                l = (t = (t || "").match(P) || [""]).length;
                while (l--) {
                    if (((d = g = (s = Te.exec(t[l]) || [])[1]), (h = (s[2] || "").split(".").sort()), d)) {
                        (f = S.event.special[d] || {}),
                            (p = u[(d = (r ? f.delegateType : f.bindType) || d)] || []),
                            (s = s[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)")),
                            (a = o = p.length);
                        while (o--) {
                            (c = p[o]),
                                (!i && g !== c.origType) ||
                                    (n && n.guid !== c.guid) ||
                                    (s && !s.test(c.namespace)) ||
                                    (r && r !== c.selector && ("**" !== r || !c.selector)) ||
                                    (p.splice(o, 1), c.selector && p.delegateCount--, f.remove && f.remove.call(e, c));
                        }
                        a &&
                            !p.length &&
                            ((f.teardown && !1 !== f.teardown.call(e, h, v.handle)) || S.removeEvent(e, d, v.handle),
                            delete u[d]);
                    } else
                        for (d in u) {
                            S.event.remove(e, d + t[l], n, r, !0);
                        }
                }
                S.isEmptyObject(u) && Y.remove(e, "handle events");
            }
        },
        dispatch: function dispatch(e) {
            var t,
                n,
                r,
                i,
                o,
                a,
                s = new Array(arguments.length),
                u = S.event.fix(e),
                l = (Y.get(this, "events") || Object.create(null))[u.type] || [],
                c = S.event.special[u.type] || {};
            for (s[0] = u, t = 1; t < arguments.length; t++) {
                s[t] = arguments[t];
            }
            if (((u.delegateTarget = this), !c.preDispatch || !1 !== c.preDispatch.call(this, u))) {
                (a = S.event.handlers.call(this, u, l)), (t = 0);
                while ((i = a[t++]) && !u.isPropagationStopped()) {
                    (u.currentTarget = i.elem), (n = 0);
                    while ((o = i.handlers[n++]) && !u.isImmediatePropagationStopped()) {
                        (u.rnamespace && !1 !== o.namespace && !u.rnamespace.test(o.namespace)) ||
                            ((u.handleObj = o),
                            (u.data = o.data),
                            void 0 !==
                                (r = ((S.event.special[o.origType] || {}).handle || o.handler).apply(i.elem, s)) &&
                                !1 === (u.result = r) &&
                                (u.preventDefault(), u.stopPropagation()));
                    }
                }
                return c.postDispatch && c.postDispatch.call(this, u), u.result;
            }
        },
        handlers: function handlers(e, t) {
            var n,
                r,
                i,
                o,
                a,
                s = [],
                u = t.delegateCount,
                l = e.target;
            if (u && l.nodeType && !("click" === e.type && 1 <= e.button))
                for (; l !== this; l = l.parentNode || this) {
                    if (1 === l.nodeType && ("click" !== e.type || !0 !== l.disabled)) {
                        for (o = [], a = {}, n = 0; n < u; n++) {
                            void 0 === a[(i = (r = t[n]).selector + " ")] &&
                                (a[i] = r.needsContext ? -1 < S(i, this).index(l) : S.find(i, this, null, [l]).length),
                                a[i] && o.push(r);
                        }
                        o.length && s.push({ elem: l, handlers: o });
                    }
                }
            return (l = this), u < t.length && s.push({ elem: l, handlers: t.slice(u) }), s;
        },
        addProp: function addProp(t, e) {
            Object.defineProperty(S.Event.prototype, t, {
                enumerable: !0,
                configurable: !0,
                get: m(e)
                    ? function () {
                          if (this.originalEvent) return e(this.originalEvent);
                      }
                    : function () {
                          if (this.originalEvent) return this.originalEvent[t];
                      },
                set: function set(e) {
                    Object.defineProperty(this, t, { enumerable: !0, configurable: !0, writable: !0, value: e });
                },
            });
        },
        fix: function fix(e) {
            return e[S.expando] ? e : new S.Event(e);
        },
        special: {
            load: { noBubble: !0 },
            click: {
                setup: function setup(e) {
                    var t = this || e;
                    return pe.test(t.type) && t.click && A(t, "input") && Ae(t, "click", Ce), !1;
                },
                trigger: function trigger(e) {
                    var t = this || e;
                    return pe.test(t.type) && t.click && A(t, "input") && Ae(t, "click"), !0;
                },
                _default: function _default(e) {
                    var t = e.target;
                    return (pe.test(t.type) && t.click && A(t, "input") && Y.get(t, "click")) || A(t, "a");
                },
            },
            beforeunload: {
                postDispatch: function postDispatch(e) {
                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
                },
            },
        },
    }),
        (S.removeEvent = function (e, t, n) {
            e.removeEventListener && e.removeEventListener(t, n);
        }),
        (S.Event = function (e, t) {
            if (!(this instanceof S.Event)) return new S.Event(e, t);
            e && e.type
                ? ((this.originalEvent = e),
                  (this.type = e.type),
                  (this.isDefaultPrevented =
                      e.defaultPrevented || (void 0 === e.defaultPrevented && !1 === e.returnValue) ? Ce : Ee),
                  (this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target),
                  (this.currentTarget = e.currentTarget),
                  (this.relatedTarget = e.relatedTarget))
                : (this.type = e),
                t && S.extend(this, t),
                (this.timeStamp = (e && e.timeStamp) || Date.now()),
                (this[S.expando] = !0);
        }),
        (S.Event.prototype = {
            constructor: S.Event,
            isDefaultPrevented: Ee,
            isPropagationStopped: Ee,
            isImmediatePropagationStopped: Ee,
            isSimulated: !1,
            preventDefault: function preventDefault() {
                var e = this.originalEvent;
                (this.isDefaultPrevented = Ce), e && !this.isSimulated && e.preventDefault();
            },
            stopPropagation: function stopPropagation() {
                var e = this.originalEvent;
                (this.isPropagationStopped = Ce), e && !this.isSimulated && e.stopPropagation();
            },
            stopImmediatePropagation: function stopImmediatePropagation() {
                var e = this.originalEvent;
                (this.isImmediatePropagationStopped = Ce),
                    e && !this.isSimulated && e.stopImmediatePropagation(),
                    this.stopPropagation();
            },
        }),
        S.each(
            {
                altKey: !0,
                bubbles: !0,
                cancelable: !0,
                changedTouches: !0,
                ctrlKey: !0,
                detail: !0,
                eventPhase: !0,
                metaKey: !0,
                pageX: !0,
                pageY: !0,
                shiftKey: !0,
                view: !0,
                char: !0,
                code: !0,
                charCode: !0,
                key: !0,
                keyCode: !0,
                button: !0,
                buttons: !0,
                clientX: !0,
                clientY: !0,
                offsetX: !0,
                offsetY: !0,
                pointerId: !0,
                pointerType: !0,
                screenX: !0,
                screenY: !0,
                targetTouches: !0,
                toElement: !0,
                touches: !0,
                which: function which(e) {
                    var t = e.button;
                    return null == e.which && be.test(e.type)
                        ? null != e.charCode
                            ? e.charCode
                            : e.keyCode
                        : !e.which && void 0 !== t && we.test(e.type)
                          ? 1 & t
                              ? 1
                              : 2 & t
                                ? 3
                                : 4 & t
                                  ? 2
                                  : 0
                          : e.which;
                },
            },
            S.event.addProp
        ),
        S.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
            S.event.special[e] = {
                setup: function setup() {
                    return Ae(this, e, Se), !1;
                },
                trigger: function trigger() {
                    return Ae(this, e), !0;
                },
                delegateType: t,
            };
        }),
        S.each(
            {
                mouseenter: "mouseover",
                mouseleave: "mouseout",
                pointerenter: "pointerover",
                pointerleave: "pointerout",
            },
            function (e, i) {
                S.event.special[e] = {
                    delegateType: i,
                    bindType: i,
                    handle: function handle(e) {
                        var t,
                            n = e.relatedTarget,
                            r = e.handleObj;
                        return (
                            (n && (n === this || S.contains(this, n))) ||
                                ((e.type = r.origType), (t = r.handler.apply(this, arguments)), (e.type = i)),
                            t
                        );
                    },
                };
            }
        ),
        S.fn.extend({
            on: function on(e, t, n, r) {
                return ke(this, e, t, n, r);
            },
            one: function one(e, t, n, r) {
                return ke(this, e, t, n, r, 1);
            },
            off: function off(e, t, n) {
                var r, i;
                if (e && e.preventDefault && e.handleObj)
                    return (
                        (r = e.handleObj),
                        S(e.delegateTarget).off(
                            r.namespace ? r.origType + "." + r.namespace : r.origType,
                            r.selector,
                            r.handler
                        ),
                        this
                    );
                if ("object" == _typeof(e)) {
                    for (i in e) {
                        this.off(i, t, e[i]);
                    }
                    return this;
                }
                return (
                    (!1 !== t && "function" != typeof t) || ((n = t), (t = void 0)),
                    !1 === n && (n = Ee),
                    this.each(function () {
                        S.event.remove(this, e, n, t);
                    })
                );
            },
        });
    var Ne = /<script|<style|<link/i,
        De = /checked\s*(?:[^=]|=\s*.checked.)/i,
        je = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    function qe(e, t) {
        return (A(e, "table") && A(11 !== t.nodeType ? t : t.firstChild, "tr") && S(e).children("tbody")[0]) || e;
    }
    function Le(e) {
        return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
    }
    function He(e) {
        return "true/" === (e.type || "").slice(0, 5) ? (e.type = e.type.slice(5)) : e.removeAttribute("type"), e;
    }
    function Oe(e, t) {
        var n, r, i, o, a, s;
        if (1 === t.nodeType) {
            if (Y.hasData(e) && (s = Y.get(e).events))
                for (i in (Y.remove(t, "handle events"), s)) {
                    for (n = 0, r = s[i].length; n < r; n++) {
                        S.event.add(t, i, s[i][n]);
                    }
                }
            Q.hasData(e) && ((o = Q.access(e)), (a = S.extend({}, o)), Q.set(t, a));
        }
    }
    function Pe(n, r, i, o) {
        r = g(r);
        var e,
            t,
            a,
            s,
            u,
            l,
            c = 0,
            f = n.length,
            p = f - 1,
            d = r[0],
            h = m(d);
        if (h || (1 < f && "string" == typeof d && !y.checkClone && De.test(d)))
            return n.each(function (e) {
                var t = n.eq(e);
                h && (r[0] = d.call(this, e, t.html())), Pe(t, r, i, o);
            });
        if (
            f &&
            ((t = (e = xe(r, n[0].ownerDocument, !1, n, o)).firstChild), 1 === e.childNodes.length && (e = t), t || o)
        ) {
            for (s = (a = S.map(ve(e, "script"), Le)).length; c < f; c++) {
                (u = e), c !== p && ((u = S.clone(u, !0, !0)), s && S.merge(a, ve(u, "script"))), i.call(n[c], u, c);
            }
            if (s)
                for (l = a[a.length - 1].ownerDocument, S.map(a, He), c = 0; c < s; c++) {
                    (u = a[c]),
                        he.test(u.type || "") &&
                            !Y.access(u, "globalEval") &&
                            S.contains(l, u) &&
                            (u.src && "module" !== (u.type || "").toLowerCase()
                                ? S._evalUrl &&
                                  !u.noModule &&
                                  S._evalUrl(u.src, { nonce: u.nonce || u.getAttribute("nonce") }, l)
                                : b(u.textContent.replace(je, ""), u, l));
                }
        }
        return n;
    }
    function Re(e, t, n) {
        for (var r, i = t ? S.filter(t, e) : e, o = 0; null != (r = i[o]); o++) {
            n || 1 !== r.nodeType || S.cleanData(ve(r)),
                r.parentNode && (n && ie(r) && ye(ve(r, "script")), r.parentNode.removeChild(r));
        }
        return e;
    }
    S.extend({
        htmlPrefilter: function htmlPrefilter(e) {
            return e;
        },
        clone: function clone(e, t, n) {
            var r,
                i,
                o,
                a,
                s,
                u,
                l,
                c = e.cloneNode(!0),
                f = ie(e);
            if (!(y.noCloneChecked || (1 !== e.nodeType && 11 !== e.nodeType) || S.isXMLDoc(e)))
                for (a = ve(c), r = 0, i = (o = ve(e)).length; r < i; r++) {
                    (s = o[r]),
                        (u = a[r]),
                        void 0,
                        "input" === (l = u.nodeName.toLowerCase()) && pe.test(s.type)
                            ? (u.checked = s.checked)
                            : ("input" !== l && "textarea" !== l) || (u.defaultValue = s.defaultValue);
                }
            if (t)
                if (n)
                    for (o = o || ve(e), a = a || ve(c), r = 0, i = o.length; r < i; r++) {
                        Oe(o[r], a[r]);
                    }
                else Oe(e, c);
            return 0 < (a = ve(c, "script")).length && ye(a, !f && ve(e, "script")), c;
        },
        cleanData: function cleanData(e) {
            for (var t, n, r, i = S.event.special, o = 0; void 0 !== (n = e[o]); o++) {
                if (V(n)) {
                    if ((t = n[Y.expando])) {
                        if (t.events)
                            for (r in t.events) {
                                i[r] ? S.event.remove(n, r) : S.removeEvent(n, r, t.handle);
                            }
                        n[Y.expando] = void 0;
                    }
                    n[Q.expando] && (n[Q.expando] = void 0);
                }
            }
        },
    }),
        S.fn.extend({
            detach: function detach(e) {
                return Re(this, e, !0);
            },
            remove: function remove(e) {
                return Re(this, e);
            },
            text: function text(e) {
                return $(
                    this,
                    function (e) {
                        return void 0 === e
                            ? S.text(this)
                            : this.empty().each(function () {
                                  (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) ||
                                      (this.textContent = e);
                              });
                    },
                    null,
                    e,
                    arguments.length
                );
            },
            append: function append() {
                return Pe(this, arguments, function (e) {
                    (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || qe(this, e).appendChild(e);
                });
            },
            prepend: function prepend() {
                return Pe(this, arguments, function (e) {
                    if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                        var t = qe(this, e);
                        t.insertBefore(e, t.firstChild);
                    }
                });
            },
            before: function before() {
                return Pe(this, arguments, function (e) {
                    this.parentNode && this.parentNode.insertBefore(e, this);
                });
            },
            after: function after() {
                return Pe(this, arguments, function (e) {
                    this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
                });
            },
            empty: function empty() {
                for (var e, t = 0; null != (e = this[t]); t++) {
                    1 === e.nodeType && (S.cleanData(ve(e, !1)), (e.textContent = ""));
                }
                return this;
            },
            clone: function clone(e, t) {
                return (
                    (e = null != e && e),
                    (t = null == t ? e : t),
                    this.map(function () {
                        return S.clone(this, e, t);
                    })
                );
            },
            html: function html(e) {
                return $(
                    this,
                    function (e) {
                        var t = this[0] || {},
                            n = 0,
                            r = this.length;
                        if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                        if ("string" == typeof e && !Ne.test(e) && !ge[(de.exec(e) || ["", ""])[1].toLowerCase()]) {
                            e = S.htmlPrefilter(e);
                            try {
                                for (; n < r; n++) {
                                    1 === (t = this[n] || {}).nodeType && (S.cleanData(ve(t, !1)), (t.innerHTML = e));
                                }
                                t = 0;
                            } catch (e) {}
                        }
                        t && this.empty().append(e);
                    },
                    null,
                    e,
                    arguments.length
                );
            },
            replaceWith: function replaceWith() {
                var n = [];
                return Pe(
                    this,
                    arguments,
                    function (e) {
                        var t = this.parentNode;
                        S.inArray(this, n) < 0 && (S.cleanData(ve(this)), t && t.replaceChild(e, this));
                    },
                    n
                );
            },
        }),
        S.each(
            {
                appendTo: "append",
                prependTo: "prepend",
                insertBefore: "before",
                insertAfter: "after",
                replaceAll: "replaceWith",
            },
            function (e, a) {
                S.fn[e] = function (e) {
                    for (var t, n = [], r = S(e), i = r.length - 1, o = 0; o <= i; o++) {
                        (t = o === i ? this : this.clone(!0)), S(r[o])[a](t), u.apply(n, t.get());
                    }
                    return this.pushStack(n);
                };
            }
        );
    var Me = new RegExp("^(" + ee + ")(?!px)[a-z%]+$", "i"),
        Ie = function Ie(e) {
            var t = e.ownerDocument.defaultView;
            return (t && t.opener) || (t = C), t.getComputedStyle(e);
        },
        We = function We(e, t, n) {
            var r,
                i,
                o = {};
            for (i in t) {
                (o[i] = e.style[i]), (e.style[i] = t[i]);
            }
            for (i in ((r = n.call(e)), t)) {
                e.style[i] = o[i];
            }
            return r;
        },
        Fe = new RegExp(ne.join("|"), "i");
    function Be(e, t, n) {
        var r,
            i,
            o,
            a,
            s = e.style;
        return (
            (n = n || Ie(e)) &&
                ("" !== (a = n.getPropertyValue(t) || n[t]) || ie(e) || (a = S.style(e, t)),
                !y.pixelBoxStyles() &&
                    Me.test(a) &&
                    Fe.test(t) &&
                    ((r = s.width),
                    (i = s.minWidth),
                    (o = s.maxWidth),
                    (s.minWidth = s.maxWidth = s.width = a),
                    (a = n.width),
                    (s.width = r),
                    (s.minWidth = i),
                    (s.maxWidth = o))),
            void 0 !== a ? a + "" : a
        );
    }
    function $e(e, t) {
        return {
            get: function get() {
                if (!e()) return (this.get = t).apply(this, arguments);
                delete this.get;
            },
        };
    }
    !(function () {
        function e() {
            if (l) {
                (u.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
                    (l.style.cssText =
                        "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
                    re.appendChild(u).appendChild(l);
                var e = C.getComputedStyle(l);
                (n = "1%" !== e.top),
                    (s = 12 === t(e.marginLeft)),
                    (l.style.right = "60%"),
                    (o = 36 === t(e.right)),
                    (r = 36 === t(e.width)),
                    (l.style.position = "absolute"),
                    (i = 12 === t(l.offsetWidth / 3)),
                    re.removeChild(u),
                    (l = null);
            }
        }
        function t(e) {
            return Math.round(parseFloat(e));
        }
        var n,
            r,
            i,
            o,
            a,
            s,
            u = E.createElement("div"),
            l = E.createElement("div");
        l.style &&
            ((l.style.backgroundClip = "content-box"),
            (l.cloneNode(!0).style.backgroundClip = ""),
            (y.clearCloneStyle = "content-box" === l.style.backgroundClip),
            S.extend(y, {
                boxSizingReliable: function boxSizingReliable() {
                    return e(), r;
                },
                pixelBoxStyles: function pixelBoxStyles() {
                    return e(), o;
                },
                pixelPosition: function pixelPosition() {
                    return e(), n;
                },
                reliableMarginLeft: function reliableMarginLeft() {
                    return e(), s;
                },
                scrollboxSize: function scrollboxSize() {
                    return e(), i;
                },
                reliableTrDimensions: function reliableTrDimensions() {
                    var e, t, n, r;
                    return (
                        null == a &&
                            ((e = E.createElement("table")),
                            (t = E.createElement("tr")),
                            (n = E.createElement("div")),
                            (e.style.cssText = "position:absolute;left:-11111px"),
                            (t.style.height = "1px"),
                            (n.style.height = "9px"),
                            re.appendChild(e).appendChild(t).appendChild(n),
                            (r = C.getComputedStyle(t)),
                            (a = 3 < parseInt(r.height)),
                            re.removeChild(e)),
                        a
                    );
                },
            }));
    })();
    var _e = ["Webkit", "Moz", "ms"],
        ze = E.createElement("div").style,
        Ue = {};
    function Xe(e) {
        var t = S.cssProps[e] || Ue[e];
        return (
            t ||
            (e in ze
                ? e
                : (Ue[e] =
                      (function (e) {
                          var t = e[0].toUpperCase() + e.slice(1),
                              n = _e.length;
                          while (n--) {
                              if ((e = _e[n] + t) in ze) return e;
                          }
                      })(e) || e))
        );
    }
    var Ve = /^(none|table(?!-c[ea]).+)/,
        Ge = /^--/,
        Ye = { position: "absolute", visibility: "hidden", display: "block" },
        Qe = { letterSpacing: "0", fontWeight: "400" };
    function Je(e, t, n) {
        var r = te.exec(t);
        return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t;
    }
    function Ke(e, t, n, r, i, o) {
        var a = "width" === t ? 1 : 0,
            s = 0,
            u = 0;
        if (n === (r ? "border" : "content")) return 0;
        for (; a < 4; a += 2) {
            "margin" === n && (u += S.css(e, n + ne[a], !0, i)),
                r
                    ? ("content" === n && (u -= S.css(e, "padding" + ne[a], !0, i)),
                      "margin" !== n && (u -= S.css(e, "border" + ne[a] + "Width", !0, i)))
                    : ((u += S.css(e, "padding" + ne[a], !0, i)),
                      "padding" !== n
                          ? (u += S.css(e, "border" + ne[a] + "Width", !0, i))
                          : (s += S.css(e, "border" + ne[a] + "Width", !0, i)));
        }
        return (
            !r &&
                0 <= o &&
                (u += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - o - u - s - 0.5)) || 0),
            u
        );
    }
    function Ze(e, t, n) {
        var r = Ie(e),
            i = (!y.boxSizingReliable() || n) && "border-box" === S.css(e, "boxSizing", !1, r),
            o = i,
            a = Be(e, t, r),
            s = "offset" + t[0].toUpperCase() + t.slice(1);
        if (Me.test(a)) {
            if (!n) return a;
            a = "auto";
        }
        return (
            ((!y.boxSizingReliable() && i) ||
                (!y.reliableTrDimensions() && A(e, "tr")) ||
                "auto" === a ||
                (!parseFloat(a) && "inline" === S.css(e, "display", !1, r))) &&
                e.getClientRects().length &&
                ((i = "border-box" === S.css(e, "boxSizing", !1, r)), (o = s in e) && (a = e[s])),
            (a = parseFloat(a) || 0) + Ke(e, t, n || (i ? "border" : "content"), o, r, a) + "px"
        );
    }
    function et(e, t, n, r, i) {
        return new et.prototype.init(e, t, n, r, i);
    }
    S.extend({
        cssHooks: {
            opacity: {
                get: function get(e, t) {
                    if (t) {
                        var n = Be(e, "opacity");
                        return "" === n ? "1" : n;
                    }
                },
            },
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            gridArea: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnStart: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowStart: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0,
        },
        cssProps: {},
        style: function style(e, t, n, r) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var i,
                    o,
                    a,
                    s = X(t),
                    u = Ge.test(t),
                    l = e.style;
                if ((u || (t = Xe(s)), (a = S.cssHooks[t] || S.cssHooks[s]), void 0 === n))
                    return a && "get" in a && void 0 !== (i = a.get(e, !1, r)) ? i : l[t];
                "string" === (o = _typeof(n)) && (i = te.exec(n)) && i[1] && ((n = se(e, t, i)), (o = "number")),
                    null != n &&
                        n == n &&
                        ("number" !== o || u || (n += (i && i[3]) || (S.cssNumber[s] ? "" : "px")),
                        y.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (l[t] = "inherit"),
                        (a && "set" in a && void 0 === (n = a.set(e, n, r))) || (u ? l.setProperty(t, n) : (l[t] = n)));
            }
        },
        css: function css(e, t, n, r) {
            var i,
                o,
                a,
                s = X(t);
            return (
                Ge.test(t) || (t = Xe(s)),
                (a = S.cssHooks[t] || S.cssHooks[s]) && "get" in a && (i = a.get(e, !0, n)),
                void 0 === i && (i = Be(e, t, r)),
                "normal" === i && t in Qe && (i = Qe[t]),
                "" === n || n ? ((o = parseFloat(i)), !0 === n || isFinite(o) ? o || 0 : i) : i
            );
        },
    }),
        S.each(["height", "width"], function (e, u) {
            S.cssHooks[u] = {
                get: function get(e, t, n) {
                    if (t)
                        return !Ve.test(S.css(e, "display")) ||
                            (e.getClientRects().length && e.getBoundingClientRect().width)
                            ? Ze(e, u, n)
                            : We(e, Ye, function () {
                                  return Ze(e, u, n);
                              });
                },
                set: function set(e, t, n) {
                    var r,
                        i = Ie(e),
                        o = !y.scrollboxSize() && "absolute" === i.position,
                        a = (o || n) && "border-box" === S.css(e, "boxSizing", !1, i),
                        s = n ? Ke(e, u, n, a, i) : 0;
                    return (
                        a &&
                            o &&
                            (s -= Math.ceil(
                                e["offset" + u[0].toUpperCase() + u.slice(1)] -
                                    parseFloat(i[u]) -
                                    Ke(e, u, "border", !1, i) -
                                    0.5
                            )),
                        s && (r = te.exec(t)) && "px" !== (r[3] || "px") && ((e.style[u] = t), (t = S.css(e, u))),
                        Je(0, t, s)
                    );
                },
            };
        }),
        (S.cssHooks.marginLeft = $e(y.reliableMarginLeft, function (e, t) {
            if (t)
                return (
                    (parseFloat(Be(e, "marginLeft")) ||
                        e.getBoundingClientRect().left -
                            We(e, { marginLeft: 0 }, function () {
                                return e.getBoundingClientRect().left;
                            })) + "px"
                );
        })),
        S.each({ margin: "", padding: "", border: "Width" }, function (i, o) {
            (S.cssHooks[i + o] = {
                expand: function expand(e) {
                    for (var t = 0, n = {}, r = "string" == typeof e ? e.split(" ") : [e]; t < 4; t++) {
                        n[i + ne[t] + o] = r[t] || r[t - 2] || r[0];
                    }
                    return n;
                },
            }),
                "margin" !== i && (S.cssHooks[i + o].set = Je);
        }),
        S.fn.extend({
            css: function css(e, t) {
                return $(
                    this,
                    function (e, t, n) {
                        var r,
                            i,
                            o = {},
                            a = 0;
                        if (Array.isArray(t)) {
                            for (r = Ie(e), i = t.length; a < i; a++) {
                                o[t[a]] = S.css(e, t[a], !1, r);
                            }
                            return o;
                        }
                        return void 0 !== n ? S.style(e, t, n) : S.css(e, t);
                    },
                    e,
                    t,
                    1 < arguments.length
                );
            },
        }),
        (((S.Tween = et).prototype = {
            constructor: et,
            init: function init(e, t, n, r, i, o) {
                (this.elem = e),
                    (this.prop = n),
                    (this.easing = i || S.easing._default),
                    (this.options = t),
                    (this.start = this.now = this.cur()),
                    (this.end = r),
                    (this.unit = o || (S.cssNumber[n] ? "" : "px"));
            },
            cur: function cur() {
                var e = et.propHooks[this.prop];
                return e && e.get ? e.get(this) : et.propHooks._default.get(this);
            },
            run: function run(e) {
                var t,
                    n = et.propHooks[this.prop];
                return (
                    this.options.duration
                        ? (this.pos = t =
                              S.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration))
                        : (this.pos = t = e),
                    (this.now = (this.end - this.start) * t + this.start),
                    this.options.step && this.options.step.call(this.elem, this.now, this),
                    n && n.set ? n.set(this) : et.propHooks._default.set(this),
                    this
                );
            },
        }).init.prototype = et.prototype),
        ((et.propHooks = {
            _default: {
                get: function get(e) {
                    var t;
                    return 1 !== e.elem.nodeType || (null != e.elem[e.prop] && null == e.elem.style[e.prop])
                        ? e.elem[e.prop]
                        : (t = S.css(e.elem, e.prop, "")) && "auto" !== t
                          ? t
                          : 0;
                },
                set: function set(e) {
                    S.fx.step[e.prop]
                        ? S.fx.step[e.prop](e)
                        : 1 !== e.elem.nodeType || (!S.cssHooks[e.prop] && null == e.elem.style[Xe(e.prop)])
                          ? (e.elem[e.prop] = e.now)
                          : S.style(e.elem, e.prop, e.now + e.unit);
                },
            },
        }).scrollTop = et.propHooks.scrollLeft =
            {
                set: function set(e) {
                    e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
                },
            }),
        (S.easing = {
            linear: function linear(e) {
                return e;
            },
            swing: function swing(e) {
                return 0.5 - Math.cos(e * Math.PI) / 2;
            },
            _default: "swing",
        }),
        (S.fx = et.prototype.init),
        (S.fx.step = {});
    var tt,
        nt,
        rt,
        it,
        ot = /^(?:toggle|show|hide)$/,
        at = /queueHooks$/;
    function st() {
        nt &&
            (!1 === E.hidden && C.requestAnimationFrame ? C.requestAnimationFrame(st) : C.setTimeout(st, S.fx.interval),
            S.fx.tick());
    }
    function ut() {
        return (
            C.setTimeout(function () {
                tt = void 0;
            }),
            (tt = Date.now())
        );
    }
    function lt(e, t) {
        var n,
            r = 0,
            i = { height: e };
        for (t = t ? 1 : 0; r < 4; r += 2 - t) {
            i["margin" + (n = ne[r])] = i["padding" + n] = e;
        }
        return t && (i.opacity = i.width = e), i;
    }
    function ct(e, t, n) {
        for (var r, i = (ft.tweeners[t] || []).concat(ft.tweeners["*"]), o = 0, a = i.length; o < a; o++) {
            if ((r = i[o].call(n, t, e))) return r;
        }
    }
    function ft(o, e, t) {
        var n,
            a,
            r = 0,
            i = ft.prefilters.length,
            s = S.Deferred().always(function () {
                delete u.elem;
            }),
            u = function u() {
                if (a) return !1;
                for (
                    var e = tt || ut(),
                        t = Math.max(0, l.startTime + l.duration - e),
                        n = 1 - (t / l.duration || 0),
                        r = 0,
                        i = l.tweens.length;
                    r < i;
                    r++
                ) {
                    l.tweens[r].run(n);
                }
                return (
                    s.notifyWith(o, [l, n, t]),
                    n < 1 && i ? t : (i || s.notifyWith(o, [l, 1, 0]), s.resolveWith(o, [l]), !1)
                );
            },
            l = s.promise({
                elem: o,
                props: S.extend({}, e),
                opts: S.extend(!0, { specialEasing: {}, easing: S.easing._default }, t),
                originalProperties: e,
                originalOptions: t,
                startTime: tt || ut(),
                duration: t.duration,
                tweens: [],
                createTween: function createTween(e, t) {
                    var n = S.Tween(o, l.opts, e, t, l.opts.specialEasing[e] || l.opts.easing);
                    return l.tweens.push(n), n;
                },
                stop: function stop(e) {
                    var t = 0,
                        n = e ? l.tweens.length : 0;
                    if (a) return this;
                    for (a = !0; t < n; t++) {
                        l.tweens[t].run(1);
                    }
                    return e ? (s.notifyWith(o, [l, 1, 0]), s.resolveWith(o, [l, e])) : s.rejectWith(o, [l, e]), this;
                },
            }),
            c = l.props;
        for (
            !(function (e, t) {
                var n, r, i, o, a;
                for (n in e) {
                    if (
                        ((i = t[(r = X(n))]),
                        (o = e[n]),
                        Array.isArray(o) && ((i = o[1]), (o = e[n] = o[0])),
                        n !== r && ((e[r] = o), delete e[n]),
                        (a = S.cssHooks[r]) && ("expand" in a))
                    )
                        for (n in ((o = a.expand(o)), delete e[r], o)) {
                            (n in e) || ((e[n] = o[n]), (t[n] = i));
                        }
                    else t[r] = i;
                }
            })(c, l.opts.specialEasing);
            r < i;
            r++
        ) {
            if ((n = ft.prefilters[r].call(l, o, c, l.opts)))
                return m(n.stop) && (S._queueHooks(l.elem, l.opts.queue).stop = n.stop.bind(n)), n;
        }
        return (
            S.map(c, ct, l),
            m(l.opts.start) && l.opts.start.call(o, l),
            l.progress(l.opts.progress).done(l.opts.done, l.opts.complete).fail(l.opts.fail).always(l.opts.always),
            S.fx.timer(S.extend(u, { elem: o, anim: l, queue: l.opts.queue })),
            l
        );
    }
    (S.Animation = S.extend(ft, {
        tweeners: {
            "*": [
                function (e, t) {
                    var n = this.createTween(e, t);
                    return se(n.elem, e, te.exec(t), n), n;
                },
            ],
        },
        tweener: function tweener(e, t) {
            m(e) ? ((t = e), (e = ["*"])) : (e = e.match(P));
            for (var n, r = 0, i = e.length; r < i; r++) {
                (n = e[r]), (ft.tweeners[n] = ft.tweeners[n] || []), ft.tweeners[n].unshift(t);
            }
        },
        prefilters: [
            function (e, t, n) {
                var r,
                    i,
                    o,
                    a,
                    s,
                    u,
                    l,
                    c,
                    f = "width" in t || "height" in t,
                    p = this,
                    d = {},
                    h = e.style,
                    g = e.nodeType && ae(e),
                    v = Y.get(e, "fxshow");
                for (r in (n.queue ||
                    (null == (a = S._queueHooks(e, "fx")).unqueued &&
                        ((a.unqueued = 0),
                        (s = a.empty.fire),
                        (a.empty.fire = function () {
                            a.unqueued || s();
                        })),
                    a.unqueued++,
                    p.always(function () {
                        p.always(function () {
                            a.unqueued--, S.queue(e, "fx").length || a.empty.fire();
                        });
                    })),
                t)) {
                    if (((i = t[r]), ot.test(i))) {
                        if ((delete t[r], (o = o || "toggle" === i), i === (g ? "hide" : "show"))) {
                            if ("show" !== i || !v || void 0 === v[r]) continue;
                            g = !0;
                        }
                        d[r] = (v && v[r]) || S.style(e, r);
                    }
                }
                if ((u = !S.isEmptyObject(t)) || !S.isEmptyObject(d))
                    for (r in (f &&
                        1 === e.nodeType &&
                        ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
                        null == (l = v && v.display) && (l = Y.get(e, "display")),
                        "none" === (c = S.css(e, "display")) &&
                            (l
                                ? (c = l)
                                : (le([e], !0), (l = e.style.display || l), (c = S.css(e, "display")), le([e]))),
                        ("inline" === c || ("inline-block" === c && null != l)) &&
                            "none" === S.css(e, "float") &&
                            (u ||
                                (p.done(function () {
                                    h.display = l;
                                }),
                                null == l && ((c = h.display), (l = "none" === c ? "" : c))),
                            (h.display = "inline-block"))),
                    n.overflow &&
                        ((h.overflow = "hidden"),
                        p.always(function () {
                            (h.overflow = n.overflow[0]), (h.overflowX = n.overflow[1]), (h.overflowY = n.overflow[2]);
                        })),
                    (u = !1),
                    d)) {
                        u ||
                            (v ? "hidden" in v && (g = v.hidden) : (v = Y.access(e, "fxshow", { display: l })),
                            o && (v.hidden = !g),
                            g && le([e], !0),
                            p.done(function () {
                                for (r in (g || le([e]), Y.remove(e, "fxshow"), d)) {
                                    S.style(e, r, d[r]);
                                }
                            })),
                            (u = ct(g ? v[r] : 0, r, p)),
                            r in v || ((v[r] = u.start), g && ((u.end = u.start), (u.start = 0)));
                    }
            },
        ],
        prefilter: function prefilter(e, t) {
            t ? ft.prefilters.unshift(e) : ft.prefilters.push(e);
        },
    })),
        (S.speed = function (e, t, n) {
            var r =
                e && "object" == _typeof(e)
                    ? S.extend({}, e)
                    : { complete: n || (!n && t) || (m(e) && e), duration: e, easing: (n && t) || (t && !m(t) && t) };
            return (
                S.fx.off
                    ? (r.duration = 0)
                    : "number" != typeof r.duration &&
                      (r.duration in S.fx.speeds
                          ? (r.duration = S.fx.speeds[r.duration])
                          : (r.duration = S.fx.speeds._default)),
                (null != r.queue && !0 !== r.queue) || (r.queue = "fx"),
                (r.old = r.complete),
                (r.complete = function () {
                    m(r.old) && r.old.call(this), r.queue && S.dequeue(this, r.queue);
                }),
                r
            );
        }),
        S.fn.extend({
            fadeTo: function fadeTo(e, t, n, r) {
                return this.filter(ae).css("opacity", 0).show().end().animate({ opacity: t }, e, n, r);
            },
            animate: function animate(t, e, n, r) {
                var i = S.isEmptyObject(t),
                    o = S.speed(e, n, r),
                    a = function a() {
                        var e = ft(this, S.extend({}, t), o);
                        (i || Y.get(this, "finish")) && e.stop(!0);
                    };
                return (a.finish = a), i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a);
            },
            stop: function stop(i, e, o) {
                var a = function a(e) {
                    var t = e.stop;
                    delete e.stop, t(o);
                };
                return (
                    "string" != typeof i && ((o = e), (e = i), (i = void 0)),
                    e && this.queue(i || "fx", []),
                    this.each(function () {
                        var e = !0,
                            t = null != i && i + "queueHooks",
                            n = S.timers,
                            r = Y.get(this);
                        if (t) r[t] && r[t].stop && a(r[t]);
                        else
                            for (t in r) {
                                r[t] && r[t].stop && at.test(t) && a(r[t]);
                            }
                        for (t = n.length; t--; ) {
                            n[t].elem !== this ||
                                (null != i && n[t].queue !== i) ||
                                (n[t].anim.stop(o), (e = !1), n.splice(t, 1));
                        }
                        (!e && o) || S.dequeue(this, i);
                    })
                );
            },
            finish: function finish(a) {
                return (
                    !1 !== a && (a = a || "fx"),
                    this.each(function () {
                        var e,
                            t = Y.get(this),
                            n = t[a + "queue"],
                            r = t[a + "queueHooks"],
                            i = S.timers,
                            o = n ? n.length : 0;
                        for (
                            t.finish = !0, S.queue(this, a, []), r && r.stop && r.stop.call(this, !0), e = i.length;
                            e--;

                        ) {
                            i[e].elem === this && i[e].queue === a && (i[e].anim.stop(!0), i.splice(e, 1));
                        }
                        for (e = 0; e < o; e++) {
                            n[e] && n[e].finish && n[e].finish.call(this);
                        }
                        delete t.finish;
                    })
                );
            },
        }),
        S.each(["toggle", "show", "hide"], function (e, r) {
            var i = S.fn[r];
            S.fn[r] = function (e, t, n) {
                return null == e || "boolean" == typeof e ? i.apply(this, arguments) : this.animate(lt(r, !0), e, t, n);
            };
        }),
        S.each(
            {
                slideDown: lt("show"),
                slideUp: lt("hide"),
                slideToggle: lt("toggle"),
                fadeIn: { opacity: "show" },
                fadeOut: { opacity: "hide" },
                fadeToggle: { opacity: "toggle" },
            },
            function (e, r) {
                S.fn[e] = function (e, t, n) {
                    return this.animate(r, e, t, n);
                };
            }
        ),
        (S.timers = []),
        (S.fx.tick = function () {
            var e,
                t = 0,
                n = S.timers;
            for (tt = Date.now(); t < n.length; t++) {
                (e = n[t])() || n[t] !== e || n.splice(t--, 1);
            }
            n.length || S.fx.stop(), (tt = void 0);
        }),
        (S.fx.timer = function (e) {
            S.timers.push(e), S.fx.start();
        }),
        (S.fx.interval = 13),
        (S.fx.start = function () {
            nt || ((nt = !0), st());
        }),
        (S.fx.stop = function () {
            nt = null;
        }),
        (S.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
        (S.fn.delay = function (r, e) {
            return (
                (r = (S.fx && S.fx.speeds[r]) || r),
                (e = e || "fx"),
                this.queue(e, function (e, t) {
                    var n = C.setTimeout(e, r);
                    t.stop = function () {
                        C.clearTimeout(n);
                    };
                })
            );
        }),
        (rt = E.createElement("input")),
        (it = E.createElement("select").appendChild(E.createElement("option"))),
        (rt.type = "checkbox"),
        (y.checkOn = "" !== rt.value),
        (y.optSelected = it.selected),
        ((rt = E.createElement("input")).value = "t"),
        (rt.type = "radio"),
        (y.radioValue = "t" === rt.value);
    var pt,
        dt = S.expr.attrHandle;
    S.fn.extend({
        attr: function attr(e, t) {
            return $(this, S.attr, e, t, 1 < arguments.length);
        },
        removeAttr: function removeAttr(e) {
            return this.each(function () {
                S.removeAttr(this, e);
            });
        },
    }),
        S.extend({
            attr: function attr(e, t, n) {
                var r,
                    i,
                    o = e.nodeType;
                if (3 !== o && 8 !== o && 2 !== o)
                    return "undefined" == typeof e.getAttribute
                        ? S.prop(e, t, n)
                        : ((1 === o && S.isXMLDoc(e)) ||
                              (i = S.attrHooks[t.toLowerCase()] || (S.expr.match.bool.test(t) ? pt : void 0)),
                          void 0 !== n
                              ? null === n
                                  ? void S.removeAttr(e, t)
                                  : i && "set" in i && void 0 !== (r = i.set(e, n, t))
                                    ? r
                                    : (e.setAttribute(t, n + ""), n)
                              : i && "get" in i && null !== (r = i.get(e, t))
                                ? r
                                : null == (r = S.find.attr(e, t))
                                  ? void 0
                                  : r);
            },
            attrHooks: {
                type: {
                    set: function set(e, t) {
                        if (!y.radioValue && "radio" === t && A(e, "input")) {
                            var n = e.value;
                            return e.setAttribute("type", t), n && (e.value = n), t;
                        }
                    },
                },
            },
            removeAttr: function removeAttr(e, t) {
                var n,
                    r = 0,
                    i = t && t.match(P);
                if (i && 1 === e.nodeType)
                    while ((n = i[r++])) {
                        e.removeAttribute(n);
                    }
            },
        }),
        (pt = {
            set: function set(e, t, n) {
                return !1 === t ? S.removeAttr(e, n) : e.setAttribute(n, n), n;
            },
        }),
        S.each(S.expr.match.bool.source.match(/\w+/g), function (e, t) {
            var a = dt[t] || S.find.attr;
            dt[t] = function (e, t, n) {
                var r,
                    i,
                    o = t.toLowerCase();
                return n || ((i = dt[o]), (dt[o] = r), (r = null != a(e, t, n) ? o : null), (dt[o] = i)), r;
            };
        });
    var ht = /^(?:input|select|textarea|button)$/i,
        gt = /^(?:a|area)$/i;
    function vt(e) {
        return (e.match(P) || []).join(" ");
    }
    function yt(e) {
        return (e.getAttribute && e.getAttribute("class")) || "";
    }
    function mt(e) {
        return Array.isArray(e) ? e : ("string" == typeof e && e.match(P)) || [];
    }
    S.fn.extend({
        prop: function prop(e, t) {
            return $(this, S.prop, e, t, 1 < arguments.length);
        },
        removeProp: function removeProp(e) {
            return this.each(function () {
                delete this[S.propFix[e] || e];
            });
        },
    }),
        S.extend({
            prop: function prop(e, t, n) {
                var r,
                    i,
                    o = e.nodeType;
                if (3 !== o && 8 !== o && 2 !== o)
                    return (
                        (1 === o && S.isXMLDoc(e)) || ((t = S.propFix[t] || t), (i = S.propHooks[t])),
                        void 0 !== n
                            ? i && "set" in i && void 0 !== (r = i.set(e, n, t))
                                ? r
                                : (e[t] = n)
                            : i && "get" in i && null !== (r = i.get(e, t))
                              ? r
                              : e[t]
                    );
            },
            propHooks: {
                tabIndex: {
                    get: function get(e) {
                        var t = S.find.attr(e, "tabindex");
                        return t ? parseInt(t, 10) : ht.test(e.nodeName) || (gt.test(e.nodeName) && e.href) ? 0 : -1;
                    },
                },
            },
            propFix: { for: "htmlFor", class: "className" },
        }),
        y.optSelected ||
            (S.propHooks.selected = {
                get: function get(e) {
                    var t = e.parentNode;
                    return t && t.parentNode && t.parentNode.selectedIndex, null;
                },
                set: function set(e) {
                    var t = e.parentNode;
                    t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
                },
            }),
        S.each(
            [
                "tabIndex",
                "readOnly",
                "maxLength",
                "cellSpacing",
                "cellPadding",
                "rowSpan",
                "colSpan",
                "useMap",
                "frameBorder",
                "contentEditable",
            ],
            function () {
                S.propFix[this.toLowerCase()] = this;
            }
        ),
        S.fn.extend({
            addClass: function addClass(t) {
                var e,
                    n,
                    r,
                    i,
                    o,
                    a,
                    s,
                    u = 0;
                if (m(t))
                    return this.each(function (e) {
                        S(this).addClass(t.call(this, e, yt(this)));
                    });
                if ((e = mt(t)).length)
                    while ((n = this[u++])) {
                        if (((i = yt(n)), (r = 1 === n.nodeType && " " + vt(i) + " "))) {
                            a = 0;
                            while ((o = e[a++])) {
                                r.indexOf(" " + o + " ") < 0 && (r += o + " ");
                            }
                            i !== (s = vt(r)) && n.setAttribute("class", s);
                        }
                    }
                return this;
            },
            removeClass: function removeClass(t) {
                var e,
                    n,
                    r,
                    i,
                    o,
                    a,
                    s,
                    u = 0;
                if (m(t))
                    return this.each(function (e) {
                        S(this).removeClass(t.call(this, e, yt(this)));
                    });
                if (!arguments.length) return this.attr("class", "");
                if ((e = mt(t)).length)
                    while ((n = this[u++])) {
                        if (((i = yt(n)), (r = 1 === n.nodeType && " " + vt(i) + " "))) {
                            a = 0;
                            while ((o = e[a++])) {
                                while (-1 < r.indexOf(" " + o + " ")) {
                                    r = r.replace(" " + o + " ", " ");
                                }
                            }
                            i !== (s = vt(r)) && n.setAttribute("class", s);
                        }
                    }
                return this;
            },
            toggleClass: function toggleClass(i, t) {
                var o = _typeof(i),
                    a = "string" === o || Array.isArray(i);
                return "boolean" == typeof t && a
                    ? t
                        ? this.addClass(i)
                        : this.removeClass(i)
                    : m(i)
                      ? this.each(function (e) {
                            S(this).toggleClass(i.call(this, e, yt(this), t), t);
                        })
                      : this.each(function () {
                            var e, t, n, r;
                            if (a) {
                                (t = 0), (n = S(this)), (r = mt(i));
                                while ((e = r[t++])) {
                                    n.hasClass(e) ? n.removeClass(e) : n.addClass(e);
                                }
                            } else
                                (void 0 !== i && "boolean" !== o) ||
                                    ((e = yt(this)) && Y.set(this, "__className__", e),
                                    this.setAttribute &&
                                        this.setAttribute(
                                            "class",
                                            e || !1 === i ? "" : Y.get(this, "__className__") || ""
                                        ));
                        });
            },
            hasClass: function hasClass(e) {
                var t,
                    n,
                    r = 0;
                t = " " + e + " ";
                while ((n = this[r++])) {
                    if (1 === n.nodeType && -1 < (" " + vt(yt(n)) + " ").indexOf(t)) return !0;
                }
                return !1;
            },
        });
    var xt = /\r/g;
    S.fn.extend({
        val: function val(n) {
            var r,
                e,
                i,
                t = this[0];
            return arguments.length
                ? ((i = m(n)),
                  this.each(function (e) {
                      var t;
                      1 === this.nodeType &&
                          (null == (t = i ? n.call(this, e, S(this).val()) : n)
                              ? (t = "")
                              : "number" == typeof t
                                ? (t += "")
                                : Array.isArray(t) &&
                                  (t = S.map(t, function (e) {
                                      return null == e ? "" : e + "";
                                  })),
                          ((r = S.valHooks[this.type] || S.valHooks[this.nodeName.toLowerCase()]) &&
                              "set" in r &&
                              void 0 !== r.set(this, t, "value")) ||
                              (this.value = t));
                  }))
                : t
                  ? (r = S.valHooks[t.type] || S.valHooks[t.nodeName.toLowerCase()]) &&
                    "get" in r &&
                    void 0 !== (e = r.get(t, "value"))
                      ? e
                      : "string" == typeof (e = t.value)
                        ? e.replace(xt, "")
                        : null == e
                          ? ""
                          : e
                  : void 0;
        },
    }),
        S.extend({
            valHooks: {
                option: {
                    get: function get(e) {
                        var t = S.find.attr(e, "value");
                        return null != t ? t : vt(S.text(e));
                    },
                },
                select: {
                    get: function get(e) {
                        var t,
                            n,
                            r,
                            i = e.options,
                            o = e.selectedIndex,
                            a = "select-one" === e.type,
                            s = a ? null : [],
                            u = a ? o + 1 : i.length;
                        for (r = o < 0 ? u : a ? o : 0; r < u; r++) {
                            if (
                                ((n = i[r]).selected || r === o) &&
                                !n.disabled &&
                                (!n.parentNode.disabled || !A(n.parentNode, "optgroup"))
                            ) {
                                if (((t = S(n).val()), a)) return t;
                                s.push(t);
                            }
                        }
                        return s;
                    },
                    set: function set(e, t) {
                        var n,
                            r,
                            i = e.options,
                            o = S.makeArray(t),
                            a = i.length;
                        while (a--) {
                            ((r = i[a]).selected = -1 < S.inArray(S.valHooks.option.get(r), o)) && (n = !0);
                        }
                        return n || (e.selectedIndex = -1), o;
                    },
                },
            },
        }),
        S.each(["radio", "checkbox"], function () {
            (S.valHooks[this] = {
                set: function set(e, t) {
                    if (Array.isArray(t)) return (e.checked = -1 < S.inArray(S(e).val(), t));
                },
            }),
                y.checkOn ||
                    (S.valHooks[this].get = function (e) {
                        return null === e.getAttribute("value") ? "on" : e.value;
                    });
        }),
        (y.focusin = "onfocusin" in C);
    var bt = /^(?:focusinfocus|focusoutblur)$/,
        wt = function wt(e) {
            e.stopPropagation();
        };
    S.extend(S.event, {
        trigger: function trigger(e, t, n, r) {
            var i,
                o,
                a,
                s,
                u,
                l,
                c,
                f,
                p = [n || E],
                d = v.call(e, "type") ? e.type : e,
                h = v.call(e, "namespace") ? e.namespace.split(".") : [];
            if (
                ((o = f = a = n = n || E),
                3 !== n.nodeType &&
                    8 !== n.nodeType &&
                    !bt.test(d + S.event.triggered) &&
                    (-1 < d.indexOf(".") && ((d = (h = d.split(".")).shift()), h.sort()),
                    (u = d.indexOf(":") < 0 && "on" + d),
                    ((e = e[S.expando] ? e : new S.Event(d, "object" == _typeof(e) && e)).isTrigger = r ? 2 : 3),
                    (e.namespace = h.join(".")),
                    (e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)") : null),
                    (e.result = void 0),
                    e.target || (e.target = n),
                    (t = null == t ? [e] : S.makeArray(t, [e])),
                    (c = S.event.special[d] || {}),
                    r || !c.trigger || !1 !== c.trigger.apply(n, t)))
            ) {
                if (!r && !c.noBubble && !x(n)) {
                    for (s = c.delegateType || d, bt.test(s + d) || (o = o.parentNode); o; o = o.parentNode) {
                        p.push(o), (a = o);
                    }
                    a === (n.ownerDocument || E) && p.push(a.defaultView || a.parentWindow || C);
                }
                i = 0;
                while ((o = p[i++]) && !e.isPropagationStopped()) {
                    (f = o),
                        (e.type = 1 < i ? s : c.bindType || d),
                        (l = (Y.get(o, "events") || Object.create(null))[e.type] && Y.get(o, "handle")) &&
                            l.apply(o, t),
                        (l = u && o[u]) &&
                            l.apply &&
                            V(o) &&
                            ((e.result = l.apply(o, t)), !1 === e.result && e.preventDefault());
                }
                return (
                    (e.type = d),
                    r ||
                        e.isDefaultPrevented() ||
                        (c._default && !1 !== c._default.apply(p.pop(), t)) ||
                        !V(n) ||
                        (u &&
                            m(n[d]) &&
                            !x(n) &&
                            ((a = n[u]) && (n[u] = null),
                            (S.event.triggered = d),
                            e.isPropagationStopped() && f.addEventListener(d, wt),
                            n[d](),
                            e.isPropagationStopped() && f.removeEventListener(d, wt),
                            (S.event.triggered = void 0),
                            a && (n[u] = a))),
                    e.result
                );
            }
        },
        simulate: function simulate(e, t, n) {
            var r = S.extend(new S.Event(), n, { type: e, isSimulated: !0 });
            S.event.trigger(r, null, t);
        },
    }),
        S.fn.extend({
            trigger: function trigger(e, t) {
                return this.each(function () {
                    S.event.trigger(e, t, this);
                });
            },
            triggerHandler: function triggerHandler(e, t) {
                var n = this[0];
                if (n) return S.event.trigger(e, t, n, !0);
            },
        }),
        y.focusin ||
            S.each({ focus: "focusin", blur: "focusout" }, function (n, r) {
                var i = function i(e) {
                    S.event.simulate(r, e.target, S.event.fix(e));
                };
                S.event.special[r] = {
                    setup: function setup() {
                        var e = this.ownerDocument || this.document || this,
                            t = Y.access(e, r);
                        t || e.addEventListener(n, i, !0), Y.access(e, r, (t || 0) + 1);
                    },
                    teardown: function teardown() {
                        var e = this.ownerDocument || this.document || this,
                            t = Y.access(e, r) - 1;
                        t ? Y.access(e, r, t) : (e.removeEventListener(n, i, !0), Y.remove(e, r));
                    },
                };
            });
    var Tt = C.location,
        Ct = { guid: Date.now() },
        Et = /\?/;
    S.parseXML = function (e) {
        var t;
        if (!e || "string" != typeof e) return null;
        try {
            t = new C.DOMParser().parseFromString(e, "text/xml");
        } catch (e) {
            t = void 0;
        }
        return (t && !t.getElementsByTagName("parsererror").length) || S.error("Invalid XML: " + e), t;
    };
    var St = /\[\]$/,
        kt = /\r?\n/g,
        At = /^(?:submit|button|image|reset|file)$/i,
        Nt = /^(?:input|select|textarea|keygen)/i;
    function Dt(n, e, r, i) {
        var t;
        if (Array.isArray(e))
            S.each(e, function (e, t) {
                r || St.test(n) ? i(n, t) : Dt(n + "[" + ("object" == _typeof(t) && null != t ? e : "") + "]", t, r, i);
            });
        else if (r || "object" !== w(e)) i(n, e);
        else
            for (t in e) {
                Dt(n + "[" + t + "]", e[t], r, i);
            }
    }
    (S.param = function (e, t) {
        var n,
            r = [],
            i = function i(e, t) {
                var n = m(t) ? t() : t;
                r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
            };
        if (null == e) return "";
        if (Array.isArray(e) || (e.jquery && !S.isPlainObject(e)))
            S.each(e, function () {
                i(this.name, this.value);
            });
        else
            for (n in e) {
                Dt(n, e[n], t, i);
            }
        return r.join("&");
    }),
        S.fn.extend({
            serialize: function serialize() {
                return S.param(this.serializeArray());
            },
            serializeArray: function serializeArray() {
                return this.map(function () {
                    var e = S.prop(this, "elements");
                    return e ? S.makeArray(e) : this;
                })
                    .filter(function () {
                        var e = this.type;
                        return (
                            this.name &&
                            !S(this).is(":disabled") &&
                            Nt.test(this.nodeName) &&
                            !At.test(e) &&
                            (this.checked || !pe.test(e))
                        );
                    })
                    .map(function (e, t) {
                        var n = S(this).val();
                        return null == n
                            ? null
                            : Array.isArray(n)
                              ? S.map(n, function (e) {
                                    return { name: t.name, value: e.replace(kt, "\r\n") };
                                })
                              : { name: t.name, value: n.replace(kt, "\r\n") };
                    })
                    .get();
            },
        });
    var jt = /%20/g,
        qt = /#.*$/,
        Lt = /([?&])_=[^&]*/,
        Ht = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        Ot = /^(?:GET|HEAD)$/,
        Pt = /^\/\//,
        Rt = {},
        Mt = {},
        It = "*/".concat("*"),
        Wt = E.createElement("a");
    function Ft(o) {
        return function (e, t) {
            "string" != typeof e && ((t = e), (e = "*"));
            var n,
                r = 0,
                i = e.toLowerCase().match(P) || [];
            if (m(t))
                while ((n = i[r++])) {
                    "+" === n[0]
                        ? ((n = n.slice(1) || "*"), (o[n] = o[n] || []).unshift(t))
                        : (o[n] = o[n] || []).push(t);
                }
        };
    }
    function Bt(t, i, o, a) {
        var s = {},
            u = t === Mt;
        function l(e) {
            var r;
            return (
                (s[e] = !0),
                S.each(t[e] || [], function (e, t) {
                    var n = t(i, o, a);
                    return "string" != typeof n || u || s[n]
                        ? u
                            ? !(r = n)
                            : void 0
                        : (i.dataTypes.unshift(n), l(n), !1);
                }),
                r
            );
        }
        return l(i.dataTypes[0]) || (!s["*"] && l("*"));
    }
    function $t(e, t) {
        var n,
            r,
            i = S.ajaxSettings.flatOptions || {};
        for (n in t) {
            void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
        }
        return r && S.extend(!0, e, r), e;
    }
    (Wt.href = Tt.href),
        S.extend({
            active: 0,
            lastModified: {},
            etag: {},
            ajaxSettings: {
                url: Tt.href,
                type: "GET",
                isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Tt.protocol),
                global: !0,
                processData: !0,
                async: !0,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                accepts: {
                    "*": It,
                    text: "text/plain",
                    html: "text/html",
                    xml: "application/xml, text/xml",
                    json: "application/json, text/javascript",
                },
                contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" },
                converters: { "* text": String, "text html": !0, "text json": JSON.parse, "text xml": S.parseXML },
                flatOptions: { url: !0, context: !0 },
            },
            ajaxSetup: function ajaxSetup(e, t) {
                return t ? $t($t(e, S.ajaxSettings), t) : $t(S.ajaxSettings, e);
            },
            ajaxPrefilter: Ft(Rt),
            ajaxTransport: Ft(Mt),
            ajax: function ajax(e, t) {
                "object" == _typeof(e) && ((t = e), (e = void 0)), (t = t || {});
                var c,
                    f,
                    p,
                    n,
                    d,
                    r,
                    h,
                    g,
                    i,
                    o,
                    v = S.ajaxSetup({}, t),
                    y = v.context || v,
                    m = v.context && (y.nodeType || y.jquery) ? S(y) : S.event,
                    x = S.Deferred(),
                    b = S.Callbacks("once memory"),
                    w = v.statusCode || {},
                    a = {},
                    s = {},
                    u = "canceled",
                    T = {
                        readyState: 0,
                        getResponseHeader: function getResponseHeader(e) {
                            var t;
                            if (h) {
                                if (!n) {
                                    n = {};
                                    while ((t = Ht.exec(p))) {
                                        n[t[1].toLowerCase() + " "] = (n[t[1].toLowerCase() + " "] || []).concat(t[2]);
                                    }
                                }
                                t = n[e.toLowerCase() + " "];
                            }
                            return null == t ? null : t.join(", ");
                        },
                        getAllResponseHeaders: function getAllResponseHeaders() {
                            return h ? p : null;
                        },
                        setRequestHeader: function setRequestHeader(e, t) {
                            return null == h && ((e = s[e.toLowerCase()] = s[e.toLowerCase()] || e), (a[e] = t)), this;
                        },
                        overrideMimeType: function overrideMimeType(e) {
                            return null == h && (v.mimeType = e), this;
                        },
                        statusCode: function statusCode(e) {
                            var t;
                            if (e)
                                if (h) T.always(e[T.status]);
                                else
                                    for (t in e) {
                                        w[t] = [w[t], e[t]];
                                    }
                            return this;
                        },
                        abort: function abort(e) {
                            var t = e || u;
                            return c && c.abort(t), l(0, t), this;
                        },
                    };
                if (
                    (x.promise(T),
                    (v.url = ((e || v.url || Tt.href) + "").replace(Pt, Tt.protocol + "//")),
                    (v.type = t.method || t.type || v.method || v.type),
                    (v.dataTypes = (v.dataType || "*").toLowerCase().match(P) || [""]),
                    null == v.crossDomain)
                ) {
                    r = E.createElement("a");
                    try {
                        (r.href = v.url),
                            (r.href = r.href),
                            (v.crossDomain = Wt.protocol + "//" + Wt.host != r.protocol + "//" + r.host);
                    } catch (e) {
                        v.crossDomain = !0;
                    }
                }
                if (
                    (v.data && v.processData && "string" != typeof v.data && (v.data = S.param(v.data, v.traditional)),
                    Bt(Rt, v, t, T),
                    h)
                )
                    return T;
                for (i in ((g = S.event && v.global) && 0 == S.active++ && S.event.trigger("ajaxStart"),
                (v.type = v.type.toUpperCase()),
                (v.hasContent = !Ot.test(v.type)),
                (f = v.url.replace(qt, "")),
                v.hasContent
                    ? v.data &&
                      v.processData &&
                      0 === (v.contentType || "").indexOf("application/x-www-form-urlencoded") &&
                      (v.data = v.data.replace(jt, "+"))
                    : ((o = v.url.slice(f.length)),
                      v.data &&
                          (v.processData || "string" == typeof v.data) &&
                          ((f += (Et.test(f) ? "&" : "?") + v.data), delete v.data),
                      !1 === v.cache &&
                          ((f = f.replace(Lt, "$1")), (o = (Et.test(f) ? "&" : "?") + "_=" + Ct.guid++ + o)),
                      (v.url = f + o)),
                v.ifModified &&
                    (S.lastModified[f] && T.setRequestHeader("If-Modified-Since", S.lastModified[f]),
                    S.etag[f] && T.setRequestHeader("If-None-Match", S.etag[f])),
                ((v.data && v.hasContent && !1 !== v.contentType) || t.contentType) &&
                    T.setRequestHeader("Content-Type", v.contentType),
                T.setRequestHeader(
                    "Accept",
                    v.dataTypes[0] && v.accepts[v.dataTypes[0]]
                        ? v.accepts[v.dataTypes[0]] + ("*" !== v.dataTypes[0] ? ", " + It + "; q=0.01" : "")
                        : v.accepts["*"]
                ),
                v.headers)) {
                    T.setRequestHeader(i, v.headers[i]);
                }
                if (v.beforeSend && (!1 === v.beforeSend.call(y, T, v) || h)) return T.abort();
                if (((u = "abort"), b.add(v.complete), T.done(v.success), T.fail(v.error), (c = Bt(Mt, v, t, T)))) {
                    if (((T.readyState = 1), g && m.trigger("ajaxSend", [T, v]), h)) return T;
                    v.async &&
                        0 < v.timeout &&
                        (d = C.setTimeout(function () {
                            T.abort("timeout");
                        }, v.timeout));
                    try {
                        (h = !1), c.send(a, l);
                    } catch (e) {
                        if (h) throw e;
                        l(-1, e);
                    }
                } else l(-1, "No Transport");
                function l(e, t, n, r) {
                    var i,
                        o,
                        a,
                        s,
                        u,
                        l = t;
                    h ||
                        ((h = !0),
                        d && C.clearTimeout(d),
                        (c = void 0),
                        (p = r || ""),
                        (T.readyState = 0 < e ? 4 : 0),
                        (i = (200 <= e && e < 300) || 304 === e),
                        n &&
                            (s = (function (e, t, n) {
                                var r,
                                    i,
                                    o,
                                    a,
                                    s = e.contents,
                                    u = e.dataTypes;
                                while ("*" === u[0]) {
                                    u.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
                                }
                                if (r)
                                    for (i in s) {
                                        if (s[i] && s[i].test(r)) {
                                            u.unshift(i);
                                            break;
                                        }
                                    }
                                if (u[0] in n) o = u[0];
                                else {
                                    for (i in n) {
                                        if (!u[0] || e.converters[i + " " + u[0]]) {
                                            o = i;
                                            break;
                                        }
                                        a || (a = i);
                                    }
                                    o = o || a;
                                }
                                if (o) return o !== u[0] && u.unshift(o), n[o];
                            })(v, T, n)),
                        !i && -1 < S.inArray("script", v.dataTypes) && (v.converters["text script"] = function () {}),
                        (s = (function (e, t, n, r) {
                            var i,
                                o,
                                a,
                                s,
                                u,
                                l = {},
                                c = e.dataTypes.slice();
                            if (c[1])
                                for (a in e.converters) {
                                    l[a.toLowerCase()] = e.converters[a];
                                }
                            o = c.shift();
                            while (o) {
                                if (
                                    (e.responseFields[o] && (n[e.responseFields[o]] = t),
                                    !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                                    (u = o),
                                    (o = c.shift()))
                                )
                                    if ("*" === o) o = u;
                                    else if ("*" !== u && u !== o) {
                                        if (!(a = l[u + " " + o] || l["* " + o]))
                                            for (i in l) {
                                                if (
                                                    (s = i.split(" "))[1] === o &&
                                                    (a = l[u + " " + s[0]] || l["* " + s[0]])
                                                ) {
                                                    !0 === a
                                                        ? (a = l[i])
                                                        : !0 !== l[i] && ((o = s[0]), c.unshift(s[1]));
                                                    break;
                                                }
                                            }
                                        if (!0 !== a)
                                            if (a && e["throws"]) t = a(t);
                                            else
                                                try {
                                                    t = a(t);
                                                } catch (e) {
                                                    return {
                                                        state: "parsererror",
                                                        error: a ? e : "No conversion from " + u + " to " + o,
                                                    };
                                                }
                                    }
                            }
                            return { state: "success", data: t };
                        })(v, s, T, i)),
                        i
                            ? (v.ifModified &&
                                  ((u = T.getResponseHeader("Last-Modified")) && (S.lastModified[f] = u),
                                  (u = T.getResponseHeader("etag")) && (S.etag[f] = u)),
                              204 === e || "HEAD" === v.type
                                  ? (l = "nocontent")
                                  : 304 === e
                                    ? (l = "notmodified")
                                    : ((l = s.state), (o = s.data), (i = !(a = s.error))))
                            : ((a = l), (!e && l) || ((l = "error"), e < 0 && (e = 0))),
                        (T.status = e),
                        (T.statusText = (t || l) + ""),
                        i ? x.resolveWith(y, [o, l, T]) : x.rejectWith(y, [T, l, a]),
                        T.statusCode(w),
                        (w = void 0),
                        g && m.trigger(i ? "ajaxSuccess" : "ajaxError", [T, v, i ? o : a]),
                        b.fireWith(y, [T, l]),
                        g && (m.trigger("ajaxComplete", [T, v]), --S.active || S.event.trigger("ajaxStop")));
                }
                return T;
            },
            getJSON: function getJSON(e, t, n) {
                return S.get(e, t, n, "json");
            },
            getScript: function getScript(e, t) {
                return S.get(e, void 0, t, "script");
            },
        }),
        S.each(["get", "post"], function (e, i) {
            S[i] = function (e, t, n, r) {
                return (
                    m(t) && ((r = r || n), (n = t), (t = void 0)),
                    S.ajax(S.extend({ url: e, type: i, dataType: r, data: t, success: n }, S.isPlainObject(e) && e))
                );
            };
        }),
        S.ajaxPrefilter(function (e) {
            var t;
            for (t in e.headers) {
                "content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "");
            }
        }),
        (S._evalUrl = function (e, t, n) {
            return S.ajax({
                url: e,
                type: "GET",
                dataType: "script",
                cache: !0,
                async: !1,
                global: !1,
                converters: { "text script": function textScript() {} },
                dataFilter: function dataFilter(e) {
                    S.globalEval(e, t, n);
                },
            });
        }),
        S.fn.extend({
            wrapAll: function wrapAll(e) {
                var t;
                return (
                    this[0] &&
                        (m(e) && (e = e.call(this[0])),
                        (t = S(e, this[0].ownerDocument).eq(0).clone(!0)),
                        this[0].parentNode && t.insertBefore(this[0]),
                        t
                            .map(function () {
                                var e = this;
                                while (e.firstElementChild) {
                                    e = e.firstElementChild;
                                }
                                return e;
                            })
                            .append(this)),
                    this
                );
            },
            wrapInner: function wrapInner(n) {
                return m(n)
                    ? this.each(function (e) {
                          S(this).wrapInner(n.call(this, e));
                      })
                    : this.each(function () {
                          var e = S(this),
                              t = e.contents();
                          t.length ? t.wrapAll(n) : e.append(n);
                      });
            },
            wrap: function wrap(t) {
                var n = m(t);
                return this.each(function (e) {
                    S(this).wrapAll(n ? t.call(this, e) : t);
                });
            },
            unwrap: function unwrap(e) {
                return (
                    this.parent(e)
                        .not("body")
                        .each(function () {
                            S(this).replaceWith(this.childNodes);
                        }),
                    this
                );
            },
        }),
        (S.expr.pseudos.hidden = function (e) {
            return !S.expr.pseudos.visible(e);
        }),
        (S.expr.pseudos.visible = function (e) {
            return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
        }),
        (S.ajaxSettings.xhr = function () {
            try {
                return new C.XMLHttpRequest();
            } catch (e) {}
        });
    var _t = { 0: 200, 1223: 204 },
        zt = S.ajaxSettings.xhr();
    (y.cors = !!zt && "withCredentials" in zt),
        (y.ajax = zt = !!zt),
        S.ajaxTransport(function (i) {
            var _o, a;
            if (y.cors || (zt && !i.crossDomain))
                return {
                    send: function send(e, t) {
                        var n,
                            r = i.xhr();
                        if ((r.open(i.type, i.url, i.async, i.username, i.password), i.xhrFields))
                            for (n in i.xhrFields) {
                                r[n] = i.xhrFields[n];
                            }
                        for (n in (i.mimeType && r.overrideMimeType && r.overrideMimeType(i.mimeType),
                        i.crossDomain || e["X-Requested-With"] || (e["X-Requested-With"] = "XMLHttpRequest"),
                        e)) {
                            r.setRequestHeader(n, e[n]);
                        }
                        (_o = function o(e) {
                            return function () {
                                _o &&
                                    ((_o =
                                        a =
                                        r.onload =
                                        r.onerror =
                                        r.onabort =
                                        r.ontimeout =
                                        r.onreadystatechange =
                                            null),
                                    "abort" === e
                                        ? r.abort()
                                        : "error" === e
                                          ? "number" != typeof r.status
                                              ? t(0, "error")
                                              : t(r.status, r.statusText)
                                          : t(
                                                _t[r.status] || r.status,
                                                r.statusText,
                                                "text" !== (r.responseType || "text") ||
                                                    "string" != typeof r.responseText
                                                    ? { binary: r.response }
                                                    : { text: r.responseText },
                                                r.getAllResponseHeaders()
                                            ));
                            };
                        }),
                            (r.onload = _o()),
                            (a = r.onerror = r.ontimeout = _o("error")),
                            void 0 !== r.onabort
                                ? (r.onabort = a)
                                : (r.onreadystatechange = function () {
                                      4 === r.readyState &&
                                          C.setTimeout(function () {
                                              _o && a();
                                          });
                                  }),
                            (_o = _o("abort"));
                        try {
                            r.send((i.hasContent && i.data) || null);
                        } catch (e) {
                            if (_o) throw e;
                        }
                    },
                    abort: function abort() {
                        _o && _o();
                    },
                };
        }),
        S.ajaxPrefilter(function (e) {
            e.crossDomain && (e.contents.script = !1);
        }),
        S.ajaxSetup({
            accepts: {
                script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
            },
            contents: { script: /\b(?:java|ecma)script\b/ },
            converters: {
                "text script": function textScript(e) {
                    return S.globalEval(e), e;
                },
            },
        }),
        S.ajaxPrefilter("script", function (e) {
            void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
        }),
        S.ajaxTransport("script", function (n) {
            var r, _i;
            if (n.crossDomain || n.scriptAttrs)
                return {
                    send: function send(e, t) {
                        (r = S("<script>")
                            .attr(n.scriptAttrs || {})
                            .prop({ charset: n.scriptCharset, src: n.url })
                            .on(
                                "load error",
                                (_i = function i(e) {
                                    r.remove(), (_i = null), e && t("error" === e.type ? 404 : 200, e.type);
                                })
                            )),
                            E.head.appendChild(r[0]);
                    },
                    abort: function abort() {
                        _i && _i();
                    },
                };
        });
    var Ut,
        Xt = [],
        Vt = /(=)\?(?=&|$)|\?\?/;
    S.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function jsonpCallback() {
            var e = Xt.pop() || S.expando + "_" + Ct.guid++;
            return (this[e] = !0), e;
        },
    }),
        S.ajaxPrefilter("json jsonp", function (e, t, n) {
            var r,
                i,
                o,
                a =
                    !1 !== e.jsonp &&
                    (Vt.test(e.url)
                        ? "url"
                        : "string" == typeof e.data &&
                          0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") &&
                          Vt.test(e.data) &&
                          "data");
            if (a || "jsonp" === e.dataTypes[0])
                return (
                    (r = e.jsonpCallback = m(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
                    a
                        ? (e[a] = e[a].replace(Vt, "$1" + r))
                        : !1 !== e.jsonp && (e.url += (Et.test(e.url) ? "&" : "?") + e.jsonp + "=" + r),
                    (e.converters["script json"] = function () {
                        return o || S.error(r + " was not called"), o[0];
                    }),
                    (e.dataTypes[0] = "json"),
                    (i = C[r]),
                    (C[r] = function () {
                        o = arguments;
                    }),
                    n.always(function () {
                        void 0 === i ? S(C).removeProp(r) : (C[r] = i),
                            e[r] && ((e.jsonpCallback = t.jsonpCallback), Xt.push(r)),
                            o && m(i) && i(o[0]),
                            (o = i = void 0);
                    }),
                    "script"
                );
        }),
        (y.createHTMLDocument =
            (((Ut = E.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>"),
            2 === Ut.childNodes.length)),
        (S.parseHTML = function (e, t, n) {
            return "string" != typeof e
                ? []
                : ("boolean" == typeof t && ((n = t), (t = !1)),
                  t ||
                      (y.createHTMLDocument
                          ? (((r = (t = E.implementation.createHTMLDocument("")).createElement("base")).href =
                                E.location.href),
                            t.head.appendChild(r))
                          : (t = E)),
                  (o = !n && []),
                  (i = N.exec(e))
                      ? [t.createElement(i[1])]
                      : ((i = xe([e], t, o)), o && o.length && S(o).remove(), S.merge([], i.childNodes)));
            var r, i, o;
        }),
        (S.fn.load = function (e, t, n) {
            var r,
                i,
                o,
                a = this,
                s = e.indexOf(" ");
            return (
                -1 < s && ((r = vt(e.slice(s))), (e = e.slice(0, s))),
                m(t) ? ((n = t), (t = void 0)) : t && "object" == _typeof(t) && (i = "POST"),
                0 < a.length &&
                    S.ajax({ url: e, type: i || "GET", dataType: "html", data: t })
                        .done(function (e) {
                            (o = arguments), a.html(r ? S("<div>").append(S.parseHTML(e)).find(r) : e);
                        })
                        .always(
                            n &&
                                function (e, t) {
                                    a.each(function () {
                                        n.apply(this, o || [e.responseText, t, e]);
                                    });
                                }
                        ),
                this
            );
        }),
        (S.expr.pseudos.animated = function (t) {
            return S.grep(S.timers, function (e) {
                return t === e.elem;
            }).length;
        }),
        (S.offset = {
            setOffset: function setOffset(e, t, n) {
                var r,
                    i,
                    o,
                    a,
                    s,
                    u,
                    l = S.css(e, "position"),
                    c = S(e),
                    f = {};
                "static" === l && (e.style.position = "relative"),
                    (s = c.offset()),
                    (o = S.css(e, "top")),
                    (u = S.css(e, "left")),
                    ("absolute" === l || "fixed" === l) && -1 < (o + u).indexOf("auto")
                        ? ((a = (r = c.position()).top), (i = r.left))
                        : ((a = parseFloat(o) || 0), (i = parseFloat(u) || 0)),
                    m(t) && (t = t.call(e, n, S.extend({}, s))),
                    null != t.top && (f.top = t.top - s.top + a),
                    null != t.left && (f.left = t.left - s.left + i),
                    "using" in t
                        ? t.using.call(e, f)
                        : ("number" == typeof f.top && (f.top += "px"),
                          "number" == typeof f.left && (f.left += "px"),
                          c.css(f));
            },
        }),
        S.fn.extend({
            offset: function offset(t) {
                if (arguments.length)
                    return void 0 === t
                        ? this
                        : this.each(function (e) {
                              S.offset.setOffset(this, t, e);
                          });
                var e,
                    n,
                    r = this[0];
                return r
                    ? r.getClientRects().length
                        ? ((e = r.getBoundingClientRect()),
                          (n = r.ownerDocument.defaultView),
                          { top: e.top + n.pageYOffset, left: e.left + n.pageXOffset })
                        : { top: 0, left: 0 }
                    : void 0;
            },
            position: function position() {
                if (this[0]) {
                    var e,
                        t,
                        n,
                        r = this[0],
                        i = { top: 0, left: 0 };
                    if ("fixed" === S.css(r, "position")) t = r.getBoundingClientRect();
                    else {
                        (t = this.offset()), (n = r.ownerDocument), (e = r.offsetParent || n.documentElement);
                        while (e && (e === n.body || e === n.documentElement) && "static" === S.css(e, "position")) {
                            e = e.parentNode;
                        }
                        e &&
                            e !== r &&
                            1 === e.nodeType &&
                            (((i = S(e).offset()).top += S.css(e, "borderTopWidth", !0)),
                            (i.left += S.css(e, "borderLeftWidth", !0)));
                    }
                    return {
                        top: t.top - i.top - S.css(r, "marginTop", !0),
                        left: t.left - i.left - S.css(r, "marginLeft", !0),
                    };
                }
            },
            offsetParent: function offsetParent() {
                return this.map(function () {
                    var e = this.offsetParent;
                    while (e && "static" === S.css(e, "position")) {
                        e = e.offsetParent;
                    }
                    return e || re;
                });
            },
        }),
        S.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (t, i) {
            var o = "pageYOffset" === i;
            S.fn[t] = function (e) {
                return $(
                    this,
                    function (e, t, n) {
                        var r;
                        if ((x(e) ? (r = e) : 9 === e.nodeType && (r = e.defaultView), void 0 === n))
                            return r ? r[i] : e[t];
                        r ? r.scrollTo(o ? r.pageXOffset : n, o ? n : r.pageYOffset) : (e[t] = n);
                    },
                    t,
                    e,
                    arguments.length
                );
            };
        }),
        S.each(["top", "left"], function (e, n) {
            S.cssHooks[n] = $e(y.pixelPosition, function (e, t) {
                if (t) return (t = Be(e, n)), Me.test(t) ? S(e).position()[n] + "px" : t;
            });
        }),
        S.each({ Height: "height", Width: "width" }, function (a, s) {
            S.each({ padding: "inner" + a, content: s, "": "outer" + a }, function (r, o) {
                S.fn[o] = function (e, t) {
                    var n = arguments.length && (r || "boolean" != typeof e),
                        i = r || (!0 === e || !0 === t ? "margin" : "border");
                    return $(
                        this,
                        function (e, t, n) {
                            var r;
                            return x(e)
                                ? 0 === o.indexOf("outer")
                                    ? e["inner" + a]
                                    : e.document.documentElement["client" + a]
                                : 9 === e.nodeType
                                  ? ((r = e.documentElement),
                                    Math.max(
                                        e.body["scroll" + a],
                                        r["scroll" + a],
                                        e.body["offset" + a],
                                        r["offset" + a],
                                        r["client" + a]
                                    ))
                                  : void 0 === n
                                    ? S.css(e, t, i)
                                    : S.style(e, t, n, i);
                        },
                        s,
                        n ? e : void 0,
                        n
                    );
                };
            });
        }),
        S.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
            S.fn[t] = function (e) {
                return this.on(t, e);
            };
        }),
        S.fn.extend({
            bind: function bind(e, t, n) {
                return this.on(e, null, t, n);
            },
            unbind: function unbind(e, t) {
                return this.off(e, null, t);
            },
            delegate: function delegate(e, t, n, r) {
                return this.on(t, e, n, r);
            },
            undelegate: function undelegate(e, t, n) {
                return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
            },
            hover: function hover(e, t) {
                return this.mouseenter(e).mouseleave(t || e);
            },
        }),
        S.each(
            "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
                " "
            ),
            function (e, n) {
                S.fn[n] = function (e, t) {
                    return 0 < arguments.length ? this.on(n, null, e, t) : this.trigger(n);
                };
            }
        );
    var Gt = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    (S.proxy = function (e, t) {
        var n, r, i;
        if (("string" == typeof t && ((n = e[t]), (t = e), (e = n)), m(e)))
            return (
                (r = s.call(arguments, 2)),
                ((i = function i() {
                    return e.apply(t || this, r.concat(s.call(arguments)));
                }).guid = e.guid =
                    e.guid || S.guid++),
                i
            );
    }),
        (S.holdReady = function (e) {
            e ? S.readyWait++ : S.ready(!0);
        }),
        (S.isArray = Array.isArray),
        (S.parseJSON = JSON.parse),
        (S.nodeName = A),
        (S.isFunction = m),
        (S.isWindow = x),
        (S.camelCase = X),
        (S.type = w),
        (S.now = Date.now),
        (S.isNumeric = function (e) {
            var t = S.type(e);
            return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
        }),
        (S.trim = function (e) {
            return null == e ? "" : (e + "").replace(Gt, "");
        }),
        "function" == typeof define &&
            define.amd &&
            define("jquery", [], function () {
                return S;
            });
    var Yt = C.jQuery,
        Qt = C.$;
    return (
        (S.noConflict = function (e) {
            return C.$ === S && (C.$ = Qt), e && C.jQuery === S && (C.jQuery = Yt), S;
        }),
        "undefined" == typeof e && (C.jQuery = C.$ = S),
        S
    );
});
theme.jQuery = $;

(function ($) {
    var $ = (jQuery = $);
    var define = null;

    /*! lazysizes - v4.0.1 */
    !(function (a, b) {
        var c = b(a, a.document);
        (a.lazySizes = c),
            "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) &&
                module.exports &&
                (module.exports = c);
    })(window, function (a, b) {
        "use strict";
        if (b.getElementsByClassName) {
            var c,
                d,
                e = b.documentElement,
                f = a.Date,
                g = a.HTMLPictureElement,
                h = "addEventListener",
                i = "getAttribute",
                j = a[h],
                k = a.setTimeout,
                l = a.requestAnimationFrame || k,
                m = a.requestIdleCallback,
                n = /^picture$/i,
                o = ["load", "error", "lazyincluded", "_lazyloaded"],
                p = {},
                q = Array.prototype.forEach,
                r = function r(a, b) {
                    return (
                        p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b]
                    );
                },
                s = function s(a, b) {
                    r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b);
                },
                t = function t(a, b) {
                    var c;
                    (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " "));
                },
                u = function u(a, b, c) {
                    var d = c ? h : "removeEventListener";
                    c && u(a, b),
                        o.forEach(function (c) {
                            a[d](c, b);
                        });
                },
                v = function v(a, d, e, f, g) {
                    var h = b.createEvent("CustomEvent");
                    return e || (e = {}), (e.instance = c), h.initCustomEvent(d, !f, !g, e), a.dispatchEvent(h), h;
                },
                w = function w(b, c) {
                    var e;
                    !g && (e = a.picturefill || d.pf)
                        ? e({ reevaluate: !0, elements: [b] })
                        : c && c.src && (b.src = c.src);
                },
                x = function x(a, b) {
                    return (getComputedStyle(a, null) || {})[b];
                },
                y = function y(a, b, c) {
                    for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth; ) {
                        (c = b.offsetWidth), (b = b.parentNode);
                    }
                    return c;
                },
                z = (function () {
                    var a,
                        c,
                        d = [],
                        e = [],
                        f = d,
                        g = function g() {
                            var b = f;
                            for (f = d.length ? e : d, a = !0, c = !1; b.length; ) {
                                b.shift()();
                            }
                            a = !1;
                        },
                        h = function h(d, e) {
                            a && !e ? d.apply(this, arguments) : (f.push(d), c || ((c = !0), (b.hidden ? k : l)(g)));
                        };
                    return (h._lsFlush = g), h;
                })(),
                A = function A(a, b) {
                    return b
                        ? function () {
                              z(a);
                          }
                        : function () {
                              var b = this,
                                  c = arguments;
                              z(function () {
                                  a.apply(b, c);
                              });
                          };
                },
                B = function B(a) {
                    var b,
                        c = 0,
                        e = 125,
                        g = d.ricTimeout,
                        h = function h() {
                            (b = !1), (c = f.now()), a();
                        },
                        i =
                            m && d.ricTimeout
                                ? function () {
                                      m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout);
                                  }
                                : A(function () {
                                      k(h);
                                  }, !0);
                    return function (a) {
                        var d;
                        (a = a === !0) && (g = 33),
                            b ||
                                ((b = !0),
                                (d = e - (f.now() - c)),
                                0 > d && (d = 0),
                                a || (9 > d && m) ? i() : k(i, d));
                    };
                },
                C = function C(a) {
                    var b,
                        c,
                        d = 99,
                        e = function e() {
                            (b = null), a();
                        },
                        g = function g() {
                            var a = f.now() - c;
                            d > a ? k(g, d - a) : (m || e)(e);
                        };
                    return function () {
                        (c = f.now()), b || (b = k(g, d));
                    };
                };
            !(function () {
                var b,
                    c = {
                        lazyClass: "lazyload",
                        loadedClass: "lazyloaded",
                        loadingClass: "lazyloading",
                        preloadClass: "lazypreload",
                        errorClass: "lazyerror",
                        autosizesClass: "lazyautosizes",
                        srcAttr: "data-src",
                        srcsetAttr: "data-srcset",
                        sizesAttr: "data-sizes",
                        minSize: 40,
                        customMedia: {},
                        init: !0,
                        expFactor: 1.5,
                        hFac: 0.8,
                        loadMode: 2,
                        loadHidden: !0,
                        ricTimeout: 300,
                    };
                d = a.lazySizesConfig || a.lazysizesConfig || {};
                for (b in c) {
                    b in d || (d[b] = c[b]);
                }
                (a.lazySizesConfig = d),
                    k(function () {
                        d.init && F();
                    });
            })();
            var D = (function () {
                    var g,
                        l,
                        m,
                        o,
                        p,
                        y,
                        D,
                        F,
                        G,
                        H,
                        I,
                        J,
                        K,
                        L,
                        M = /^img$/i,
                        N = /^iframe$/i,
                        O = "onscroll" in a && !/glebot/.test(navigator.userAgent),
                        P = 0,
                        Q = 0,
                        R = 0,
                        S = -1,
                        T = function T(a) {
                            R--, a && a.target && u(a.target, T), (!a || 0 > R || !a.target) && (R = 0);
                        },
                        U = function U(a, c) {
                            var d,
                                f = a,
                                g = "hidden" == x(b.body, "visibility") || "hidden" != x(a, "visibility");
                            for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e; ) {
                                (g = (x(f, "opacity") || 1) > 0),
                                    g &&
                                        "visible" != x(f, "overflow") &&
                                        ((d = f.getBoundingClientRect()),
                                        (g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1));
                            }
                            return g;
                        },
                        V = function V() {
                            var a,
                                f,
                                h,
                                j,
                                k,
                                m,
                                n,
                                p,
                                q,
                                r = c.elements;
                            if ((o = d.loadMode) && 8 > R && (a = r.length)) {
                                (f = 0),
                                    S++,
                                    null == K &&
                                        ("expand" in d ||
                                            (d.expand = e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370),
                                        (J = d.expand),
                                        (K = J * d.expFactor)),
                                    K > Q && 1 > R && S > 2 && o > 2 && !b.hidden
                                        ? ((Q = K), (S = 0))
                                        : (Q = o > 1 && S > 1 && 6 > R ? J : P);
                                for (; a > f; f++) {
                                    if (r[f] && !r[f]._lazyRace)
                                        if (O) {
                                            if (
                                                (((p = r[f][i]("data-expand")) && (m = 1 * p)) || (m = Q),
                                                q !== m &&
                                                    ((y = innerWidth + m * L),
                                                    (D = innerHeight + m),
                                                    (n = -1 * m),
                                                    (q = m)),
                                                (h = r[f].getBoundingClientRect()),
                                                (I = h.bottom) >= n &&
                                                    (F = h.top) <= D &&
                                                    (H = h.right) >= n * L &&
                                                    (G = h.left) <= y &&
                                                    (I || H || G || F) &&
                                                    (d.loadHidden || "hidden" != x(r[f], "visibility")) &&
                                                    ((l && 3 > R && !p && (3 > o || 4 > S)) || U(r[f], m)))
                                            ) {
                                                if ((ba(r[f]), (k = !0), R > 9)) break;
                                            } else
                                                !k &&
                                                    l &&
                                                    !j &&
                                                    4 > R &&
                                                    4 > S &&
                                                    o > 2 &&
                                                    (g[0] || d.preloadAfterLoad) &&
                                                    (g[0] ||
                                                        (!p && (I || H || G || F || "auto" != r[f][i](d.sizesAttr)))) &&
                                                    (j = g[0] || r[f]);
                                        } else ba(r[f]);
                                }
                                j && !k && ba(j);
                            }
                        },
                        W = B(V),
                        X = function X(a) {
                            s(a.target, d.loadedClass),
                                t(a.target, d.loadingClass),
                                u(a.target, Z),
                                v(a.target, "lazyloaded");
                        },
                        Y = A(X),
                        Z = function Z(a) {
                            Y({ target: a.target });
                        },
                        $ = function $(a, b) {
                            try {
                                a.contentWindow.location.replace(b);
                            } catch (c) {
                                a.src = b;
                            }
                        },
                        _ = function _(a) {
                            var b,
                                c = a[i](d.srcsetAttr);
                            (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b),
                                c && a.setAttribute("srcset", c);
                        },
                        aa = A(function (a, b, c, e, f) {
                            var g, h, j, l, o, p;
                            (o = v(a, "lazybeforeunveil", b)).defaultPrevented ||
                                (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)),
                                (h = a[i](d.srcsetAttr)),
                                (g = a[i](d.srcAttr)),
                                f && ((j = a.parentNode), (l = j && n.test(j.nodeName || ""))),
                                (p = b.firesLoad || ("src" in a && (h || g || l))),
                                (o = { target: a }),
                                p &&
                                    (u(a, T, !0), clearTimeout(m), (m = k(T, 2500)), s(a, d.loadingClass), u(a, Z, !0)),
                                l && q.call(j.getElementsByTagName("source"), _),
                                h
                                    ? a.setAttribute("srcset", h)
                                    : g && !l && (N.test(a.nodeName) ? $(a, g) : (a.src = g)),
                                f && (h || l) && w(a, { src: g })),
                                a._lazyRace && delete a._lazyRace,
                                t(a, d.lazyClass),
                                z(function () {
                                    (!p || (a.complete && a.naturalWidth > 1)) && (p ? T(o) : R--, X(o));
                                }, !0);
                        }),
                        ba = function ba(a) {
                            var b,
                                c = M.test(a.nodeName),
                                e = c && (a[i](d.sizesAttr) || a[i]("sizes")),
                                f = "auto" == e;
                            ((!f && l) ||
                                !c ||
                                (!a[i]("src") && !a.srcset) ||
                                a.complete ||
                                r(a, d.errorClass) ||
                                !r(a, d.lazyClass)) &&
                                ((b = v(a, "lazyunveilread").detail),
                                f && E.updateElem(a, !0, a.offsetWidth),
                                (a._lazyRace = !0),
                                R++,
                                aa(a, b, f, e, c));
                        },
                        ca = function ca() {
                            if (!l) {
                                if (f.now() - p < 999) return void k(ca, 999);
                                var a = C(function () {
                                    (d.loadMode = 3), W();
                                });
                                (l = !0),
                                    (d.loadMode = 3),
                                    W(),
                                    j(
                                        "scroll",
                                        function () {
                                            3 == d.loadMode && (d.loadMode = 2), a();
                                        },
                                        !0
                                    );
                            }
                        };
                    return {
                        _: function _() {
                            (p = f.now()),
                                (c.elements = b.getElementsByClassName(d.lazyClass)),
                                (g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass)),
                                (L = d.hFac),
                                j("scroll", W, !0),
                                j("resize", W, !0),
                                a.MutationObserver
                                    ? new MutationObserver(W).observe(e, { childList: !0, subtree: !0, attributes: !0 })
                                    : (e[h]("DOMNodeInserted", W, !0),
                                      e[h]("DOMAttrModified", W, !0),
                                      setInterval(W, 999)),
                                j("hashchange", W, !0),
                                [
                                    "focus",
                                    "mouseover",
                                    "click",
                                    "load",
                                    "transitionend",
                                    "animationend",
                                    "webkitAnimationEnd",
                                ].forEach(function (a) {
                                    b[h](a, W, !0);
                                }),
                                /d$|^c/.test(b.readyState)
                                    ? ca()
                                    : (j("load", ca), b[h]("DOMContentLoaded", W), k(ca, 2e4)),
                                c.elements.length ? (V(), z._lsFlush()) : W();
                        },
                        checkElems: W,
                        unveil: ba,
                    };
                })(),
                E = (function () {
                    var a,
                        c = A(function (a, b, c, d) {
                            var e, f, g;
                            if (
                                ((a._lazysizesWidth = d),
                                (d += "px"),
                                a.setAttribute("sizes", d),
                                n.test(b.nodeName || ""))
                            )
                                for (e = b.getElementsByTagName("source"), f = 0, g = e.length; g > f; f++) {
                                    e[f].setAttribute("sizes", d);
                                }
                            c.detail.dataAttr || w(a, c.detail);
                        }),
                        e = function e(a, b, d) {
                            var e,
                                f = a.parentNode;
                            f &&
                                ((d = y(a, f, d)),
                                (e = v(a, "lazybeforesizes", { width: d, dataAttr: !!b })),
                                e.defaultPrevented ||
                                    ((d = e.detail.width), d && d !== a._lazysizesWidth && c(a, f, e, d)));
                        },
                        f = function f() {
                            var b,
                                c = a.length;
                            if (c)
                                for (b = 0; c > b; b++) {
                                    e(a[b]);
                                }
                        },
                        g = C(f);
                    return {
                        _: function _() {
                            (a = b.getElementsByClassName(d.autosizesClass)), j("resize", g);
                        },
                        checkElems: g,
                        updateElem: e,
                    };
                })(),
                F = function F() {
                    F.i || ((F.i = !0), E._(), D._());
                };
            return (c = {
                cfg: d,
                autoSizer: E,
                loader: D,
                init: F,
                uP: w,
                aC: s,
                rC: t,
                hC: r,
                fire: v,
                gW: y,
                rAF: z,
            });
        }
    });
    /*! lazysizes - rias */
    !(function (a, b) {
        var c = function c() {
            b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0);
        };
        (b = b.bind(null, a, a.document)),
            "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports
                ? b(require("lazysizes"))
                : a.lazySizes
                  ? c()
                  : a.addEventListener("lazyunveilread", c, !0);
    })(window, function (a, b, c) {
        "use strict";
        function d(b, c) {
            var d,
                e,
                f,
                g,
                h = a.getComputedStyle(b);
            (e = b.parentNode),
                (g = { isPicture: !(!e || !m.test(e.nodeName || "")) }),
                (f = function f(a, c) {
                    var d = b.getAttribute("data-" + a);
                    if (!d) {
                        var e = h.getPropertyValue("--ls-" + a);
                        e && (d = e.trim());
                    }
                    if (d) {
                        if ("true" == d) d = !0;
                        else if ("false" == d) d = !1;
                        else if (l.test(d)) d = parseFloat(d);
                        else if ("function" == typeof j[a]) d = j[a](b, d);
                        else if (q.test(d))
                            try {
                                d = JSON.parse(d);
                            } catch (f) {}
                        g[a] = d;
                    } else
                        a in j && "function" != typeof j[a]
                            ? (g[a] = j[a])
                            : c && "function" == typeof j[a] && (g[a] = j[a](b, d));
                });
            for (d in j) {
                f(d);
            }
            return (
                c.replace(p, function (a, b) {
                    b in g || f(b, !0);
                }),
                g
            );
        }
        function e(a, b) {
            var c = [],
                d = function d(a, c) {
                    return k[_typeof(b[c])] ? b[c] : a;
                };
            return (
                (c.srcset = []),
                b.absUrl && (s.setAttribute("href", a), (a = s.href)),
                (a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d)),
                b.widths.forEach(function (d) {
                    var e = b.widthmap[d] || d,
                        f = { u: a.replace(n, e).replace(o, b.ratio ? Math.round(d * b.ratio) : ""), w: d };
                    c.push(f), c.srcset.push((f.c = f.u + " " + d + "w"));
                }),
                c
            );
        }
        function f(a, c, d) {
            var f = 0,
                g = 0,
                h = d;
            if (a) {
                if ("container" === c.ratio) {
                    for (f = h.scrollWidth, g = h.scrollHeight; !((f && g) || h === b); ) {
                        (h = h.parentNode), (f = h.scrollWidth), (g = h.scrollHeight);
                    }
                    f && g && (c.ratio = g / f);
                }
                (a = e(a, c)),
                    (a.isPicture = c.isPicture),
                    u && "IMG" == d.nodeName.toUpperCase()
                        ? d.removeAttribute(i.srcsetAttr)
                        : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")),
                    Object.defineProperty(d, "_lazyrias", { value: a, writable: !0 });
            }
        }
        function g(a, b) {
            var e = d(a, b);
            return (
                j.modifyOptions.call(a, { target: a, details: e, detail: e }), c.fire(a, "lazyriasmodifyoptions", e), e
            );
        }
        function h(a) {
            return (
                a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) ||
                a.getAttribute(i.srcsetAttr) ||
                a.getAttribute(i.srcAttr) ||
                a.getAttribute("data-pfsrcset") ||
                ""
            );
        }
        var i,
            j,
            k = { string: 1, number: 1 },
            l = /^\-*\+*\d+\.*\d*$/,
            m = /^picture$/i,
            n = /\s*\{\s*width\s*\}\s*/i,
            o = /\s*\{\s*height\s*\}\s*/i,
            p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
            q = /^\[.*\]|\{.*\}$/,
            r = /^(?:auto|\d+(px)?)$/,
            s = b.createElement("a"),
            t = b.createElement("img"),
            u = "srcset" in t && !("sizes" in t),
            v = !!a.HTMLPictureElement && !u;
        !(function () {
            var b,
                d = function d() {},
                e = {
                    prefix: "",
                    postfix: "",
                    srcAttr: "data-src",
                    absUrl: !1,
                    modifyOptions: d,
                    widthmap: {},
                    ratio: !1,
                };
            (i = (c && c.cfg) || a.lazySizesConfig),
                i || ((i = {}), (a.lazySizesConfig = i)),
                i.supportsType ||
                    (i.supportsType = function (a) {
                        return !a;
                    }),
                i.rias || (i.rias = {}),
                (j = i.rias),
                "widths" in j ||
                    ((j.widths = []),
                    (function (a) {
                        for (var b, c = 0; !b || 3e3 > b; ) {
                            (c += 5), c > 30 && (c += 1), (b = 36 * c), a.push(b);
                        }
                    })(j.widths));
            for (b in e) {
                b in j || (j[b] = e[b]);
            }
        })(),
            addEventListener(
                "lazybeforesizes",
                function (a) {
                    if (a.detail.instance == c) {
                        var b, d, e, k, l, m, o, p, q, s, t, u, x;
                        if (
                            ((b = a.target),
                            a.detail.dataAttr &&
                                !a.defaultPrevented &&
                                !j.disabled &&
                                (q = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) &&
                                r.test(q))
                        ) {
                            if (
                                ((d = h(b)),
                                (e = g(b, d)),
                                (t = n.test(e.prefix) || n.test(e.postfix)),
                                e.isPicture && (k = b.parentNode))
                            )
                                for (l = k.getElementsByTagName("source"), m = 0, o = l.length; o > m; m++) {
                                    (t || n.test((p = h(l[m])))) && (f(p, e, l[m]), (u = !0));
                                }
                            t || n.test(d)
                                ? (f(d, e, b), (u = !0))
                                : u &&
                                  ((x = []),
                                  (x.srcset = []),
                                  (x.isPicture = !0),
                                  Object.defineProperty(b, "_lazyrias", { value: x, writable: !0 })),
                                u &&
                                    (v
                                        ? b.removeAttribute(i.srcAttr)
                                        : "auto" != q &&
                                          ((s = { width: parseInt(q, 10) }), w({ target: b, detail: s })));
                        }
                    }
                },
                !0
            );
        var w = (function () {
            var d = function d(a, b) {
                    return a.w - b.w;
                },
                e = function e(a) {
                    var b,
                        c,
                        d = a.length,
                        e = a[d - 1],
                        f = 0;
                    for (f; d > f; f++) {
                        if (((e = a[f]), (e.d = e.w / a.w), e.d >= a.d)) {
                            !e.cached &&
                                (b = a[f - 1]) &&
                                b.d > a.d - 0.13 * Math.pow(a.d, 2.2) &&
                                ((c = Math.pow(b.d - 0.6, 1.6)),
                                b.cached && (b.d += 0.15 * c),
                                b.d + (e.d - a.d) * c > a.d && (e = b));
                            break;
                        }
                    }
                    return e;
                },
                f = function f(a, b) {
                    var d;
                    return (
                        !a._lazyrias &&
                            c.pWS &&
                            (d = c.pWS(a.getAttribute(i.srcsetAttr || ""))).length &&
                            (Object.defineProperty(a, "_lazyrias", { value: d, writable: !0 }),
                            b && a.parentNode && (d.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase())),
                        a._lazyrias
                    );
                },
                g = function g(b) {
                    var d = a.devicePixelRatio || 1,
                        e = c.getX && c.getX(b);
                    return Math.min(e || d, 2.4, d);
                },
                h = function h(b, c) {
                    var h, i, j, k, l, m;
                    if (((l = b._lazyrias), l.isPicture && a.matchMedia))
                        for (i = 0, h = b.parentNode.getElementsByTagName("source"), j = h.length; j > i; i++) {
                            if (
                                f(h[i]) &&
                                !h[i].getAttribute("type") &&
                                (!(k = h[i].getAttribute("media")) || (matchMedia(k) || {}).matches)
                            ) {
                                l = h[i]._lazyrias;
                                break;
                            }
                        }
                    return (!l.w || l.w < c) && ((l.w = c), (l.d = g(b)), (m = e(l.sort(d)))), m;
                },
                _j = function j(d) {
                    if (d.detail.instance == c) {
                        var e,
                            g = d.target;
                        return !u && (a.respimage || a.picturefill || lazySizesConfig.pf)
                            ? void b.removeEventListener("lazybeforesizes", _j)
                            : void (
                                  ("_lazyrias" in g || (d.detail.dataAttr && f(g, !0))) &&
                                  ((e = h(g, d.detail.width)),
                                  e &&
                                      e.u &&
                                      g._lazyrias.cur != e.u &&
                                      ((g._lazyrias.cur = e.u),
                                      (e.cached = !0),
                                      c.rAF(function () {
                                          g.setAttribute(i.srcAttr, e.u), g.setAttribute("src", e.u);
                                      })))
                              );
                    }
                };
            return v ? (_j = function _j() {}) : addEventListener("lazybeforesizes", _j), _j;
        })();
    });
    /* lazysizes - optimumx */
    !(function (a, b, c) {
        "use strict";
        if (a.addEventListener) {
            var d,
                e = /^picture$/i,
                f = b.documentElement,
                g = (function () {
                    var a,
                        b = /(([^,\s].[^\s]+)\s+(\d+)(w|h)(\s+(\d+)(w|h))?)/g,
                        c = function c(b, _c, d, e, f, g, h, i) {
                            a.push({ c: _c, u: d, w: 1 * ("w" == i ? h : e) });
                        };
                    return function (d) {
                        return (a = []), d.replace(b, c), a;
                    };
                })(),
                h = (function () {
                    var a = function a(_a, b) {
                            return _a.w - b.w;
                        },
                        b = function b(_b, c) {
                            var d = { srcset: _b.getAttribute(lazySizes.cfg.srcsetAttr) || "" },
                                e = g(d.srcset);
                            return (
                                Object.defineProperty(_b, c, { value: d, writable: !0 }),
                                (d.cands = e),
                                (d.index = 0),
                                (d.dirty = !1),
                                e[0] && e[0].w
                                    ? (e.sort(a), (d.cSrcset = [e[d.index].c]))
                                    : ((d.cSrcset = d.srcset ? [d.srcset] : []), (d.cands = [])),
                                d
                            );
                        };
                    return function (a, c) {
                        var d, f, g, h;
                        if (
                            !a[c] &&
                            ((h = a.parentNode || {}), (a[c] = b(a, c)), (a[c].isImg = !0), e.test(h.nodeName || ""))
                        )
                            for (
                                a[c].picture = !0, d = h.getElementsByTagName("source"), f = 0, g = d.length;
                                g > f;
                                f++
                            ) {
                                b(d[f], c).isImg = !1;
                            }
                        return a[c];
                    };
                })(),
                i = {
                    _lazyOptimumx: (function () {
                        var a = function a(_a2, b, c) {
                            var d, e, f;
                            return _a2 && _a2.d
                                ? ((f = c > 0.7 ? 0.6 : 0.4),
                                  _a2.d >= c
                                      ? !1
                                      : ((e = Math.pow(_a2.d - f, 1.6) || 0.1),
                                        0.1 > e ? (e = 0.1) : e > 3 && (e = 3),
                                        (d = _a2.d + (b - c) * e),
                                        c > d))
                                : !0;
                        };
                        return function (b, c, d) {
                            var e, f;
                            for (e = 0; e < b.cands.length; e++) {
                                if (((f = b.cands[e]), (f.d = (f.w || 1) / c), !(b.index >= e))) {
                                    if (!(f.d <= d || a(b.cands[e - 1], f.d, d))) break;
                                    b.cSrcset.push(f.c), (b.index = e);
                                }
                            }
                        };
                    })(),
                },
                j = (function () {
                    var a = function a(_a3, b, c, d, e) {
                        var f,
                            g = _a3[e];
                        g &&
                            ((f = g.index),
                            i[e](g, b, c),
                            (g.dirty && f == g.index) ||
                                (g.cSrcset.join(", "), _a3.setAttribute(d, g.cSrcset.join(", ")), (g.dirty = !0)));
                    };
                    return function (b, c, d, e, f) {
                        var g,
                            h,
                            i,
                            j,
                            k = b[f];
                        if (((k.width = c), k.picture && (h = b.parentNode)))
                            for (g = h.getElementsByTagName("source"), j = 0, i = g.length; i > j; j++) {
                                a(g[j], c, d, e, f);
                            }
                        a(b, c, d, e, f);
                    };
                })(),
                k = function k(a) {
                    var b = a.getAttribute("data-optimumx") || a.getAttribute("data-maxdpr");
                    return (
                        !b && d.constrainPixelDensity && (b = "auto"),
                        b && (b = "auto" == b ? d.getOptimumX(a) : parseFloat(b, 10)),
                        b
                    );
                },
                l = function l() {
                    a.lazySizes &&
                        !a.lazySizes.getOptimumX &&
                        ((lazySizes.getX = k), (lazySizes.pWS = g), f.removeEventListener("lazybeforeunveil", l));
                };
            f.addEventListener("lazybeforeunveil", l),
                setTimeout(l),
                (d = (a.lazySizes && lazySizes.cfg) || a.lazySizesConfig),
                d || ((d = {}), (a.lazySizesConfig = d)),
                "function" != typeof d.getOptimumX &&
                    (d.getOptimumX = function () {
                        var b = a.devicePixelRatio || 1;
                        return (
                            b > 2.6 ? (b *= 0.6) : b > 1.9 ? (b *= 0.8) : (b -= 0.01),
                            Math.min(Math.round(100 * b) / 100, 2)
                        );
                    }),
                a.devicePixelRatio &&
                    addEventListener("lazybeforesizes", function (a) {
                        var b,
                            c,
                            e,
                            f,
                            g = a.target,
                            i = a.detail,
                            l = i.dataAttr;
                        a.defaultPrevented ||
                            !(b = k(g)) ||
                            b >= devicePixelRatio ||
                            (!l ||
                                !g._lazyOptimumx ||
                                i.reloaded ||
                                (d.unloadedClass && lazySizes.hC(g, d.unloadedClass)) ||
                                (g._lazyOptimumx = null),
                            (c = h(g, "_lazyOptimumx")),
                            (e = i.width),
                            e &&
                                (c.width || 0) < e &&
                                ((f = l ? lazySizes.cfg.srcsetAttr : "srcset"),
                                lazySizes.rAF(function () {
                                    j(g, e, b, f, "_lazyOptimumx");
                                })));
                    });
        }
    })(window, document);
    /* lazysizes - progressive */
    !(function (a, b) {
        var c = function c() {
            b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0);
        };
        (b = b.bind(null, a, a.document)),
            "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports
                ? b(require("lazysizes"))
                : a.lazySizes
                  ? c()
                  : a.addEventListener("lazyunveilread", c, !0);
    })(window, function (a, b, c) {
        "use strict";
        var d, _e2;
        "srcset" in b.createElement("img") &&
            ((d = /^img$/i),
            (_e2 = function e(a) {
                (a.target.style.backgroundSize = ""),
                    (a.target.style.backgroundImage = ""),
                    a.target.removeEventListener(a.type, _e2);
            }),
            b.addEventListener(
                "lazybeforeunveil",
                function (a) {
                    if (a.detail.instance == c) {
                        var b = a.target;
                        if (d.test(b.nodeName)) {
                            var f = b.getAttribute("src");
                            f &&
                                ((b.style.backgroundSize = "100% 100%"),
                                (b.style.backgroundImage = "url(" + f + ")"),
                                b.removeAttribute("src"),
                                b.addEventListener("load", _e2));
                        }
                    }
                },
                !1
            ));
    });
    /* lazysizes - parent-fit */
    !(function (a, b) {
        var c = function c() {
            b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0);
        };
        (b = b.bind(null, a, a.document)),
            "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports
                ? b(require("lazysizes"))
                : a.lazySizes
                  ? c()
                  : a.addEventListener("lazyunveilread", c, !0);
    })(window, function (a, b, c) {
        "use strict";
        if (a.addEventListener) {
            var d = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
                e = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
                f = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,
                g = /^picture$/i,
                h = function h(a) {
                    return getComputedStyle(a, null) || {};
                },
                i = {
                    getParent: function getParent(b, c) {
                        var d = b,
                            e = b.parentNode;
                        return (
                            (c && "prev" != c) || !e || !g.test(e.nodeName || "") || (e = e.parentNode),
                            "self" != c &&
                                (d =
                                    "prev" == c
                                        ? b.previousElementSibling
                                        : c && (e.closest || a.jQuery)
                                          ? (e.closest ? e.closest(c) : jQuery(e).closest(c)[0]) || e
                                          : e),
                            d
                        );
                    },
                    getFit: function getFit(a) {
                        var b,
                            c,
                            d = h(a),
                            g = d.content || d.fontFamily,
                            j = { fit: a._lazysizesParentFit || a.getAttribute("data-parent-fit") };
                        return (
                            !j.fit && g && (b = g.match(e)) && (j.fit = b[1]),
                            j.fit
                                ? ((c = a._lazysizesParentContainer || a.getAttribute("data-parent-container")),
                                  !c && g && (b = g.match(f)) && (c = b[1]),
                                  (j.parent = i.getParent(a, c)))
                                : (j.fit = d.objectFit),
                            j
                        );
                    },
                    getImageRatio: function getImageRatio(b) {
                        var c,
                            e,
                            f,
                            h,
                            i = b.parentNode,
                            j = i && g.test(i.nodeName || "") ? i.querySelectorAll("source, img") : [b];
                        for (c = 0; c < j.length; c++) {
                            if (
                                ((b = j[c]),
                                (e =
                                    b.getAttribute(lazySizesConfig.srcsetAttr) ||
                                    b.getAttribute("srcset") ||
                                    b.getAttribute("data-pfsrcset") ||
                                    b.getAttribute("data-risrcset") ||
                                    ""),
                                (f = b._lsMedia || b.getAttribute("media")),
                                (f = lazySizesConfig.customMedia[b.getAttribute("data-media") || f] || f),
                                e && (!f || ((a.matchMedia && matchMedia(f)) || {}).matches))
                            ) {
                                (h = parseFloat(b.getAttribute("data-aspectratio"))),
                                    !h &&
                                        e.match(d) &&
                                        (h = "w" == RegExp.$2 ? RegExp.$1 / RegExp.$3 : RegExp.$3 / RegExp.$1);
                                break;
                            }
                        }
                        return h;
                    },
                    calculateSize: function calculateSize(a, b) {
                        var c,
                            d,
                            e,
                            f,
                            g = this.getFit(a),
                            h = g.fit,
                            i = g.parent;
                        return "width" == h || (("contain" == h || "cover" == h) && (e = this.getImageRatio(a)))
                            ? (i ? (b = i.clientWidth) : (i = a),
                              (f = b),
                              "width" == h
                                  ? (f = b)
                                  : ((d = i.clientHeight),
                                    d > 40 &&
                                        (c = b / d) &&
                                        (("cover" == h && e > c) || ("contain" == h && c > e)) &&
                                        (f = b * (e / c))),
                              f)
                            : b;
                    },
                };
            (c.parentFit = i),
                b.addEventListener("lazybeforesizes", function (a) {
                    if (!a.defaultPrevented && a.detail.instance == c) {
                        var b = a.target;
                        a.detail.width = i.calculateSize(b, a.detail.width);
                    }
                });
        }
    });
    /*! lazysizes - respimg */
    !(function (a, b) {
        var c = function c() {
            b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0);
        };
        (b = b.bind(null, a, a.document)),
            "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports
                ? b(require("lazysizes"), require("../fix-ios-sizes/fix-ios-sizes"))
                : a.lazySizes
                  ? c()
                  : a.addEventListener("lazyunveilread", c, !0);
    })(window, function (a, b, c) {
        "use strict";
        var d,
            e = (c && c.cfg) || a.lazySizesConfig,
            f = b.createElement("img"),
            g = "sizes" in f && "srcset" in f,
            h = /\s+\d+h/g,
            i = (function () {
                var a = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
                    c = Array.prototype.forEach;
                return function (d) {
                    var e = b.createElement("img"),
                        f = function f(b) {
                            var c,
                                d,
                                e = b.getAttribute(lazySizesConfig.srcsetAttr);
                            e &&
                                ((d = e.match(a)) &&
                                    ((c = "w" == d[2] ? d[1] / d[3] : d[3] / d[1]),
                                    c && b.setAttribute("data-aspectratio", c)),
                                b.setAttribute(lazySizesConfig.srcsetAttr, e.replace(h, "")));
                        },
                        g = function g(a) {
                            var b = a.target.parentNode;
                            b && "PICTURE" == b.nodeName && c.call(b.getElementsByTagName("source"), f), f(a.target);
                        },
                        i = function i() {
                            e.currentSrc && b.removeEventListener("lazybeforeunveil", g);
                        };
                    d[1] &&
                        (b.addEventListener("lazybeforeunveil", g),
                        (e.onload = i),
                        (e.onerror = i),
                        (e.srcset = "data:,a 1w 1h"),
                        e.complete && i());
                };
            })();
        if (
            (e || ((e = {}), (a.lazySizesConfig = e)),
            e.supportsType ||
                (e.supportsType = function (a) {
                    return !a;
                }),
            !a.picturefill && !e.pf)
        ) {
            if (a.HTMLPictureElement && g)
                return (
                    b.msElementsFromPoint && i(navigator.userAgent.match(/Edge\/(\d+)/)), void (e.pf = function () {})
                );
            (e.pf = function (b) {
                var c, e;
                if (!a.picturefill)
                    for (c = 0, e = b.elements.length; e > c; c++) {
                        d(b.elements[c]);
                    }
            }),
                (d = (function () {
                    var f = function f(a, b) {
                            return a.w - b.w;
                        },
                        i = /^\s*\d+\.*\d*px\s*$/,
                        j = function j(a) {
                            var b,
                                c,
                                d = a.length,
                                e = a[d - 1],
                                f = 0;
                            for (f; d > f; f++) {
                                if (((e = a[f]), (e.d = e.w / a.w), e.d >= a.d)) {
                                    !e.cached &&
                                        (b = a[f - 1]) &&
                                        b.d > a.d - 0.13 * Math.pow(a.d, 2.2) &&
                                        ((c = Math.pow(b.d - 0.6, 1.6)),
                                        b.cached && (b.d += 0.15 * c),
                                        b.d + (e.d - a.d) * c > a.d && (e = b));
                                    break;
                                }
                            }
                            return e;
                        },
                        k = (function () {
                            var a,
                                b = /(([^,\s].[^\s]+)\s+(\d+)w)/g,
                                c = /\s/,
                                d = function d(b, c, _d, e) {
                                    a.push({ c: c, u: _d, w: 1 * e });
                                };
                            return function (e) {
                                return (
                                    (a = []),
                                    (e = e.trim()),
                                    e.replace(h, "").replace(b, d),
                                    a.length || !e || c.test(e) || a.push({ c: e, u: e, w: 99 }),
                                    a
                                );
                            };
                        })(),
                        l = function l() {
                            l.init ||
                                ((l.init = !0),
                                addEventListener(
                                    "resize",
                                    (function () {
                                        var a,
                                            c = b.getElementsByClassName("lazymatchmedia"),
                                            e = function e() {
                                                var a, b;
                                                for (a = 0, b = c.length; b > a; a++) {
                                                    d(c[a]);
                                                }
                                            };
                                        return function () {
                                            clearTimeout(a), (a = setTimeout(e, 66));
                                        };
                                    })()
                                ));
                        },
                        m = function m(b, d) {
                            var f,
                                g = b.getAttribute("srcset") || b.getAttribute(e.srcsetAttr);
                            !g &&
                                d &&
                                (g = b._lazypolyfill
                                    ? b._lazypolyfill._set
                                    : b.getAttribute(e.srcAttr) || b.getAttribute("src")),
                                (b._lazypolyfill && b._lazypolyfill._set == g) ||
                                    ((f = k(g || "")),
                                    d &&
                                        b.parentNode &&
                                        ((f.isPicture = "PICTURE" == b.parentNode.nodeName.toUpperCase()),
                                        f.isPicture && a.matchMedia && (c.aC(b, "lazymatchmedia"), l())),
                                    (f._set = g),
                                    Object.defineProperty(b, "_lazypolyfill", { value: f, writable: !0 }));
                        },
                        n = function n(b) {
                            var d = a.devicePixelRatio || 1,
                                e = c.getX && c.getX(b);
                            return Math.min(e || d, 2.5, d);
                        },
                        _o2 = function o(b) {
                            return a.matchMedia
                                ? (_o2 = function o(a) {
                                      return !a || (matchMedia(a) || {}).matches;
                                  })(b)
                                : !b;
                        },
                        p = function p(a) {
                            var b, d, g, h, k, l, p;
                            if (((h = a), m(h, !0), (k = h._lazypolyfill), k.isPicture))
                                for (d = 0, b = a.parentNode.getElementsByTagName("source"), g = b.length; g > d; d++) {
                                    if (
                                        e.supportsType(b[d].getAttribute("type"), a) &&
                                        _o2(b[d].getAttribute("media"))
                                    ) {
                                        (h = b[d]), m(h), (k = h._lazypolyfill);
                                        break;
                                    }
                                }
                            return (
                                k.length > 1
                                    ? ((p = h.getAttribute("sizes") || ""),
                                      (p = (i.test(p) && parseInt(p, 10)) || c.gW(a, a.parentNode)),
                                      (k.d = n(a)),
                                      !k.src || !k.w || k.w < p
                                          ? ((k.w = p), (l = j(k.sort(f))), (k.src = l))
                                          : (l = k.src))
                                    : (l = k[0]),
                                l
                            );
                        },
                        q = function q(a) {
                            if (!g || !a.parentNode || "PICTURE" == a.parentNode.nodeName.toUpperCase()) {
                                var b = p(a);
                                b &&
                                    b.u &&
                                    a._lazypolyfill.cur != b.u &&
                                    ((a._lazypolyfill.cur = b.u),
                                    (b.cached = !0),
                                    a.setAttribute(e.srcAttr, b.u),
                                    a.setAttribute("src", b.u));
                            }
                        };
                    return (q.parse = k), q;
                })()),
                e.loadedClass &&
                    e.loadingClass &&
                    !(function () {
                        var a = [];
                        ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function (b) {
                            a.push(b + e.loadedClass), a.push(b + e.loadingClass);
                        }),
                            e.pf({ elements: b.querySelectorAll(a.join(", ")) });
                    })();
        }
    });
    /*! lazysizes - bgset */
    !(function (a, b) {
        var c = function c() {
            b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0);
        };
        (b = b.bind(null, a, a.document)),
            "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports
                ? b(require("lazysizes"))
                : a.lazySizes
                  ? c()
                  : a.addEventListener("lazyunveilread", c, !0);
    })(window, function (a, b, c) {
        "use strict";
        if (a.addEventListener) {
            var d = /\s+/g,
                e = /\s*\|\s+|\s+\|\s*/g,
                f = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/,
                g = /\(|\)|'/,
                h = { contain: 1, cover: 1 },
                i = function i(a) {
                    var b = c.gW(a, a.parentNode);
                    return (!a._lazysizesWidth || b > a._lazysizesWidth) && (a._lazysizesWidth = b), a._lazysizesWidth;
                },
                j = function j(a) {
                    var b;
                    return (
                        (b = (
                            getComputedStyle(a) || { getPropertyValue: function getPropertyValue() {} }
                        ).getPropertyValue("background-size")),
                        !h[b] && h[a.style.backgroundSize] && (b = a.style.backgroundSize),
                        b
                    );
                },
                k = function k(a, c, g) {
                    var h = b.createElement("picture"),
                        i = c.getAttribute(lazySizesConfig.sizesAttr),
                        j = c.getAttribute("data-ratio"),
                        k = c.getAttribute("data-optimumx");
                    c._lazybgset && c._lazybgset.parentNode == c && c.removeChild(c._lazybgset),
                        Object.defineProperty(g, "_lazybgset", { value: c, writable: !0 }),
                        Object.defineProperty(c, "_lazybgset", { value: h, writable: !0 }),
                        (a = a.replace(d, " ").split(e)),
                        (h.style.display = "none"),
                        (g.className = lazySizesConfig.lazyClass),
                        1 != a.length || i || (i = "auto"),
                        a.forEach(function (a) {
                            var c = b.createElement("source");
                            i && "auto" != i && c.setAttribute("sizes", i),
                                a.match(f) &&
                                    (c.setAttribute(lazySizesConfig.srcsetAttr, RegExp.$1),
                                    RegExp.$2 &&
                                        c.setAttribute("media", lazySizesConfig.customMedia[RegExp.$2] || RegExp.$2)),
                                h.appendChild(c);
                        }),
                        i &&
                            (g.setAttribute(lazySizesConfig.sizesAttr, i),
                            c.removeAttribute(lazySizesConfig.sizesAttr),
                            c.removeAttribute("sizes")),
                        k && g.setAttribute("data-optimumx", k),
                        j && g.setAttribute("data-ratio", j),
                        h.appendChild(g),
                        c.appendChild(h);
                },
                l = function l(a) {
                    if (a.target._lazybgset) {
                        var b = a.target,
                            d = b._lazybgset,
                            e = b.currentSrc || b.src;
                        e && (d.style.backgroundImage = "url(" + (g.test(e) ? JSON.stringify(e) : e) + ")"),
                            b._lazybgsetLoading && (c.fire(d, "_lazyloaded", {}, !1, !0), delete b._lazybgsetLoading);
                    }
                };
            addEventListener("lazybeforeunveil", function (a) {
                var d, e, f;
                !a.defaultPrevented &&
                    (d = a.target.getAttribute("data-bgset")) &&
                    ((f = a.target),
                    (e = b.createElement("img")),
                    (e.alt = ""),
                    (e._lazybgsetLoading = !0),
                    (a.detail.firesLoad = !0),
                    k(d, f, e),
                    setTimeout(function () {
                        c.loader.unveil(e),
                            c.rAF(function () {
                                c.fire(e, "_lazyloaded", {}, !0, !0), e.complete && l({ target: e });
                            });
                    }));
            }),
                b.addEventListener("load", l, !0),
                a.addEventListener(
                    "lazybeforesizes",
                    function (a) {
                        if (a.detail.instance == c && a.target._lazybgset && a.detail.dataAttr) {
                            var b = a.target._lazybgset,
                                d = j(b);
                            h[d] &&
                                ((a.target._lazysizesParentFit = d),
                                c.rAF(function () {
                                    a.target.setAttribute("data-parent-fit", d),
                                        a.target._lazysizesParentFit && delete a.target._lazysizesParentFit;
                                }));
                        }
                    },
                    !0
                ),
                b.documentElement.addEventListener("lazybeforesizes", function (a) {
                    !a.defaultPrevented &&
                        a.target._lazybgset &&
                        a.detail.instance == c &&
                        (a.detail.width = i(a.target._lazybgset));
                });
        }
    });
    /* lazysizes placeholder removal */
    document.addEventListener("lazyloaded", function (e) {
        e.target.parentElement.className = e.target.parentElement.className.replace("lazyload--placeholder", "");
    });
    /*
       _ _      _       _
   ___| (_) ___| | __  (_)___
  / __| | |/ __| |/ /  | / __|
  \__ \ | | (__|   < _ | \__ \
  |___/_|_|\___|_|\_(_)/ |___/
                     |__/
  
   Version: 1.6.0
    Author: Ken Wheeler
   Website: http://kenwheeler.github.io
      Docs: http://kenwheeler.github.io/slick
      Repo: http://github.com/kenwheeler/slick
    Issues: http://github.com/kenwheeler/slick/issues
  
    Modified by Clean Canvas - removed 'aria-describedby', translating labels
   */
    !(function (a) {
        "use strict";
        "function" == typeof define && define.amd
            ? define(["jquery"], a)
            : "undefined" != typeof exports
              ? (module.exports = a(require("jquery")))
              : a(jQuery);
    })(function (a) {
        "use strict";
        var b = window.Slick || {};
        (b = (function () {
            function c(c, d) {
                var f,
                    e = this;
                (e.defaults = {
                    accessibility: !0,
                    adaptiveHeight: !1,
                    appendArrows: a(c),
                    appendDots: a(c),
                    arrows: !0,
                    asNavFor: null,
                    prevArrow:
                        '<button type="button" data-role="none" class="slick-prev" aria-label="' +
                        theme.strings.previous +
                        '" tabindex="0" role="button">' +
                        theme.strings.previous +
                        "</button>",
                    nextArrow:
                        '<button type="button" data-role="none" class="slick-next" aria-label="' +
                        theme.strings.next +
                        '" tabindex="0" role="button">' +
                        theme.strings.next +
                        "</button>",
                    autoplay: !1,
                    autoplaySpeed: 3e3,
                    centerMode: !1,
                    centerPadding: "50px",
                    cssEase: "ease",
                    customPaging: function customPaging(b, c) {
                        return a('<button type="button" data-role="none" role="button" tabindex="0" />').text(c + 1);
                    },
                    dots: !1,
                    dotsClass: "slick-dots",
                    draggable: !0,
                    easing: "linear",
                    edgeFriction: 0.35,
                    fade: !1,
                    focusOnSelect: !1,
                    infinite: !0,
                    initialSlide: 0,
                    lazyLoad: "ondemand",
                    mobileFirst: !1,
                    pauseOnHover: !0,
                    pauseOnFocus: !0,
                    pauseOnDotsHover: !1,
                    respondTo: "window",
                    responsive: null,
                    rows: 1,
                    rtl: !1,
                    slide: "",
                    slidesPerRow: 1,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 500,
                    swipe: !0,
                    swipeToSlide: !1,
                    touchMove: !0,
                    touchThreshold: 5,
                    useCSS: !0,
                    useTransform: !0,
                    variableWidth: !1,
                    vertical: !1,
                    verticalSwiping: !1,
                    waitForAnimate: !0,
                    zIndex: 1e3,
                }),
                    (e.initials = {
                        animating: !1,
                        dragging: !1,
                        autoPlayTimer: null,
                        currentDirection: 0,
                        currentLeft: null,
                        currentSlide: 0,
                        direction: 1,
                        $dots: null,
                        listWidth: null,
                        listHeight: null,
                        loadIndex: 0,
                        $nextArrow: null,
                        $prevArrow: null,
                        slideCount: null,
                        slideWidth: null,
                        $slideTrack: null,
                        $slides: null,
                        sliding: !1,
                        slideOffset: 0,
                        swipeLeft: null,
                        $list: null,
                        touchObject: {},
                        transformsEnabled: !1,
                        unslicked: !1,
                    }),
                    a.extend(e, e.initials),
                    (e.activeBreakpoint = null),
                    (e.animType = null),
                    (e.animProp = null),
                    (e.breakpoints = []),
                    (e.breakpointSettings = []),
                    (e.cssTransitions = !1),
                    (e.focussed = !1),
                    (e.interrupted = !1),
                    (e.hidden = "hidden"),
                    (e.paused = !0),
                    (e.positionProp = null),
                    (e.respondTo = null),
                    (e.rowCount = 1),
                    (e.shouldClick = !0),
                    (e.$slider = a(c)),
                    (e.$slidesCache = null),
                    (e.transformType = null),
                    (e.transitionType = null),
                    (e.visibilityChange = "visibilitychange"),
                    (e.windowWidth = 0),
                    (e.windowTimer = null),
                    (f = a(c).data("slick") || {}),
                    (e.options = a.extend({}, e.defaults, d, f)),
                    (e.currentSlide = e.options.initialSlide),
                    (e.originalSettings = e.options),
                    "undefined" != typeof document.mozHidden
                        ? ((e.hidden = "mozHidden"), (e.visibilityChange = "mozvisibilitychange"))
                        : "undefined" != typeof document.webkitHidden &&
                          ((e.hidden = "webkitHidden"), (e.visibilityChange = "webkitvisibilitychange")),
                    (e.autoPlay = a.proxy(e.autoPlay, e)),
                    (e.autoPlayClear = a.proxy(e.autoPlayClear, e)),
                    (e.autoPlayIterator = a.proxy(e.autoPlayIterator, e)),
                    (e.changeSlide = a.proxy(e.changeSlide, e)),
                    (e.clickHandler = a.proxy(e.clickHandler, e)),
                    (e.selectHandler = a.proxy(e.selectHandler, e)),
                    (e.setPosition = a.proxy(e.setPosition, e)),
                    (e.swipeHandler = a.proxy(e.swipeHandler, e)),
                    (e.dragHandler = a.proxy(e.dragHandler, e)),
                    (e.keyHandler = a.proxy(e.keyHandler, e)),
                    (e.instanceUid = b++),
                    (e.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
                    e.registerBreakpoints(),
                    e.init(!0);
            }
            var b = 0;
            return c;
        })()),
            (b.prototype.activateADA = function () {
                var a = this;
                a.$slideTrack
                    .find(".slick-active")
                    .attr({ "aria-hidden": "false" })
                    .find("a, input, button, select")
                    .attr({ tabindex: "0" });
            }),
            (b.prototype.addSlide = b.prototype.slickAdd =
                function (b, c, d) {
                    var e = this;
                    if ("boolean" == typeof c) (d = c), (c = null);
                    else if (0 > c || c >= e.slideCount) return !1;
                    e.unload(),
                        "number" == typeof c
                            ? 0 === c && 0 === e.$slides.length
                                ? a(b).appendTo(e.$slideTrack)
                                : d
                                  ? a(b).insertBefore(e.$slides.eq(c))
                                  : a(b).insertAfter(e.$slides.eq(c))
                            : d === !0
                              ? a(b).prependTo(e.$slideTrack)
                              : a(b).appendTo(e.$slideTrack),
                        (e.$slides = e.$slideTrack.children(this.options.slide)),
                        e.$slideTrack.children(this.options.slide).detach(),
                        e.$slideTrack.append(e.$slides),
                        e.$slides.each(function (b, c) {
                            a(c).attr("data-slick-index", b);
                        }),
                        (e.$slidesCache = e.$slides),
                        e.reinit();
                }),
            (b.prototype.animateHeight = function () {
                var a = this;
                if (1 === a.options.slidesToShow && a.options.adaptiveHeight === !0 && a.options.vertical === !1) {
                    var b = a.$slides.eq(a.currentSlide).outerHeight(!0);
                    a.$list.animate({ height: b }, a.options.speed);
                }
            }),
            (b.prototype.animateSlide = function (b, c) {
                var d = {},
                    e = this;
                e.animateHeight(),
                    e.options.rtl === !0 && e.options.vertical === !1 && (b = -b),
                    e.transformsEnabled === !1
                        ? e.options.vertical === !1
                            ? e.$slideTrack.animate({ left: b }, e.options.speed, e.options.easing, c)
                            : e.$slideTrack.animate({ top: b }, e.options.speed, e.options.easing, c)
                        : e.cssTransitions === !1
                          ? (e.options.rtl === !0 && (e.currentLeft = -e.currentLeft),
                            a({ animStart: e.currentLeft }).animate(
                                { animStart: b },
                                {
                                    duration: e.options.speed,
                                    easing: e.options.easing,
                                    step: function step(a) {
                                        (a = Math.ceil(a)),
                                            e.options.vertical === !1
                                                ? ((d[e.animType] = "translate(" + a + "px, 0px)"),
                                                  e.$slideTrack.css(d))
                                                : ((d[e.animType] = "translate(0px," + a + "px)"),
                                                  e.$slideTrack.css(d));
                                    },
                                    complete: function complete() {
                                        c && c.call();
                                    },
                                }
                            ))
                          : (e.applyTransition(),
                            (b = Math.ceil(b)),
                            e.options.vertical === !1
                                ? (d[e.animType] = "translate3d(" + b + "px, 0px, 0px)")
                                : (d[e.animType] = "translate3d(0px," + b + "px, 0px)"),
                            e.$slideTrack.css(d),
                            c &&
                                setTimeout(function () {
                                    e.disableTransition(), c.call();
                                }, e.options.speed));
            }),
            (b.prototype.getNavTarget = function () {
                var b = this,
                    c = b.options.asNavFor;
                return c && null !== c && (c = a(c).not(b.$slider)), c;
            }),
            (b.prototype.asNavFor = function (b) {
                var c = this,
                    d = c.getNavTarget();
                null !== d &&
                    "object" == _typeof(d) &&
                    d.each(function () {
                        var c = a(this).slick("getSlick");
                        c.unslicked || c.slideHandler(b, !0);
                    });
            }),
            (b.prototype.applyTransition = function (a) {
                var b = this,
                    c = {};
                b.options.fade === !1
                    ? (c[b.transitionType] = b.transformType + " " + b.options.speed + "ms " + b.options.cssEase)
                    : (c[b.transitionType] = "opacity " + b.options.speed + "ms " + b.options.cssEase),
                    b.options.fade === !1 ? b.$slideTrack.css(c) : b.$slides.eq(a).css(c);
            }),
            (b.prototype.autoPlay = function () {
                var a = this;
                a.autoPlayClear(),
                    a.slideCount > a.options.slidesToShow &&
                        (a.autoPlayTimer = setInterval(a.autoPlayIterator, a.options.autoplaySpeed));
            }),
            (b.prototype.autoPlayClear = function () {
                var a = this;
                a.autoPlayTimer && clearInterval(a.autoPlayTimer);
            }),
            (b.prototype.autoPlayIterator = function () {
                var a = this,
                    b = a.currentSlide + a.options.slidesToScroll;
                a.paused ||
                    a.interrupted ||
                    a.focussed ||
                    (a.options.infinite === !1 &&
                        (1 === a.direction && a.currentSlide + 1 === a.slideCount - 1
                            ? (a.direction = 0)
                            : 0 === a.direction &&
                              ((b = a.currentSlide - a.options.slidesToScroll),
                              a.currentSlide - 1 === 0 && (a.direction = 1))),
                    a.slideHandler(b));
            }),
            (b.prototype.buildArrows = function () {
                var b = this;
                b.options.arrows === !0 &&
                    ((b.$prevArrow = a(b.options.prevArrow).addClass("slick-arrow")),
                    (b.$nextArrow = a(b.options.nextArrow).addClass("slick-arrow")),
                    b.slideCount > b.options.slidesToShow
                        ? (b.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                          b.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                          b.htmlExpr.test(b.options.prevArrow) && b.$prevArrow.prependTo(b.options.appendArrows),
                          b.htmlExpr.test(b.options.nextArrow) && b.$nextArrow.appendTo(b.options.appendArrows),
                          b.options.infinite !== !0 &&
                              b.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"))
                        : b.$prevArrow
                              .add(b.$nextArrow)
                              .addClass("slick-hidden")
                              .attr({ "aria-disabled": "true", tabindex: "-1" }));
            }),
            (b.prototype.buildDots = function () {
                var c,
                    d,
                    b = this;
                if (b.options.dots === !0 && b.slideCount > b.options.slidesToShow) {
                    for (
                        b.$slider.addClass("slick-dotted"), d = a("<ul />").addClass(b.options.dotsClass), c = 0;
                        c <= b.getDotCount();
                        c += 1
                    ) {
                        d.append(a("<li />").append(b.options.customPaging.call(this, b, c)));
                    }
                    (b.$dots = d.appendTo(b.options.appendDots)),
                        b.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false");
                }
            }),
            (b.prototype.buildOut = function () {
                var b = this;
                (b.$slides = b.$slider.children(b.options.slide + ":not(.slick-cloned)").addClass("slick-slide")),
                    (b.slideCount = b.$slides.length),
                    b.$slides.each(function (b, c) {
                        a(c)
                            .attr("data-slick-index", b)
                            .data("originalStyling", a(c).attr("style") || "");
                    }),
                    b.$slider.addClass("slick-slider"),
                    (b.$slideTrack =
                        0 === b.slideCount
                            ? a(
                                  '<div class="slick-track" aria-label="'.concat(
                                      theme.strings.imageSlider ? theme.strings.imageSlider : "",
                                      '"/>'
                                  )
                              ).appendTo(b.$slider)
                            : b.$slides
                                  .wrapAll(
                                      '<div class="slick-track" aria-label="'.concat(
                                          theme.strings.imageSlider ? theme.strings.imageSlider : "",
                                          '"/>'
                                      )
                                  )
                                  .parent()),
                    (b.$list = b.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent()),
                    b.$slideTrack.css("opacity", 0),
                    (b.options.centerMode === !0 || b.options.swipeToSlide === !0) && (b.options.slidesToScroll = 1),
                    a("img[data-lazy]", b.$slider).not("[src]").addClass("slick-loading"),
                    b.setupInfinite(),
                    b.buildArrows(),
                    b.buildDots(),
                    b.updateDots(),
                    b.setSlideClasses("number" == typeof b.currentSlide ? b.currentSlide : 0),
                    b.options.draggable === !0 && b.$list.addClass("draggable");
            }),
            (b.prototype.buildRows = function () {
                var b,
                    c,
                    d,
                    e,
                    f,
                    g,
                    h,
                    a = this;
                if (((e = document.createDocumentFragment()), (g = a.$slider.children()), a.options.rows > 1)) {
                    for (h = a.options.slidesPerRow * a.options.rows, f = Math.ceil(g.length / h), b = 0; f > b; b++) {
                        var i = document.createElement("div");
                        for (c = 0; c < a.options.rows; c++) {
                            var j = document.createElement("div");
                            for (d = 0; d < a.options.slidesPerRow; d++) {
                                var k = b * h + (c * a.options.slidesPerRow + d);
                                g.get(k) && j.appendChild(g.get(k));
                            }
                            i.appendChild(j);
                        }
                        e.appendChild(i);
                    }
                    a.$slider.empty().append(e),
                        a.$slider
                            .children()
                            .children()
                            .children()
                            .css({ width: 100 / a.options.slidesPerRow + "%", display: "inline-block" });
                }
            }),
            (b.prototype.checkResponsive = function (b, c) {
                var e,
                    f,
                    g,
                    d = this,
                    h = !1,
                    i = d.$slider.width(),
                    j = window.innerWidth || a(window).width();
                if (
                    ("window" === d.respondTo
                        ? (g = j)
                        : "slider" === d.respondTo
                          ? (g = i)
                          : "min" === d.respondTo && (g = Math.min(j, i)),
                    d.options.responsive && d.options.responsive.length && null !== d.options.responsive)
                ) {
                    f = null;
                    for (e in d.breakpoints) {
                        d.breakpoints.hasOwnProperty(e) &&
                            (d.originalSettings.mobileFirst === !1
                                ? g < d.breakpoints[e] && (f = d.breakpoints[e])
                                : g > d.breakpoints[e] && (f = d.breakpoints[e]));
                    }
                    null !== f
                        ? null !== d.activeBreakpoint
                            ? (f !== d.activeBreakpoint || c) &&
                              ((d.activeBreakpoint = f),
                              "unslick" === d.breakpointSettings[f]
                                  ? d.unslick(f)
                                  : ((d.options = a.extend({}, d.originalSettings, d.breakpointSettings[f])),
                                    b === !0 && (d.currentSlide = d.options.initialSlide),
                                    d.refresh(b)),
                              (h = f))
                            : ((d.activeBreakpoint = f),
                              "unslick" === d.breakpointSettings[f]
                                  ? d.unslick(f)
                                  : ((d.options = a.extend({}, d.originalSettings, d.breakpointSettings[f])),
                                    b === !0 && (d.currentSlide = d.options.initialSlide),
                                    d.refresh(b)),
                              (h = f))
                        : null !== d.activeBreakpoint &&
                          ((d.activeBreakpoint = null),
                          (d.options = d.originalSettings),
                          b === !0 && (d.currentSlide = d.options.initialSlide),
                          d.refresh(b),
                          (h = f)),
                        b || h === !1 || d.$slider.trigger("breakpoint", [d, h]);
                }
            }),
            (b.prototype.changeSlide = function (b, c) {
                var f,
                    g,
                    h,
                    d = this,
                    e = a(b.currentTarget);
                switch (
                    (e.is("a") && b.preventDefault(),
                    e.is("li") || (e = e.closest("li")),
                    (h = d.slideCount % d.options.slidesToScroll !== 0),
                    (f = h ? 0 : (d.slideCount - d.currentSlide) % d.options.slidesToScroll),
                    b.data.message)
                ) {
                    case "previous":
                        (g = 0 === f ? d.options.slidesToScroll : d.options.slidesToShow - f),
                            d.slideCount > d.options.slidesToShow && d.slideHandler(d.currentSlide - g, !1, c);
                        break;
                    case "next":
                        (g = 0 === f ? d.options.slidesToScroll : f),
                            d.slideCount > d.options.slidesToShow && d.slideHandler(d.currentSlide + g, !1, c);
                        break;
                    case "index":
                        var i = 0 === b.data.index ? 0 : b.data.index || e.index() * d.options.slidesToScroll;
                        d.slideHandler(d.checkNavigable(i), !1, c), e.children().trigger("focus");
                        break;
                    default:
                        return;
                }
            }),
            (b.prototype.checkNavigable = function (a) {
                var c,
                    d,
                    b = this;
                if (((c = b.getNavigableIndexes()), (d = 0), a > c[c.length - 1])) a = c[c.length - 1];
                else
                    for (var e in c) {
                        if (a < c[e]) {
                            a = d;
                            break;
                        }
                        d = c[e];
                    }
                return a;
            }),
            (b.prototype.cleanUpEvents = function () {
                var b = this;
                b.options.dots &&
                    null !== b.$dots &&
                    a("li", b.$dots)
                        .off("click.slick", b.changeSlide)
                        .off("mouseenter.slick", a.proxy(b.interrupt, b, !0))
                        .off("mouseleave.slick", a.proxy(b.interrupt, b, !1)),
                    b.$slider.off("focus.slick blur.slick"),
                    b.options.arrows === !0 &&
                        b.slideCount > b.options.slidesToShow &&
                        (b.$prevArrow && b.$prevArrow.off("click.slick", b.changeSlide),
                        b.$nextArrow && b.$nextArrow.off("click.slick", b.changeSlide)),
                    b.$list.off("touchstart.slick mousedown.slick", b.swipeHandler),
                    b.$list.off("touchmove.slick mousemove.slick", b.swipeHandler),
                    b.$list.off("touchend.slick mouseup.slick", b.swipeHandler),
                    b.$list.off("touchcancel.slick mouseleave.slick", b.swipeHandler),
                    b.$list.off("click.slick", b.clickHandler),
                    a(document).off(b.visibilityChange, b.visibility),
                    b.cleanUpSlideEvents(),
                    b.options.accessibility === !0 && b.$list.off("keydown.slick", b.keyHandler),
                    b.options.focusOnSelect === !0 && a(b.$slideTrack).children().off("click.slick", b.selectHandler),
                    a(window).off("orientationchange.slick.slick-" + b.instanceUid, b.orientationChange),
                    a(window).off("resize.slick.slick-" + b.instanceUid, b.resize),
                    a("[draggable!=true]", b.$slideTrack).off("dragstart", b.preventDefault),
                    a(window).off("load.slick.slick-" + b.instanceUid, b.setPosition),
                    a(document).off("ready.slick.slick-" + b.instanceUid, b.setPosition);
            }),
            (b.prototype.cleanUpSlideEvents = function () {
                var b = this;
                b.$list.off("mouseenter.slick", a.proxy(b.interrupt, b, !0)),
                    b.$list.off("mouseleave.slick", a.proxy(b.interrupt, b, !1));
            }),
            (b.prototype.cleanUpRows = function () {
                var b,
                    a = this;
                a.options.rows > 1 &&
                    ((b = a.$slides.children().children()), b.removeAttr("style"), a.$slider.empty().append(b));
            }),
            (b.prototype.clickHandler = function (a) {
                var b = this;
                b.shouldClick === !1 && (a.stopImmediatePropagation(), a.stopPropagation(), a.preventDefault());
            }),
            (b.prototype.destroy = function (b) {
                var c = this;
                c.autoPlayClear(),
                    (c.touchObject = {}),
                    c.cleanUpEvents(),
                    a(".slick-cloned", c.$slider).detach(),
                    c.$dots && c.$dots.remove(),
                    c.$prevArrow &&
                        c.$prevArrow.length &&
                        (c.$prevArrow
                            .removeClass("slick-disabled slick-arrow slick-hidden")
                            .removeAttr("aria-hidden aria-disabled tabindex")
                            .css("display", ""),
                        c.htmlExpr.test(c.options.prevArrow) && c.$prevArrow.remove()),
                    c.$nextArrow &&
                        c.$nextArrow.length &&
                        (c.$nextArrow
                            .removeClass("slick-disabled slick-arrow slick-hidden")
                            .removeAttr("aria-hidden aria-disabled tabindex")
                            .css("display", ""),
                        c.htmlExpr.test(c.options.nextArrow) && c.$nextArrow.remove()),
                    c.$slides &&
                        (c.$slides
                            .removeClass("slick-slide slick-active slick-center slick-visible slick-current")
                            .removeAttr("aria-hidden")
                            .removeAttr("data-slick-index")
                            .each(function () {
                                a(this).attr("style", a(this).data("originalStyling"));
                            }),
                        c.$slideTrack.children(this.options.slide).detach(),
                        c.$slideTrack.detach(),
                        c.$list.detach(),
                        c.$slider.append(c.$slides)),
                    c.cleanUpRows(),
                    c.$slider.removeClass("slick-slider"),
                    c.$slider.removeClass("slick-initialized"),
                    c.$slider.removeClass("slick-dotted"),
                    (c.unslicked = !0),
                    b || c.$slider.trigger("destroy", [c]);
            }),
            (b.prototype.disableTransition = function (a) {
                var b = this,
                    c = {};
                (c[b.transitionType] = ""), b.options.fade === !1 ? b.$slideTrack.css(c) : b.$slides.eq(a).css(c);
            }),
            (b.prototype.fadeSlide = function (a, b) {
                var c = this;
                c.cssTransitions === !1
                    ? (c.$slides.eq(a).css({ zIndex: c.options.zIndex }),
                      c.$slides.eq(a).animate({ opacity: 1 }, c.options.speed, c.options.easing, b))
                    : (c.applyTransition(a),
                      c.$slides.eq(a).css({ opacity: 1, zIndex: c.options.zIndex }),
                      b &&
                          setTimeout(function () {
                              c.disableTransition(a), b.call();
                          }, c.options.speed));
            }),
            (b.prototype.fadeSlideOut = function (a) {
                var b = this;
                b.cssTransitions === !1
                    ? b.$slides
                          .eq(a)
                          .animate({ opacity: 0, zIndex: b.options.zIndex - 2 }, b.options.speed, b.options.easing)
                    : (b.applyTransition(a), b.$slides.eq(a).css({ opacity: 0, zIndex: b.options.zIndex - 2 }));
            }),
            (b.prototype.filterSlides = b.prototype.slickFilter =
                function (a) {
                    var b = this;
                    null !== a &&
                        ((b.$slidesCache = b.$slides),
                        b.unload(),
                        b.$slideTrack.children(this.options.slide).detach(),
                        b.$slidesCache.filter(a).appendTo(b.$slideTrack),
                        b.reinit());
                }),
            (b.prototype.focusHandler = function () {
                var b = this;
                b.$slider
                    .off("focus.slick blur.slick")
                    .on("focus.slick blur.slick", "*:not(.slick-arrow)", function (c) {
                        var d = a(this);
                        setTimeout(function () {
                            b.options.pauseOnFocus && ((b.focussed = d.is(":focus")), b.autoPlay());
                        }, 0);
                    });
            }),
            (b.prototype.getCurrent = b.prototype.slickCurrentSlide =
                function () {
                    var a = this;
                    return a.currentSlide;
                }),
            (b.prototype.getDotCount = function () {
                var a = this,
                    b = 0,
                    c = 0,
                    d = 0;
                if (a.options.infinite === !0)
                    for (; b < a.slideCount; ) {
                        ++d,
                            (b = c + a.options.slidesToScroll),
                            (c +=
                                a.options.slidesToScroll <= a.options.slidesToShow
                                    ? a.options.slidesToScroll
                                    : a.options.slidesToShow);
                    }
                else if (a.options.centerMode === !0) d = a.slideCount;
                else if (a.options.asNavFor)
                    for (; b < a.slideCount; ) {
                        ++d,
                            (b = c + a.options.slidesToScroll),
                            (c +=
                                a.options.slidesToScroll <= a.options.slidesToShow
                                    ? a.options.slidesToScroll
                                    : a.options.slidesToShow);
                    }
                else d = 1 + Math.ceil((a.slideCount - a.options.slidesToShow) / a.options.slidesToScroll);
                return d - 1;
            }),
            (b.prototype.getLeft = function (a) {
                var c,
                    d,
                    f,
                    b = this,
                    e = 0;
                return (
                    (b.slideOffset = 0),
                    (d = b.$slides.first().outerHeight(!0)),
                    b.options.infinite === !0
                        ? (b.slideCount > b.options.slidesToShow &&
                              ((b.slideOffset = b.slideWidth * b.options.slidesToShow * -1),
                              (e = d * b.options.slidesToShow * -1)),
                          b.slideCount % b.options.slidesToScroll !== 0 &&
                              a + b.options.slidesToScroll > b.slideCount &&
                              b.slideCount > b.options.slidesToShow &&
                              (a > b.slideCount
                                  ? ((b.slideOffset =
                                        (b.options.slidesToShow - (a - b.slideCount)) * b.slideWidth * -1),
                                    (e = (b.options.slidesToShow - (a - b.slideCount)) * d * -1))
                                  : ((b.slideOffset = (b.slideCount % b.options.slidesToScroll) * b.slideWidth * -1),
                                    (e = (b.slideCount % b.options.slidesToScroll) * d * -1))))
                        : a + b.options.slidesToShow > b.slideCount &&
                          ((b.slideOffset = (a + b.options.slidesToShow - b.slideCount) * b.slideWidth),
                          (e = (a + b.options.slidesToShow - b.slideCount) * d)),
                    b.slideCount <= b.options.slidesToShow && ((b.slideOffset = 0), (e = 0)),
                    b.options.centerMode === !0 && b.options.infinite === !0
                        ? (b.slideOffset += b.slideWidth * Math.floor(b.options.slidesToShow / 2) - b.slideWidth)
                        : b.options.centerMode === !0 &&
                          ((b.slideOffset = 0),
                          (b.slideOffset += b.slideWidth * Math.floor(b.options.slidesToShow / 2))),
                    (c = b.options.vertical === !1 ? a * b.slideWidth * -1 + b.slideOffset : a * d * -1 + e),
                    b.options.variableWidth === !0 &&
                        ((f =
                            b.slideCount <= b.options.slidesToShow || b.options.infinite === !1
                                ? b.$slideTrack.children(".slick-slide").eq(a)
                                : b.$slideTrack.children(".slick-slide").eq(a + b.options.slidesToShow)),
                        (c =
                            b.options.rtl === !0
                                ? f[0]
                                    ? -1 * (b.$slideTrack.width() - f[0].offsetLeft - f.width())
                                    : 0
                                : f[0]
                                  ? -1 * f[0].offsetLeft
                                  : 0),
                        b.options.centerMode === !0 &&
                            ((f =
                                b.slideCount <= b.options.slidesToShow || b.options.infinite === !1
                                    ? b.$slideTrack.children(".slick-slide").eq(a)
                                    : b.$slideTrack.children(".slick-slide").eq(a + b.options.slidesToShow + 1)),
                            (c =
                                b.options.rtl === !0
                                    ? f[0]
                                        ? -1 * (b.$slideTrack.width() - f[0].offsetLeft - f.width())
                                        : 0
                                    : f[0]
                                      ? -1 * f[0].offsetLeft
                                      : 0),
                            (c += (b.$list.width() - f.outerWidth()) / 2))),
                    c
                );
            }),
            (b.prototype.getOption = b.prototype.slickGetOption =
                function (a) {
                    var b = this;
                    return b.options[a];
                }),
            (b.prototype.getNavigableIndexes = function () {
                var e,
                    a = this,
                    b = 0,
                    c = 0,
                    d = [];
                for (
                    a.options.infinite === !1
                        ? (e = a.slideCount)
                        : ((b = -1 * a.options.slidesToScroll),
                          (c = -1 * a.options.slidesToScroll),
                          (e = 2 * a.slideCount));
                    e > b;

                ) {
                    d.push(b),
                        (b = c + a.options.slidesToScroll),
                        (c +=
                            a.options.slidesToScroll <= a.options.slidesToShow
                                ? a.options.slidesToScroll
                                : a.options.slidesToShow);
                }
                return d;
            }),
            (b.prototype.getSlick = function () {
                return this;
            }),
            (b.prototype.getSlideCount = function () {
                var c,
                    d,
                    e,
                    b = this;
                return (
                    (e = b.options.centerMode === !0 ? b.slideWidth * Math.floor(b.options.slidesToShow / 2) : 0),
                    b.options.swipeToSlide === !0
                        ? (b.$slideTrack.find(".slick-slide").each(function (c, f) {
                              return f.offsetLeft - e + a(f).outerWidth() / 2 > -1 * b.swipeLeft
                                  ? ((d = f), !1)
                                  : void 0;
                          }),
                          (c = Math.abs(a(d).attr("data-slick-index") - b.currentSlide) || 1))
                        : b.options.slidesToScroll
                );
            }),
            (b.prototype.goTo = b.prototype.slickGoTo =
                function (a, b) {
                    var c = this;
                    c.changeSlide({ data: { message: "index", index: parseInt(a) } }, b);
                }),
            (b.prototype.init = function (b) {
                var c = this;
                a(c.$slider).hasClass("slick-initialized") ||
                    (a(c.$slider).addClass("slick-initialized"),
                    c.buildRows(),
                    c.buildOut(),
                    c.setProps(),
                    c.startLoad(),
                    c.loadSlider(),
                    c.initializeEvents(),
                    c.updateArrows(),
                    c.updateDots(),
                    c.checkResponsive(!0),
                    c.focusHandler()),
                    b && c.$slider.trigger("init", [c]),
                    c.options.accessibility === !0 && c.initADA(),
                    c.options.autoplay && ((c.paused = !1), c.autoPlay());
            }),
            (b.prototype.initADA = function () {
                var b = this;
                b.$slides
                    .add(b.$slideTrack.find(".slick-cloned"))
                    .attr({ "aria-hidden": "true", tabindex: "-1" })
                    .find("a, input, button, select")
                    .attr({ tabindex: "-1" }),
                    b.$slideTrack.attr("role", "listbox"),
                    b.$slides.not(b.$slideTrack.find(".slick-cloned")).each(function (c) {
                        a(this).attr({ role: "option" });
                    }),
                    null !== b.$dots &&
                        b.$dots
                            .attr("aria-hidden", "true")
                            .find("li")
                            .each(function (c) {
                                a(this).attr({
                                    role: "presentation",
                                    "aria-selected": "false",
                                    "aria-controls": "navigation" + b.instanceUid + c,
                                    id: "slick-slide" + b.instanceUid + c,
                                });
                            })
                            .first()
                            .attr("aria-selected", "true")
                            .end()
                            .find("button")
                            .attr("role", "button")
                            .end()
                            .closest("div")
                            .attr("role", "toolbar"),
                    b.activateADA();
            }),
            (b.prototype.initArrowEvents = function () {
                var a = this;
                a.options.arrows === !0 &&
                    a.slideCount > a.options.slidesToShow &&
                    (a.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, a.changeSlide),
                    a.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, a.changeSlide));
            }),
            (b.prototype.initDotEvents = function () {
                var b = this;
                b.options.dots === !0 &&
                    b.slideCount > b.options.slidesToShow &&
                    a("li", b.$dots).on("click.slick", { message: "index" }, b.changeSlide),
                    b.options.dots === !0 &&
                        b.options.pauseOnDotsHover === !0 &&
                        a("li", b.$dots)
                            .on("mouseenter.slick", a.proxy(b.interrupt, b, !0))
                            .on("mouseleave.slick", a.proxy(b.interrupt, b, !1));
            }),
            (b.prototype.initSlideEvents = function () {
                var b = this;
                b.options.pauseOnHover &&
                    (b.$list.on("mouseenter.slick", a.proxy(b.interrupt, b, !0)),
                    b.$list.on("mouseleave.slick", a.proxy(b.interrupt, b, !1)));
            }),
            (b.prototype.initializeEvents = function () {
                var b = this;
                b.initArrowEvents(),
                    b.initDotEvents(),
                    b.initSlideEvents(),
                    b.$list.on("touchstart.slick mousedown.slick", { action: "start" }, b.swipeHandler),
                    b.$list.on("touchmove.slick mousemove.slick", { action: "move" }, b.swipeHandler),
                    b.$list.on("touchend.slick mouseup.slick", { action: "end" }, b.swipeHandler),
                    b.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, b.swipeHandler),
                    b.$list.on("click.slick", b.clickHandler),
                    a(document).on(b.visibilityChange, a.proxy(b.visibility, b)),
                    b.options.accessibility === !0 && b.$list.on("keydown.slick", b.keyHandler),
                    b.options.focusOnSelect === !0 && a(b.$slideTrack).children().on("click.slick", b.selectHandler),
                    a(window).on("orientationchange.slick.slick-" + b.instanceUid, a.proxy(b.orientationChange, b)),
                    a(window).on("resize.slick.slick-" + b.instanceUid, a.proxy(b.resize, b)),
                    a("[draggable!=true]", b.$slideTrack).on("dragstart", b.preventDefault),
                    a(window).on("load.slick.slick-" + b.instanceUid, b.setPosition),
                    a(document).on("ready.slick.slick-" + b.instanceUid, b.setPosition);
            }),
            (b.prototype.initUI = function () {
                var a = this;
                a.options.arrows === !0 &&
                    a.slideCount > a.options.slidesToShow &&
                    (a.$prevArrow.show(), a.$nextArrow.show()),
                    a.options.dots === !0 && a.slideCount > a.options.slidesToShow && a.$dots.show();
            }),
            (b.prototype.keyHandler = function (a) {
                var b = this;
                a.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
                    (37 === a.keyCode && b.options.accessibility === !0
                        ? b.changeSlide({ data: { message: b.options.rtl === !0 ? "next" : "previous" } })
                        : 39 === a.keyCode &&
                          b.options.accessibility === !0 &&
                          b.changeSlide({ data: { message: b.options.rtl === !0 ? "previous" : "next" } }));
            }),
            (b.prototype.lazyLoad = function () {
                function g(c) {
                    a("img[data-lazy]", c).each(function () {
                        var c = a(this),
                            d = a(this).attr("data-lazy"),
                            e = document.createElement("img");
                        (e.onload = function () {
                            c.animate({ opacity: 0 }, 100, function () {
                                c.attr("src", d).animate({ opacity: 1 }, 200, function () {
                                    c.removeAttr("data-lazy").removeClass("slick-loading");
                                }),
                                    b.$slider.trigger("lazyLoaded", [b, c, d]);
                            });
                        }),
                            (e.onerror = function () {
                                c.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
                                    b.$slider.trigger("lazyLoadError", [b, c, d]);
                            }),
                            (e.src = d);
                    });
                }
                var c,
                    d,
                    e,
                    f,
                    b = this;
                b.options.centerMode === !0
                    ? b.options.infinite === !0
                        ? ((e = b.currentSlide + (b.options.slidesToShow / 2 + 1)),
                          (f = e + b.options.slidesToShow + 2))
                        : ((e = Math.max(0, b.currentSlide - (b.options.slidesToShow / 2 + 1))),
                          (f = 2 + (b.options.slidesToShow / 2 + 1) + b.currentSlide))
                    : ((e = b.options.infinite ? b.options.slidesToShow + b.currentSlide : b.currentSlide),
                      (f = Math.ceil(e + b.options.slidesToShow)),
                      b.options.fade === !0 && (e > 0 && e--, f <= b.slideCount && f++)),
                    (c = b.$slider.find(".slick-slide").slice(e, f)),
                    g(c),
                    b.slideCount <= b.options.slidesToShow
                        ? ((d = b.$slider.find(".slick-slide")), g(d))
                        : b.currentSlide >= b.slideCount - b.options.slidesToShow
                          ? ((d = b.$slider.find(".slick-cloned").slice(0, b.options.slidesToShow)), g(d))
                          : 0 === b.currentSlide &&
                            ((d = b.$slider.find(".slick-cloned").slice(-1 * b.options.slidesToShow)), g(d));
            }),
            (b.prototype.loadSlider = function () {
                var a = this;
                a.setPosition(),
                    a.$slideTrack.css({ opacity: 1 }),
                    a.$slider.removeClass("slick-loading"),
                    a.initUI(),
                    "progressive" === a.options.lazyLoad && a.progressiveLazyLoad();
            }),
            (b.prototype.next = b.prototype.slickNext =
                function () {
                    var a = this;
                    a.changeSlide({ data: { message: "next" } });
                }),
            (b.prototype.orientationChange = function () {
                var a = this;
                a.checkResponsive(), a.setPosition();
            }),
            (b.prototype.pause = b.prototype.slickPause =
                function () {
                    var a = this;
                    a.autoPlayClear(), (a.paused = !0);
                }),
            (b.prototype.play = b.prototype.slickPlay =
                function () {
                    var a = this;
                    a.autoPlay(), (a.options.autoplay = !0), (a.paused = !1), (a.focussed = !1), (a.interrupted = !1);
                }),
            (b.prototype.postSlide = function (a) {
                var b = this;
                b.unslicked ||
                    (b.$slider.trigger("afterChange", [b, a]),
                    (b.animating = !1),
                    b.setPosition(),
                    (b.swipeLeft = null),
                    b.options.autoplay && b.autoPlay(),
                    b.options.accessibility === !0 && b.initADA());
            }),
            (b.prototype.prev = b.prototype.slickPrev =
                function () {
                    var a = this;
                    a.changeSlide({ data: { message: "previous" } });
                }),
            (b.prototype.preventDefault = function (a) {
                a.preventDefault();
            }),
            (b.prototype.progressiveLazyLoad = function (b) {
                b = b || 1;
                var e,
                    f,
                    g,
                    c = this,
                    d = a("img[data-lazy]", c.$slider);
                d.length
                    ? ((e = d.first()),
                      (f = e.attr("data-lazy")),
                      (g = document.createElement("img")),
                      (g.onload = function () {
                          e.attr("src", f).removeAttr("data-lazy").removeClass("slick-loading"),
                              c.options.adaptiveHeight === !0 && c.setPosition(),
                              c.$slider.trigger("lazyLoaded", [c, e, f]),
                              c.progressiveLazyLoad();
                      }),
                      (g.onerror = function () {
                          3 > b
                              ? setTimeout(function () {
                                    c.progressiveLazyLoad(b + 1);
                                }, 500)
                              : (e
                                    .removeAttr("data-lazy")
                                    .removeClass("slick-loading")
                                    .addClass("slick-lazyload-error"),
                                c.$slider.trigger("lazyLoadError", [c, e, f]),
                                c.progressiveLazyLoad());
                      }),
                      (g.src = f))
                    : c.$slider.trigger("allImagesLoaded", [c]);
            }),
            (b.prototype.refresh = function (b) {
                var d,
                    e,
                    c = this;
                (e = c.slideCount - c.options.slidesToShow),
                    !c.options.infinite && c.currentSlide > e && (c.currentSlide = e),
                    c.slideCount <= c.options.slidesToShow && (c.currentSlide = 0),
                    (d = c.currentSlide),
                    c.destroy(!0),
                    a.extend(c, c.initials, { currentSlide: d }),
                    c.init(),
                    b || c.changeSlide({ data: { message: "index", index: d } }, !1);
            }),
            (b.prototype.registerBreakpoints = function () {
                var c,
                    d,
                    e,
                    b = this,
                    f = b.options.responsive || null;
                if ("array" === a.type(f) && f.length) {
                    b.respondTo = b.options.respondTo || "window";
                    for (c in f) {
                        if (((e = b.breakpoints.length - 1), (d = f[c].breakpoint), f.hasOwnProperty(c))) {
                            for (; e >= 0; ) {
                                b.breakpoints[e] && b.breakpoints[e] === d && b.breakpoints.splice(e, 1), e--;
                            }
                            b.breakpoints.push(d), (b.breakpointSettings[d] = f[c].settings);
                        }
                    }
                    b.breakpoints.sort(function (a, c) {
                        return b.options.mobileFirst ? a - c : c - a;
                    });
                }
            }),
            (b.prototype.reinit = function () {
                var b = this;
                (b.$slides = b.$slideTrack.children(b.options.slide).addClass("slick-slide")),
                    (b.slideCount = b.$slides.length),
                    b.currentSlide >= b.slideCount &&
                        0 !== b.currentSlide &&
                        (b.currentSlide = b.currentSlide - b.options.slidesToScroll),
                    b.slideCount <= b.options.slidesToShow && (b.currentSlide = 0),
                    b.registerBreakpoints(),
                    b.setProps(),
                    b.setupInfinite(),
                    b.buildArrows(),
                    b.updateArrows(),
                    b.initArrowEvents(),
                    b.buildDots(),
                    b.updateDots(),
                    b.initDotEvents(),
                    b.cleanUpSlideEvents(),
                    b.initSlideEvents(),
                    b.checkResponsive(!1, !0),
                    b.options.focusOnSelect === !0 && a(b.$slideTrack).children().on("click.slick", b.selectHandler),
                    b.setSlideClasses("number" == typeof b.currentSlide ? b.currentSlide : 0),
                    b.setPosition(),
                    b.focusHandler(),
                    (b.paused = !b.options.autoplay),
                    b.autoPlay(),
                    b.$slider.trigger("reInit", [b]);
            }),
            (b.prototype.resize = function () {
                var b = this;
                a(window).width() !== b.windowWidth &&
                    (clearTimeout(b.windowDelay),
                    (b.windowDelay = window.setTimeout(function () {
                        (b.windowWidth = a(window).width()), b.checkResponsive(), b.unslicked || b.setPosition();
                    }, 50)));
            }),
            (b.prototype.removeSlide = b.prototype.slickRemove =
                function (a, b, c) {
                    var d = this;
                    return (
                        "boolean" == typeof a
                            ? ((b = a), (a = b === !0 ? 0 : d.slideCount - 1))
                            : (a = b === !0 ? --a : a),
                        d.slideCount < 1 || 0 > a || a > d.slideCount - 1
                            ? !1
                            : (d.unload(),
                              c === !0
                                  ? d.$slideTrack.children().remove()
                                  : d.$slideTrack.children(this.options.slide).eq(a).remove(),
                              (d.$slides = d.$slideTrack.children(this.options.slide)),
                              d.$slideTrack.children(this.options.slide).detach(),
                              d.$slideTrack.append(d.$slides),
                              (d.$slidesCache = d.$slides),
                              void d.reinit())
                    );
                }),
            (b.prototype.setCSS = function (a) {
                var d,
                    e,
                    b = this,
                    c = {};
                b.options.rtl === !0 && (a = -a),
                    (d = "left" == b.positionProp ? Math.ceil(a) + "px" : "0px"),
                    (e = "top" == b.positionProp ? Math.ceil(a) + "px" : "0px"),
                    (c[b.positionProp] = a),
                    b.transformsEnabled === !1
                        ? b.$slideTrack.css(c)
                        : ((c = {}),
                          b.cssTransitions === !1
                              ? ((c[b.animType] = "translate(" + d + ", " + e + ")"), b.$slideTrack.css(c))
                              : ((c[b.animType] = "translate3d(" + d + ", " + e + ", 0px)"), b.$slideTrack.css(c)));
            }),
            (b.prototype.setDimensions = function () {
                var a = this;
                a.options.vertical === !1
                    ? a.options.centerMode === !0 && a.$list.css({ padding: "0px " + a.options.centerPadding })
                    : (a.$list.height(a.$slides.first().outerHeight(!0) * a.options.slidesToShow),
                      a.options.centerMode === !0 && a.$list.css({ padding: a.options.centerPadding + " 0px" })),
                    (a.listWidth = a.$list.width()),
                    (a.listHeight = a.$list.height()),
                    a.options.vertical === !1 && a.options.variableWidth === !1
                        ? ((a.slideWidth = Math.ceil(a.listWidth / a.options.slidesToShow)),
                          a.$slideTrack.width(Math.ceil(a.slideWidth * a.$slideTrack.children(".slick-slide").length)))
                        : a.options.variableWidth === !0
                          ? a.$slideTrack.width(5e3 * a.slideCount)
                          : ((a.slideWidth = Math.ceil(a.listWidth)),
                            a.$slideTrack.height(
                                Math.ceil(
                                    a.$slides.first().outerHeight(!0) * a.$slideTrack.children(".slick-slide").length
                                )
                            ));
                var b = a.$slides.first().outerWidth(!0) - a.$slides.first().width();
                a.options.variableWidth === !1 && a.$slideTrack.children(".slick-slide").width(a.slideWidth - b);
            }),
            (b.prototype.setFade = function () {
                var c,
                    b = this;
                b.$slides.each(function (d, e) {
                    (c = b.slideWidth * d * -1),
                        b.options.rtl === !0
                            ? a(e).css({
                                  position: "relative",
                                  right: c,
                                  top: 0,
                                  zIndex: b.options.zIndex - 2,
                                  opacity: 0,
                              })
                            : a(e).css({
                                  position: "relative",
                                  left: c,
                                  top: 0,
                                  zIndex: b.options.zIndex - 2,
                                  opacity: 0,
                              });
                }),
                    b.$slides.eq(b.currentSlide).css({ zIndex: b.options.zIndex - 1, opacity: 1 });
            }),
            (b.prototype.setHeight = function () {
                var a = this;
                if (1 === a.options.slidesToShow && a.options.adaptiveHeight === !0 && a.options.vertical === !1) {
                    var b = a.$slides.eq(a.currentSlide).outerHeight(!0);
                    a.$list.css("height", b);
                }
            }),
            (b.prototype.setOption = b.prototype.slickSetOption =
                function () {
                    var c,
                        d,
                        e,
                        f,
                        h,
                        b = this,
                        g = !1;
                    if (
                        ("object" === a.type(arguments[0])
                            ? ((e = arguments[0]), (g = arguments[1]), (h = "multiple"))
                            : "string" === a.type(arguments[0]) &&
                              ((e = arguments[0]),
                              (f = arguments[1]),
                              (g = arguments[2]),
                              "responsive" === arguments[0] && "array" === a.type(arguments[1])
                                  ? (h = "responsive")
                                  : "undefined" != typeof arguments[1] && (h = "single")),
                        "single" === h)
                    )
                        b.options[e] = f;
                    else if ("multiple" === h)
                        a.each(e, function (a, c) {
                            b.options[a] = c;
                        });
                    else if ("responsive" === h)
                        for (d in f) {
                            if ("array" !== a.type(b.options.responsive)) b.options.responsive = [f[d]];
                            else {
                                for (c = b.options.responsive.length - 1; c >= 0; ) {
                                    b.options.responsive[c].breakpoint === f[d].breakpoint &&
                                        b.options.responsive.splice(c, 1),
                                        c--;
                                }
                                b.options.responsive.push(f[d]);
                            }
                        }
                    g && (b.unload(), b.reinit());
                }),
            (b.prototype.setPosition = function () {
                var a = this;
                a.setDimensions(),
                    a.setHeight(),
                    a.options.fade === !1 ? a.setCSS(a.getLeft(a.currentSlide)) : a.setFade(),
                    a.$slider.trigger("setPosition", [a]);
            }),
            (b.prototype.setProps = function () {
                var a = this,
                    b = document.body.style;
                (a.positionProp = a.options.vertical === !0 ? "top" : "left"),
                    "top" === a.positionProp
                        ? a.$slider.addClass("slick-vertical")
                        : a.$slider.removeClass("slick-vertical"),
                    (void 0 !== b.WebkitTransition || void 0 !== b.MozTransition || void 0 !== b.msTransition) &&
                        a.options.useCSS === !0 &&
                        (a.cssTransitions = !0),
                    a.options.fade &&
                        ("number" == typeof a.options.zIndex
                            ? a.options.zIndex < 3 && (a.options.zIndex = 3)
                            : (a.options.zIndex = a.defaults.zIndex)),
                    void 0 !== b.OTransform &&
                        ((a.animType = "OTransform"),
                        (a.transformType = "-o-transform"),
                        (a.transitionType = "OTransition"),
                        void 0 === b.perspectiveProperty && void 0 === b.webkitPerspective && (a.animType = !1)),
                    void 0 !== b.MozTransform &&
                        ((a.animType = "MozTransform"),
                        (a.transformType = "-moz-transform"),
                        (a.transitionType = "MozTransition"),
                        void 0 === b.perspectiveProperty && void 0 === b.MozPerspective && (a.animType = !1)),
                    void 0 !== b.webkitTransform &&
                        ((a.animType = "webkitTransform"),
                        (a.transformType = "-webkit-transform"),
                        (a.transitionType = "webkitTransition"),
                        void 0 === b.perspectiveProperty && void 0 === b.webkitPerspective && (a.animType = !1)),
                    void 0 !== b.msTransform &&
                        ((a.animType = "msTransform"),
                        (a.transformType = "-ms-transform"),
                        (a.transitionType = "msTransition"),
                        void 0 === b.msTransform && (a.animType = !1)),
                    void 0 !== b.transform &&
                        a.animType !== !1 &&
                        ((a.animType = "transform"),
                        (a.transformType = "transform"),
                        (a.transitionType = "transition")),
                    (a.transformsEnabled = a.options.useTransform && null !== a.animType && a.animType !== !1);
            }),
            (b.prototype.setSlideClasses = function (a) {
                var c,
                    d,
                    e,
                    f,
                    b = this;
                (d = b.$slider
                    .find(".slick-slide")
                    .removeClass("slick-active slick-center slick-current")
                    .attr("aria-hidden", "true")),
                    b.$slides.eq(a).addClass("slick-current"),
                    b.options.centerMode === !0
                        ? ((c = Math.floor(b.options.slidesToShow / 2)),
                          b.options.infinite === !0 &&
                              (a >= c && a <= b.slideCount - 1 - c
                                  ? b.$slides
                                        .slice(a - c, a + c + 1)
                                        .addClass("slick-active")
                                        .attr("aria-hidden", "false")
                                  : ((e = b.options.slidesToShow + a),
                                    d
                                        .slice(e - c + 1, e + c + 2)
                                        .addClass("slick-active")
                                        .attr("aria-hidden", "false")),
                              0 === a
                                  ? d.eq(d.length - 1 - b.options.slidesToShow).addClass("slick-center")
                                  : a === b.slideCount - 1 && d.eq(b.options.slidesToShow).addClass("slick-center")),
                          b.$slides.eq(a).addClass("slick-center"))
                        : a >= 0 && a <= b.slideCount - b.options.slidesToShow
                          ? b.$slides
                                .slice(a, a + b.options.slidesToShow)
                                .addClass("slick-active")
                                .attr("aria-hidden", "false")
                          : d.length <= b.options.slidesToShow
                            ? d.addClass("slick-active").attr("aria-hidden", "false")
                            : ((f = b.slideCount % b.options.slidesToShow),
                              (e = b.options.infinite === !0 ? b.options.slidesToShow + a : a),
                              b.options.slidesToShow == b.options.slidesToScroll &&
                              b.slideCount - a < b.options.slidesToShow
                                  ? d
                                        .slice(e - (b.options.slidesToShow - f), e + f)
                                        .addClass("slick-active")
                                        .attr("aria-hidden", "false")
                                  : d
                                        .slice(e, e + b.options.slidesToShow)
                                        .addClass("slick-active")
                                        .attr("aria-hidden", "false")),
                    "ondemand" === b.options.lazyLoad && b.lazyLoad();
            }),
            (b.prototype.setupInfinite = function () {
                var c,
                    d,
                    e,
                    b = this;
                if (
                    (b.options.fade === !0 && (b.options.centerMode = !1),
                    b.options.infinite === !0 &&
                        b.options.fade === !1 &&
                        ((d = null), b.slideCount > b.options.slidesToShow))
                ) {
                    for (
                        e = b.options.centerMode === !0 ? b.options.slidesToShow + 1 : b.options.slidesToShow,
                            c = b.slideCount;
                        c > b.slideCount - e;
                        c -= 1
                    ) {
                        (d = c - 1),
                            a(b.$slides[d])
                                .clone(!0)
                                .attr("id", "")
                                .attr("data-slick-index", d - b.slideCount)
                                .prependTo(b.$slideTrack)
                                .addClass("slick-cloned");
                    }
                    for (c = 0; e > c; c += 1) {
                        (d = c),
                            a(b.$slides[d])
                                .clone(!0)
                                .attr("id", "")
                                .attr("data-slick-index", d + b.slideCount)
                                .appendTo(b.$slideTrack)
                                .addClass("slick-cloned");
                    }
                    b.$slideTrack
                        .find(".slick-cloned")
                        .find("[id]")
                        .each(function () {
                            a(this).attr("id", "");
                        });
                }
            }),
            (b.prototype.interrupt = function (a) {
                var b = this;
                a || b.autoPlay(), (b.interrupted = a);
            }),
            (b.prototype.selectHandler = function (b) {
                var c = this,
                    d = a(b.target).is(".slick-slide") ? a(b.target) : a(b.target).parents(".slick-slide"),
                    e = parseInt(d.attr("data-slick-index"));
                return (
                    e || (e = 0),
                    c.slideCount <= c.options.slidesToShow
                        ? (c.setSlideClasses(e), void c.asNavFor(e))
                        : void c.slideHandler(e)
                );
            }),
            (b.prototype.slideHandler = function (a, b, c) {
                var d,
                    e,
                    f,
                    g,
                    j,
                    h = null,
                    i = this;
                return (
                    (b = b || !1),
                    (i.animating === !0 && i.options.waitForAnimate === !0) ||
                    (i.options.fade === !0 && i.currentSlide === a) ||
                    i.slideCount <= i.options.slidesToShow
                        ? void 0
                        : (b === !1 && i.asNavFor(a),
                          (d = a),
                          (h = i.getLeft(d)),
                          (g = i.getLeft(i.currentSlide)),
                          (i.currentLeft = null === i.swipeLeft ? g : i.swipeLeft),
                          i.options.infinite === !1 &&
                          i.options.centerMode === !1 &&
                          (0 > a || a > i.getDotCount() * i.options.slidesToScroll)
                              ? void (
                                    i.options.fade === !1 &&
                                    ((d = i.currentSlide),
                                    c !== !0
                                        ? i.animateSlide(g, function () {
                                              i.postSlide(d);
                                          })
                                        : i.postSlide(d))
                                )
                              : i.options.infinite === !1 &&
                                  i.options.centerMode === !0 &&
                                  (0 > a || a > i.slideCount - i.options.slidesToScroll)
                                ? void (
                                      i.options.fade === !1 &&
                                      ((d = i.currentSlide),
                                      c !== !0
                                          ? i.animateSlide(g, function () {
                                                i.postSlide(d);
                                            })
                                          : i.postSlide(d))
                                  )
                                : (i.options.autoplay && clearInterval(i.autoPlayTimer),
                                  (e =
                                      0 > d
                                          ? i.slideCount % i.options.slidesToScroll !== 0
                                              ? i.slideCount - (i.slideCount % i.options.slidesToScroll)
                                              : i.slideCount + d
                                          : d >= i.slideCount
                                            ? i.slideCount % i.options.slidesToScroll !== 0
                                                ? 0
                                                : d - i.slideCount
                                            : d),
                                  (i.animating = !0),
                                  i.$slider.trigger("beforeChange", [i, i.currentSlide, e]),
                                  (f = i.currentSlide),
                                  (i.currentSlide = e),
                                  i.setSlideClasses(i.currentSlide),
                                  i.options.asNavFor &&
                                      ((j = i.getNavTarget()),
                                      (j = j.slick("getSlick")),
                                      j.slideCount <= j.options.slidesToShow && j.setSlideClasses(i.currentSlide)),
                                  i.updateDots(),
                                  i.updateArrows(),
                                  i.options.fade === !0
                                      ? (c !== !0
                                            ? (i.fadeSlideOut(f),
                                              i.fadeSlide(e, function () {
                                                  i.postSlide(e);
                                              }))
                                            : i.postSlide(e),
                                        void i.animateHeight())
                                      : void (c !== !0
                                            ? i.animateSlide(h, function () {
                                                  i.postSlide(e);
                                              })
                                            : i.postSlide(e))))
                );
            }),
            (b.prototype.startLoad = function () {
                var a = this;
                a.options.arrows === !0 &&
                    a.slideCount > a.options.slidesToShow &&
                    (a.$prevArrow.hide(), a.$nextArrow.hide()),
                    a.options.dots === !0 && a.slideCount > a.options.slidesToShow && a.$dots.hide(),
                    a.$slider.addClass("slick-loading");
            }),
            (b.prototype.swipeDirection = function () {
                var a,
                    b,
                    c,
                    d,
                    e = this;
                return (
                    (a = e.touchObject.startX - e.touchObject.curX),
                    (b = e.touchObject.startY - e.touchObject.curY),
                    (c = Math.atan2(b, a)),
                    (d = Math.round((180 * c) / Math.PI)),
                    0 > d && (d = 360 - Math.abs(d)),
                    45 >= d && d >= 0
                        ? e.options.rtl === !1
                            ? "left"
                            : "right"
                        : 360 >= d && d >= 315
                          ? e.options.rtl === !1
                              ? "left"
                              : "right"
                          : d >= 135 && 225 >= d
                            ? e.options.rtl === !1
                                ? "right"
                                : "left"
                            : e.options.verticalSwiping === !0
                              ? d >= 35 && 135 >= d
                                  ? "down"
                                  : "up"
                              : "vertical"
                );
            }),
            (b.prototype.swipeEnd = function (a) {
                var c,
                    d,
                    b = this;
                if (
                    ((b.dragging = !1),
                    (b.interrupted = !1),
                    (b.shouldClick = b.touchObject.swipeLength > 10 ? !1 : !0),
                    void 0 === b.touchObject.curX)
                )
                    return !1;
                if (
                    (b.touchObject.edgeHit === !0 && b.$slider.trigger("edge", [b, b.swipeDirection()]),
                    b.touchObject.swipeLength >= b.touchObject.minSwipe)
                ) {
                    switch ((d = b.swipeDirection())) {
                        case "left":
                        case "down":
                            (c = b.options.swipeToSlide
                                ? b.checkNavigable(b.currentSlide + b.getSlideCount())
                                : b.currentSlide + b.getSlideCount()),
                                (b.currentDirection = 0);
                            break;
                        case "right":
                        case "up":
                            (c = b.options.swipeToSlide
                                ? b.checkNavigable(b.currentSlide - b.getSlideCount())
                                : b.currentSlide - b.getSlideCount()),
                                (b.currentDirection = 1);
                    }
                    "vertical" != d && (b.slideHandler(c), (b.touchObject = {}), b.$slider.trigger("swipe", [b, d]));
                } else
                    b.touchObject.startX !== b.touchObject.curX &&
                        (b.slideHandler(b.currentSlide), (b.touchObject = {}));
            }),
            (b.prototype.swipeHandler = function (a) {
                var b = this;
                if (
                    !(
                        b.options.swipe === !1 ||
                        ("ontouchend" in document && b.options.swipe === !1) ||
                        (b.options.draggable === !1 && -1 !== a.type.indexOf("mouse"))
                    )
                )
                    switch (
                        ((b.touchObject.fingerCount =
                            a.originalEvent && void 0 !== a.originalEvent.touches ? a.originalEvent.touches.length : 1),
                        (b.touchObject.minSwipe = b.listWidth / b.options.touchThreshold),
                        b.options.verticalSwiping === !0 &&
                            (b.touchObject.minSwipe = b.listHeight / b.options.touchThreshold),
                        a.data.action)
                    ) {
                        case "start":
                            b.swipeStart(a);
                            break;
                        case "move":
                            b.swipeMove(a);
                            break;
                        case "end":
                            b.swipeEnd(a);
                    }
            }),
            (b.prototype.swipeMove = function (a) {
                var d,
                    e,
                    f,
                    g,
                    h,
                    b = this;
                return (
                    (h = void 0 !== a.originalEvent ? a.originalEvent.touches : null),
                    !b.dragging || (h && 1 !== h.length)
                        ? !1
                        : ((d = b.getLeft(b.currentSlide)),
                          (b.touchObject.curX = void 0 !== h ? h[0].pageX : a.clientX),
                          (b.touchObject.curY = void 0 !== h ? h[0].pageY : a.clientY),
                          (b.touchObject.swipeLength = Math.round(
                              Math.sqrt(Math.pow(b.touchObject.curX - b.touchObject.startX, 2))
                          )),
                          b.options.verticalSwiping === !0 &&
                              (b.touchObject.swipeLength = Math.round(
                                  Math.sqrt(Math.pow(b.touchObject.curY - b.touchObject.startY, 2))
                              )),
                          (e = b.swipeDirection()),
                          "vertical" !== e
                              ? (void 0 !== a.originalEvent && b.touchObject.swipeLength > 4 && a.preventDefault(),
                                (g =
                                    (b.options.rtl === !1 ? 1 : -1) *
                                    (b.touchObject.curX > b.touchObject.startX ? 1 : -1)),
                                b.options.verticalSwiping === !0 &&
                                    (g = b.touchObject.curY > b.touchObject.startY ? 1 : -1),
                                (f = b.touchObject.swipeLength),
                                (b.touchObject.edgeHit = !1),
                                b.options.infinite === !1 &&
                                    ((0 === b.currentSlide && "right" === e) ||
                                        (b.currentSlide >= b.getDotCount() && "left" === e)) &&
                                    ((f = b.touchObject.swipeLength * b.options.edgeFriction),
                                    (b.touchObject.edgeHit = !0)),
                                b.options.vertical === !1
                                    ? (b.swipeLeft = d + f * g)
                                    : (b.swipeLeft = d + f * (b.$list.height() / b.listWidth) * g),
                                b.options.verticalSwiping === !0 && (b.swipeLeft = d + f * g),
                                b.options.fade === !0 || b.options.touchMove === !1
                                    ? !1
                                    : b.animating === !0
                                      ? ((b.swipeLeft = null), !1)
                                      : void b.setCSS(b.swipeLeft))
                              : void 0)
                );
            }),
            (b.prototype.swipeStart = function (a) {
                var c,
                    b = this;
                return (
                    (b.interrupted = !0),
                    1 !== b.touchObject.fingerCount || b.slideCount <= b.options.slidesToShow
                        ? ((b.touchObject = {}), !1)
                        : (void 0 !== a.originalEvent &&
                              void 0 !== a.originalEvent.touches &&
                              (c = a.originalEvent.touches[0]),
                          (b.touchObject.startX = b.touchObject.curX = void 0 !== c ? c.pageX : a.clientX),
                          (b.touchObject.startY = b.touchObject.curY = void 0 !== c ? c.pageY : a.clientY),
                          void (b.dragging = !0))
                );
            }),
            (b.prototype.unfilterSlides = b.prototype.slickUnfilter =
                function () {
                    var a = this;
                    null !== a.$slidesCache &&
                        (a.unload(),
                        a.$slideTrack.children(this.options.slide).detach(),
                        a.$slidesCache.appendTo(a.$slideTrack),
                        a.reinit());
                }),
            (b.prototype.unload = function () {
                var b = this;
                a(".slick-cloned", b.$slider).remove(),
                    b.$dots && b.$dots.remove(),
                    b.$prevArrow && b.htmlExpr.test(b.options.prevArrow) && b.$prevArrow.remove(),
                    b.$nextArrow && b.htmlExpr.test(b.options.nextArrow) && b.$nextArrow.remove(),
                    b.$slides
                        .removeClass("slick-slide slick-active slick-visible slick-current")
                        .attr("aria-hidden", "true")
                        .css("width", "");
            }),
            (b.prototype.unslick = function (a) {
                var b = this;
                b.$slider.trigger("unslick", [b, a]), b.destroy();
            }),
            (b.prototype.updateArrows = function () {
                var b,
                    a = this;
                (b = Math.floor(a.options.slidesToShow / 2)),
                    a.options.arrows === !0 &&
                        a.slideCount > a.options.slidesToShow &&
                        !a.options.infinite &&
                        (a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                        a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                        0 === a.currentSlide
                            ? (a.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
                              a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                            : a.currentSlide >= a.slideCount - a.options.slidesToShow && a.options.centerMode === !1
                              ? (a.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
                                a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                              : a.currentSlide >= a.slideCount - 1 &&
                                a.options.centerMode === !0 &&
                                (a.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
                                a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")));
            }),
            (b.prototype.updateDots = function () {
                var a = this;
                null !== a.$dots &&
                    (a.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true"),
                    a.$dots
                        .find("li")
                        .eq(Math.floor(a.currentSlide / a.options.slidesToScroll))
                        .addClass("slick-active")
                        .attr("aria-hidden", "false"));
            }),
            (b.prototype.visibility = function () {
                var a = this;
                a.options.autoplay && (document[a.hidden] ? (a.interrupted = !0) : (a.interrupted = !1));
            }),
            (a.fn.slick = function () {
                var f,
                    g,
                    a = this,
                    c = arguments[0],
                    d = Array.prototype.slice.call(arguments, 1),
                    e = a.length;
                for (f = 0; e > f; f++) {
                    if (
                        ("object" == _typeof(c) || "undefined" == typeof c
                            ? (a[f].slick = new b(a[f], c))
                            : (g = a[f].slick[c].apply(a[f].slick, d)),
                        "undefined" != typeof g)
                    )
                        return g;
                }
                return a;
            });
    });
    /*
     * Cookie plugin
     *
     * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
     * Dual licensed under the MIT and GPL licenses:
     * http://www.opensource.org/licenses/mit-license.php
     * http://www.gnu.org/licenses/gpl.html
     *
     * v1.0
     */

    jQuery.cookie = function (b, j, m) {
        if (typeof j != "undefined") {
            m = m || {};
            if (j === null) {
                j = "";
                m.expires = -1;
            }
            var e = "";
            if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) {
                var f;
                if (typeof m.expires == "number") {
                    f = new Date();
                    f.setTime(f.getTime() + m.expires * 24 * 60 * 60 * 1000);
                } else {
                    f = m.expires;
                }
                e = "; expires=" + f.toUTCString();
            }
            var l = m.path ? "; path=" + m.path : "";
            var g = m.domain ? "; domain=" + m.domain : "";
            var a = m.secure ? "; secure" : "";
            document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("");
        } else {
            var d = null;
            if (document.cookie && document.cookie != "") {
                var k = document.cookie.split(";");
                for (var h = 0; h < k.length; h++) {
                    var c = jQuery.trim(k[h]);
                    if (c.substring(0, b.length + 1) == b + "=") {
                        d = decodeURIComponent(c.substring(b.length + 1));
                        break;
                    }
                }
            }
            return d;
        }
    };
    // *************
    // Original plugin Gist: https://gist.github.com/268257
    // Current repos: https://github.com/desandro/imagesloaded
    // fix in response to: https://github.com/desandro/imagesloaded/issues/8
    //
    // In case this is useful to anyone.
    // *************

    /* Modernizr 2.6.2 (Custom Build) | MIT & BSD
     * Build: http://modernizr.com/download/#-csstransitions-input-testprop-testallprops-domprefixes-load
     */
    (window.Modernizr = (function (a, b, c) {
        function w(a) {
            i.cssText = a;
        }
        function x(a, b) {
            return w(prefixes.join(a + ";") + (b || ""));
        }
        function y(a, b) {
            return _typeof(a) === b;
        }
        function z(a, b) {
            return !!~("" + a).indexOf(b);
        }
        function A(a, b) {
            for (var d in a) {
                var e = a[d];
                if (!z(e, "-") && i[e] !== c) return b == "pfx" ? e : !0;
            }
            return !1;
        }
        function B(a, b, d) {
            for (var e in a) {
                var f = b[a[e]];
                if (f !== c) return d === !1 ? a[e] : y(f, "function") ? f.bind(d || b) : f;
            }
            return !1;
        }
        function C(a, b, c) {
            var d = a.charAt(0).toUpperCase() + a.slice(1),
                e = (a + " " + m.join(d + " ") + d).split(" ");
            return y(b, "string") || y(b, "undefined")
                ? A(e, b)
                : ((e = (a + " " + n.join(d + " ") + d).split(" ")), B(e, b, c));
        }
        function D() {
            e.input = (function (c) {
                for (var d = 0, e = c.length; d < e; d++) {
                    q[c[d]] = c[d] in j;
                }
                return q.list && (q.list = !!b.createElement("datalist") && !!a.HTMLDataListElement), q;
            })("autocomplete autofocus list placeholder max min multiple pattern required step".split(" "));
        }
        var d = "2.6.2",
            e = {},
            f = b.documentElement,
            g = "modernizr",
            h = b.createElement(g),
            i = h.style,
            j = b.createElement("input"),
            k = {}.toString,
            l = "Webkit Moz O ms",
            m = l.split(" "),
            n = l.toLowerCase().split(" "),
            o = {},
            p = {},
            q = {},
            r = [],
            s = r.slice,
            t,
            u = {}.hasOwnProperty,
            v;
        !y(u, "undefined") && !y(u.call, "undefined")
            ? (v = function v(a, b) {
                  return u.call(a, b);
              })
            : (v = function v(a, b) {
                  return b in a && y(a.constructor.prototype[b], "undefined");
              }),
            Function.prototype.bind ||
                (Function.prototype.bind = function (b) {
                    var c = this;
                    if (typeof c != "function") throw new TypeError();
                    var d = s.call(arguments, 1),
                        e = function e() {
                            if (this instanceof e) {
                                var a = function a() {};
                                a.prototype = c.prototype;
                                var f = new a(),
                                    g = c.apply(f, d.concat(s.call(arguments)));
                                return Object(g) === g ? g : f;
                            }
                            return c.apply(b, d.concat(s.call(arguments)));
                        };
                    return e;
                }),
            (o.csstransitions = function () {
                return C("transition");
            });
        for (var E in o) {
            v(o, E) && ((t = E.toLowerCase()), (e[t] = o[E]()), r.push((e[t] ? "" : "no-") + t));
        }
        return (
            e.input || D(),
            (e.addTest = function (a, b) {
                if (_typeof(a) == "object")
                    for (var d in a) {
                        v(a, d) && e.addTest(d, a[d]);
                    }
                else {
                    a = a.toLowerCase();
                    if (e[a] !== c) return e;
                    (b = typeof b == "function" ? b() : b),
                        typeof enableClasses != "undefined" &&
                            enableClasses &&
                            (f.className += " " + (b ? "" : "no-") + a),
                        (e[a] = b);
                }
                return e;
            }),
            w(""),
            (h = j = null),
            (e._version = d),
            (e._domPrefixes = n),
            (e._cssomPrefixes = m),
            (e.testProp = function (a) {
                return A([a]);
            }),
            (e.testAllProps = C),
            e
        );
    })(this, this.document)),
        (function (a, b, c) {
            function d(a) {
                return "[object Function]" == o.call(a);
            }
            function e(a) {
                return "string" == typeof a;
            }
            function f() {}
            function g(a) {
                return !a || "loaded" == a || "complete" == a || "uninitialized" == a;
            }
            function h() {
                var a = p.shift();
                (q = 1),
                    a
                        ? a.t
                            ? m(function () {
                                  ("c" == a.t ? _B.injectCss : _B.injectJs)(a.s, 0, a.a, a.x, a.e, 1);
                              }, 0)
                            : (a(), h())
                        : (q = 0);
            }
            function i(a, c, d, e, f, i, j) {
                function k(b) {
                    if (
                        !o &&
                        g(l.readyState) &&
                        ((u.r = o = 1), !q && h(), (l.onload = l.onreadystatechange = null), b)
                    ) {
                        "img" != a &&
                            m(function () {
                                t.removeChild(l);
                            }, 50);
                        for (var d in y[c]) {
                            y[c].hasOwnProperty(d) && y[c][d].onload();
                        }
                    }
                }
                var j = j || _B.errorTimeout,
                    l = b.createElement(a),
                    o = 0,
                    r = 0,
                    u = { t: d, s: c, e: f, a: i, x: j };
                1 === y[c] && ((r = 1), (y[c] = [])),
                    "object" == a ? (l.data = c) : ((l.src = c), (l.type = a)),
                    (l.width = l.height = "0"),
                    (l.onerror =
                        l.onload =
                        l.onreadystatechange =
                            function () {
                                k.call(this, r);
                            }),
                    p.splice(e, 0, u),
                    "img" != a && (r || 2 === y[c] ? (t.insertBefore(l, s ? null : n), m(k, j)) : y[c].push(l));
            }
            function j(a, b, c, d, f) {
                return (
                    (q = 0),
                    (b = b || "j"),
                    e(a)
                        ? i("c" == b ? v : u, a, b, this.i++, c, d, f)
                        : (p.splice(this.i++, 0, a), 1 == p.length && h()),
                    this
                );
            }
            function k() {
                var a = _B;
                return (a.loader = { load: j, i: 0 }), a;
            }
            var l = b.documentElement,
                m = a.setTimeout,
                n = b.getElementsByTagName("script")[0],
                o = {}.toString,
                p = [],
                q = 0,
                r = "MozAppearance" in l.style,
                s = r && !!b.createRange().compareNode,
                t = s ? l : n.parentNode,
                l = a.opera && "[object Opera]" == o.call(a.opera),
                l = !!b.attachEvent && !l,
                u = r ? "object" : l ? "script" : "img",
                v = l ? "script" : u,
                w =
                    Array.isArray ||
                    function (a) {
                        return "[object Array]" == o.call(a);
                    },
                x = [],
                y = {},
                z = {
                    timeout: function timeout(a, b) {
                        return b.length && (a.timeout = b[0]), a;
                    },
                },
                _A,
                _B;
            (_B = function B(a) {
                function b(a) {
                    var a = a.split("!"),
                        b = x.length,
                        c = a.pop(),
                        d = a.length,
                        c = { url: c, origUrl: c, prefixes: a },
                        e,
                        f,
                        g;
                    for (f = 0; f < d; f++) {
                        (g = a[f].split("=")), (e = z[g.shift()]) && (c = e(c, g));
                    }
                    for (f = 0; f < b; f++) {
                        c = x[f](c);
                    }
                    return c;
                }
                function g(a, e, f, g, h) {
                    var i = b(a),
                        j = i.autoCallback;
                    i.url.split(".").pop().split("?").shift(),
                        i.bypass ||
                            (e && (e = d(e) ? e : e[a] || e[g] || e[a.split("/").pop().split("?")[0]]),
                            i.instead
                                ? i.instead(a, e, f, g, h)
                                : (y[i.url] ? (i.noexec = !0) : (y[i.url] = 1),
                                  f.load(
                                      i.url,
                                      i.forceCSS || (!i.forceJS && "css" == i.url.split(".").pop().split("?").shift())
                                          ? "c"
                                          : c,
                                      i.noexec,
                                      i.attrs,
                                      i.timeout
                                  ),
                                  (d(e) || d(j)) &&
                                      f.load(function () {
                                          k(), e && e(i.origUrl, h, g), j && j(i.origUrl, h, g), (y[i.url] = 2);
                                      })));
                }
                function h(a, b) {
                    function c(a, c) {
                        if (a) {
                            if (e(a))
                                c ||
                                    (j = function j() {
                                        var a = [].slice.call(arguments);
                                        k.apply(this, a), l();
                                    }),
                                    g(a, j, b, 0, h);
                            else if (Object(a) === a)
                                for (n in ((m = (function () {
                                    var b = 0,
                                        c;
                                    for (c in a) {
                                        a.hasOwnProperty(c) && b++;
                                    }
                                    return b;
                                })()),
                                a)) {
                                    a.hasOwnProperty(n) &&
                                        (!c &&
                                            !--m &&
                                            (d(j)
                                                ? (j = function j() {
                                                      var a = [].slice.call(arguments);
                                                      k.apply(this, a), l();
                                                  })
                                                : (j[n] = (function (a) {
                                                      return function () {
                                                          var b = [].slice.call(arguments);
                                                          a && a.apply(this, b), l();
                                                      };
                                                  })(k[n]))),
                                        g(a[n], j, b, n, h));
                                }
                        } else !c && l();
                    }
                    var h = !!a.test,
                        i = a.load || a.both,
                        j = a.callback || f,
                        k = j,
                        l = a.complete || f,
                        m,
                        n;
                    c(h ? a.yep : a.nope, !!i), i && c(i);
                }
                var i,
                    j,
                    l = this.yepnope.loader;
                if (e(a)) g(a, 0, l, 0);
                else if (w(a))
                    for (i = 0; i < a.length; i++) {
                        (j = a[i]), e(j) ? g(j, 0, l, 0) : w(j) ? _B(j) : Object(j) === j && h(j, l);
                    }
                else Object(a) === a && h(a, l);
            }),
                (_B.addPrefix = function (a, b) {
                    z[a] = b;
                }),
                (_B.addFilter = function (a) {
                    x.push(a);
                }),
                (_B.errorTimeout = 1e4),
                null == b.readyState &&
                    b.addEventListener &&
                    ((b.readyState = "loading"),
                    b.addEventListener(
                        "DOMContentLoaded",
                        (_A = function A() {
                            b.removeEventListener("DOMContentLoaded", _A, 0), (b.readyState = "complete");
                        }),
                        0
                    )),
                (a.yepnope = k()),
                (a.yepnope.executeStack = h),
                (a.yepnope.injectJs = function (a, c, d, e, i, j) {
                    var k = b.createElement("script"),
                        l,
                        o,
                        e = e || _B.errorTimeout;
                    k.src = a;
                    for (o in d) {
                        k.setAttribute(o, d[o]);
                    }
                    (c = j ? h : c || f),
                        (k.onreadystatechange = k.onload =
                            function () {
                                !l && g(k.readyState) && ((l = 1), c(), (k.onload = k.onreadystatechange = null));
                            }),
                        m(function () {
                            l || ((l = 1), c(1));
                        }, e),
                        i ? k.onload() : n.parentNode.insertBefore(k, n);
                }),
                (a.yepnope.injectCss = function (a, c, d, e, g, i) {
                    var e = b.createElement("link"),
                        j,
                        c = i ? h : c || f;
                    (e.href = a), (e.rel = "stylesheet"), (e.type = "text/css");
                    for (j in d) {
                        e.setAttribute(j, d[j]);
                    }
                    g || (n.parentNode.insertBefore(e, n), m(c, 0));
                });
        })(this, document),
        (Modernizr.load = function () {
            yepnope.apply(window, [].slice.call(arguments, 0));
        });
    /*
     * v.1.0
     *
     * debouncedresize: special jQuery event that happens once after a window resize
     *
     * latest version and complete README available on Github:
     * https://github.com/louisremi/jquery-smartresize
     *
     * Copyright 2012 @louis_remi
     * Licensed under the MIT license.
     *
     * This saved you an hour of work?
     * Send me music http://www.amazon.co.uk/wishlist/HNTU0468LQON
     */
    (function () {
        var $event = $.event,
            $special,
            resizeTimeout,
            windowWidth = window.innerWidth;

        $special = $event.special.debouncedresize = {
            setup: function setup() {
                $(this).on("resize", $special.handler);
            },
            teardown: function teardown() {
                $(this).off("resize", $special.handler);
            },
            handler: function handler(event, execAsap) {
                // Save the context
                var context = this,
                    args = arguments,
                    dispatch = function dispatch() {
                        // set correct event type
                        event.type = "debouncedresize";
                        $event.dispatch.apply(context, args);

                        if (windowWidth !== window.innerWidth) {
                            event.type = "debouncedresizewidth";
                            $event.dispatch.apply(context, args);
                            windowWidth = window.innerWidth;
                        }
                    };

                if (resizeTimeout) {
                    clearTimeout(resizeTimeout);
                }

                execAsap ? dispatch() : (resizeTimeout = setTimeout(dispatch, $special.threshold));
            },
            threshold: 150,
        };
    })();
    /**
     * Owl Carousel v2.3.4
     * Copyright 2013-2018 David Deutsch
     * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
     */
    !(function (a, b, c, d) {
        function e(b, c) {
            (this.settings = null),
                (this.options = a.extend({}, e.Defaults, c)),
                (this.$element = a(b)),
                (this._handlers = {}),
                (this._plugins = {}),
                (this._supress = {}),
                (this._current = null),
                (this._speed = null),
                (this._coordinates = []),
                (this._breakpoint = null),
                (this._width = null),
                (this._items = []),
                (this._clones = []),
                (this._mergers = []),
                (this._widths = []),
                (this._invalidated = {}),
                (this._pipe = []),
                (this._drag = {
                    time: null,
                    target: null,
                    pointer: null,
                    stage: { start: null, current: null },
                    direction: null,
                }),
                (this._states = {
                    current: {},
                    tags: { initializing: ["busy"], animating: ["busy"], dragging: ["interacting"] },
                }),
                a.each(
                    ["onResize", "onThrottledResize"],
                    a.proxy(function (b, c) {
                        this._handlers[c] = a.proxy(this[c], this);
                    }, this)
                ),
                a.each(
                    e.Plugins,
                    a.proxy(function (a, b) {
                        this._plugins[a.charAt(0).toLowerCase() + a.slice(1)] = new b(this);
                    }, this)
                ),
                a.each(
                    e.Workers,
                    a.proxy(function (b, c) {
                        this._pipe.push({ filter: c.filter, run: a.proxy(c.run, this) });
                    }, this)
                ),
                this.setup(),
                this.initialize();
        }
        (e.Defaults = {
            items: 3,
            loop: !1,
            center: !1,
            rewind: !1,
            checkVisibility: !0,
            mouseDrag: !0,
            touchDrag: !0,
            pullDrag: !0,
            freeDrag: !1,
            margin: 0,
            stagePadding: 0,
            merge: !1,
            mergeFit: !0,
            autoWidth: !1,
            startPosition: 0,
            rtl: !1,
            smartSpeed: 250,
            fluidSpeed: !1,
            dragEndSpeed: !1,
            responsive: {},
            responsiveRefreshRate: 200,
            responsiveBaseElement: b,
            fallbackEasing: "swing",
            slideTransition: "",
            info: !1,
            nestedItemSelector: !1,
            itemElement: "div",
            stageElement: "div",
            refreshClass: "owl-refresh",
            loadedClass: "owl-loaded",
            loadingClass: "owl-loading",
            rtlClass: "owl-rtl",
            responsiveClass: "owl-responsive",
            dragClass: "owl-drag",
            itemClass: "owl-item",
            stageClass: "owl-stage",
            stageOuterClass: "owl-stage-outer",
            grabClass: "owl-grab",
        }),
            (e.Width = { Default: "default", Inner: "inner", Outer: "outer" }),
            (e.Type = { Event: "event", State: "state" }),
            (e.Plugins = {}),
            (e.Workers = [
                {
                    filter: ["width", "settings"],
                    run: function run() {
                        this._width = this.$element.width();
                    },
                },
                {
                    filter: ["width", "items", "settings"],
                    run: function run(a) {
                        a.current = this._items && this._items[this.relative(this._current)];
                    },
                },
                {
                    filter: ["items", "settings"],
                    run: function run() {
                        this.$stage.children(".cloned").remove();
                    },
                },
                {
                    filter: ["width", "items", "settings"],
                    run: function run(a) {
                        var b = this.settings.margin || "",
                            c = !this.settings.autoWidth,
                            d = this.settings.rtl,
                            e = { width: "auto", "margin-left": d ? b : "", "margin-right": d ? "" : b };
                        !c && this.$stage.children().css(e), (a.css = e);
                    },
                },
                {
                    filter: ["width", "items", "settings"],
                    run: function run(a) {
                        var b = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,
                            c = null,
                            d = this._items.length,
                            e = !this.settings.autoWidth,
                            f = [];
                        for (a.items = { merge: !1, width: b }; d--; ) {
                            (c = this._mergers[d]),
                                (c = (this.settings.mergeFit && Math.min(c, this.settings.items)) || c),
                                (a.items.merge = c > 1 || a.items.merge),
                                (f[d] = e ? b * c : this._items[d].width());
                        }
                        this._widths = f;
                    },
                },
                {
                    filter: ["items", "settings"],
                    run: function run() {
                        var b = [],
                            c = this._items,
                            d = this.settings,
                            e = Math.max(2 * d.items, 4),
                            f = 2 * Math.ceil(c.length / 2),
                            g = d.loop && c.length ? (d.rewind ? e : Math.max(e, f)) : 0,
                            h = "",
                            i = "";
                        for (g /= 2; g > 0; ) {
                            b.push(this.normalize(b.length / 2, !0)),
                                (h += c[b[b.length - 1]][0].outerHTML),
                                b.push(this.normalize(c.length - 1 - (b.length - 1) / 2, !0)),
                                (i = c[b[b.length - 1]][0].outerHTML + i),
                                (g -= 1);
                        }
                        (this._clones = b),
                            a(h).addClass("cloned").appendTo(this.$stage),
                            a(i).addClass("cloned").prependTo(this.$stage);
                    },
                },
                {
                    filter: ["width", "items", "settings"],
                    run: function run() {
                        for (
                            var a = this.settings.rtl ? 1 : -1,
                                b = this._clones.length + this._items.length,
                                c = -1,
                                d = 0,
                                e = 0,
                                f = [];
                            ++c < b;

                        ) {
                            (d = f[c - 1] || 0),
                                (e = this._widths[this.relative(c)] + this.settings.margin),
                                f.push(d + e * a);
                        }
                        this._coordinates = f;
                    },
                },
                {
                    filter: ["width", "items", "settings"],
                    run: function run() {
                        var a = this.settings.stagePadding,
                            b = this._coordinates,
                            c = {
                                width: Math.ceil(Math.abs(b[b.length - 1])) + 2 * a,
                                "padding-left": a || "",
                                "padding-right": a || "",
                            };
                        this.$stage.css(c);
                    },
                },
                {
                    filter: ["width", "items", "settings"],
                    run: function run(a) {
                        var b = this._coordinates.length,
                            c = !this.settings.autoWidth,
                            d = this.$stage.children();
                        if (c && a.items.merge)
                            for (; b--; ) {
                                (a.css.width = this._widths[this.relative(b)]), d.eq(b).css(a.css);
                            }
                        else c && ((a.css.width = a.items.width), d.css(a.css));
                    },
                },
                {
                    filter: ["items"],
                    run: function run() {
                        this._coordinates.length < 1 && this.$stage.removeAttr("style");
                    },
                },
                {
                    filter: ["width", "items", "settings"],
                    run: function run(a) {
                        (a.current = a.current ? this.$stage.children().index(a.current) : 0),
                            (a.current = Math.max(this.minimum(), Math.min(this.maximum(), a.current))),
                            this.reset(a.current);
                    },
                },
                {
                    filter: ["position"],
                    run: function run() {
                        this.animate(this.coordinates(this._current));
                    },
                },
                {
                    filter: ["width", "position", "items", "settings"],
                    run: function run() {
                        var a,
                            b,
                            c,
                            d,
                            e = this.settings.rtl ? 1 : -1,
                            f = 2 * this.settings.stagePadding,
                            g = this.coordinates(this.current()) + f,
                            h = g + this.width() * e,
                            i = [];
                        for (c = 0, d = this._coordinates.length; c < d; c++) {
                            (a = this._coordinates[c - 1] || 0),
                                (b = Math.abs(this._coordinates[c]) + f * e),
                                ((this.op(a, "<=", g) && this.op(a, ">", h)) ||
                                    (this.op(b, "<", g) && this.op(b, ">", h))) &&
                                    i.push(c);
                        }
                        this.$stage.children(".active").removeClass("active"),
                            this.$stage.children(":eq(" + i.join("), :eq(") + ")").addClass("active"),
                            this.$stage.children(".center").removeClass("center"),
                            this.settings.center && this.$stage.children().eq(this.current()).addClass("center");
                    },
                },
            ]),
            (e.prototype.initializeStage = function () {
                (this.$stage = this.$element.find("." + this.settings.stageClass)),
                    this.$stage.length ||
                        (this.$element.addClass(this.options.loadingClass),
                        (this.$stage = a("<" + this.settings.stageElement + ">", {
                            class: this.settings.stageClass,
                        }).wrap(a("<div/>", { class: this.settings.stageOuterClass }))),
                        this.$element.append(this.$stage.parent()));
            }),
            (e.prototype.initializeItems = function () {
                var b = this.$element.find(".owl-item");
                if (b.length)
                    return (
                        (this._items = b.get().map(function (b) {
                            return a(b);
                        })),
                        (this._mergers = this._items.map(function () {
                            return 1;
                        })),
                        void this.refresh()
                    );
                this.replace(this.$element.children().not(this.$stage.parent())),
                    this.isVisible() ? this.refresh() : this.invalidate("width"),
                    this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass);
            }),
            (e.prototype.initialize = function () {
                if (
                    (this.enter("initializing"),
                    this.trigger("initialize"),
                    this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl),
                    this.settings.autoWidth && !this.is("pre-loading"))
                ) {
                    var a, b, c;
                    (a = this.$element.find("img")),
                        (b = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : d),
                        (c = this.$element.children(b).width()),
                        a.length && c <= 0 && this.preloadAutoWidthImages(a);
                }
                this.initializeStage(),
                    this.initializeItems(),
                    this.registerEventHandlers(),
                    this.leave("initializing"),
                    this.trigger("initialized");
            }),
            (e.prototype.isVisible = function () {
                return !this.settings.checkVisibility || this.$element.is(":visible");
            }),
            (e.prototype.setup = function () {
                var b = this.viewport(),
                    c = this.options.responsive,
                    d = -1,
                    e = null;
                c
                    ? (a.each(c, function (a) {
                          a <= b && a > d && (d = Number(a));
                      }),
                      (e = a.extend({}, this.options, c[d])),
                      "function" == typeof e.stagePadding && (e.stagePadding = e.stagePadding()),
                      delete e.responsive,
                      e.responsiveClass &&
                          this.$element.attr(
                              "class",
                              this.$element
                                  .attr("class")
                                  .replace(new RegExp("(" + this.options.responsiveClass + "-)\\S+\\s", "g"), "$1" + d)
                          ))
                    : (e = a.extend({}, this.options)),
                    this.trigger("change", { property: { name: "settings", value: e } }),
                    (this._breakpoint = d),
                    (this.settings = e),
                    this.invalidate("settings"),
                    this.trigger("changed", { property: { name: "settings", value: this.settings } });
            }),
            (e.prototype.optionsLogic = function () {
                this.settings.autoWidth && ((this.settings.stagePadding = !1), (this.settings.merge = !1));
            }),
            (e.prototype.prepare = function (b) {
                var c = this.trigger("prepare", { content: b });
                return (
                    c.data ||
                        (c.data = a("<" + this.settings.itemElement + "/>")
                            .addClass(this.options.itemClass)
                            .append(b)),
                    this.trigger("prepared", { content: c.data }),
                    c.data
                );
            }),
            (e.prototype.update = function () {
                for (
                    var b = 0,
                        c = this._pipe.length,
                        d = a.proxy(function (a) {
                            return this[a];
                        }, this._invalidated),
                        e = {};
                    b < c;

                ) {
                    (this._invalidated.all || a.grep(this._pipe[b].filter, d).length > 0) && this._pipe[b].run(e), b++;
                }
                (this._invalidated = {}), !this.is("valid") && this.enter("valid");
            }),
            (e.prototype.width = function (a) {
                switch ((a = a || e.Width.Default)) {
                    case e.Width.Inner:
                    case e.Width.Outer:
                        return this._width;
                    default:
                        return this._width - 2 * this.settings.stagePadding + this.settings.margin;
                }
            }),
            (e.prototype.refresh = function () {
                this.enter("refreshing"),
                    this.trigger("refresh"),
                    this.setup(),
                    this.optionsLogic(),
                    this.$element.addClass(this.options.refreshClass),
                    this.update(),
                    this.$element.removeClass(this.options.refreshClass),
                    this.leave("refreshing"),
                    this.trigger("refreshed");
            }),
            (e.prototype.onThrottledResize = function () {
                b.clearTimeout(this.resizeTimer),
                    (this.resizeTimer = b.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate));
            }),
            (e.prototype.onResize = function () {
                return (
                    !!this._items.length &&
                    this._width !== this.$element.width() &&
                    !!this.isVisible() &&
                    (this.enter("resizing"),
                    this.trigger("resize").isDefaultPrevented()
                        ? (this.leave("resizing"), !1)
                        : (this.invalidate("width"),
                          this.refresh(),
                          this.leave("resizing"),
                          void this.trigger("resized")))
                );
            }),
            (e.prototype.registerEventHandlers = function () {
                a.support.transition &&
                    this.$stage.on(a.support.transition.end + ".owl.core", a.proxy(this.onTransitionEnd, this)),
                    !1 !== this.settings.responsive && this.on(b, "resize", this._handlers.onThrottledResize),
                    this.settings.mouseDrag &&
                        (this.$element.addClass(this.options.dragClass),
                        this.$stage.on("mousedown.owl.core", a.proxy(this.onDragStart, this)),
                        this.$stage.on("dragstart.owl.core selectstart.owl.core", function () {
                            return !1;
                        })),
                    this.settings.touchDrag &&
                        (this.$stage.on("touchstart.owl.core", a.proxy(this.onDragStart, this)),
                        this.$stage.on("touchcancel.owl.core", a.proxy(this.onDragEnd, this)));
            }),
            (e.prototype.onDragStart = function (b) {
                var d = null;
                3 !== b.which &&
                    (a.support.transform
                        ? ((d = this.$stage
                              .css("transform")
                              .replace(/.*\(|\)| /g, "")
                              .split(",")),
                          (d = { x: d[16 === d.length ? 12 : 4], y: d[16 === d.length ? 13 : 5] }))
                        : ((d = this.$stage.position()),
                          (d = {
                              x: this.settings.rtl
                                  ? d.left + this.$stage.width() - this.width() + this.settings.margin
                                  : d.left,
                              y: d.top,
                          })),
                    this.is("animating") &&
                        (a.support.transform ? this.animate(d.x) : this.$stage.stop(), this.invalidate("position")),
                    this.$element.toggleClass(this.options.grabClass, "mousedown" === b.type),
                    this.speed(0),
                    (this._drag.time = new Date().getTime()),
                    (this._drag.target = a(b.target)),
                    (this._drag.stage.start = d),
                    (this._drag.stage.current = d),
                    (this._drag.pointer = this.pointer(b)),
                    a(c).on("mouseup.owl.core touchend.owl.core", a.proxy(this.onDragEnd, this)),
                    a(c).one(
                        "mousemove.owl.core touchmove.owl.core",
                        a.proxy(function (b) {
                            var d = this.difference(this._drag.pointer, this.pointer(b));
                            a(c).on("mousemove.owl.core touchmove.owl.core", a.proxy(this.onDragMove, this)),
                                (Math.abs(d.x) < Math.abs(d.y) && this.is("valid")) ||
                                    (b.preventDefault(), this.enter("dragging"), this.trigger("drag"));
                        }, this)
                    ));
            }),
            (e.prototype.onDragMove = function (a) {
                var b = null,
                    c = null,
                    d = null,
                    e = this.difference(this._drag.pointer, this.pointer(a)),
                    f = this.difference(this._drag.stage.start, e);
                this.is("dragging") &&
                    (a.preventDefault(),
                    this.settings.loop
                        ? ((b = this.coordinates(this.minimum())),
                          (c = this.coordinates(this.maximum() + 1) - b),
                          (f.x = ((((f.x - b) % c) + c) % c) + b))
                        : ((b = this.settings.rtl
                              ? this.coordinates(this.maximum())
                              : this.coordinates(this.minimum())),
                          (c = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum())),
                          (d = this.settings.pullDrag ? (-1 * e.x) / 5 : 0),
                          (f.x = Math.max(Math.min(f.x, b + d), c + d))),
                    (this._drag.stage.current = f),
                    this.animate(f.x));
            }),
            (e.prototype.onDragEnd = function (b) {
                var d = this.difference(this._drag.pointer, this.pointer(b)),
                    e = this._drag.stage.current,
                    f = (d.x > 0) ^ this.settings.rtl ? "left" : "right";
                a(c).off(".owl.core"),
                    this.$element.removeClass(this.options.grabClass),
                    ((0 !== d.x && this.is("dragging")) || !this.is("valid")) &&
                        (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed),
                        this.current(this.closest(e.x, 0 !== d.x ? f : this._drag.direction)),
                        this.invalidate("position"),
                        this.update(),
                        (this._drag.direction = f),
                        (Math.abs(d.x) > 3 || new Date().getTime() - this._drag.time > 300) &&
                            this._drag.target.one("click.owl.core", function () {
                                return !1;
                            })),
                    this.is("dragging") && (this.leave("dragging"), this.trigger("dragged"));
            }),
            (e.prototype.closest = function (b, c) {
                var e = -1,
                    f = 30,
                    g = this.width(),
                    h = this.coordinates();
                return (
                    this.settings.freeDrag ||
                        a.each(
                            h,
                            a.proxy(function (a, i) {
                                return (
                                    "left" === c && b > i - f && b < i + f
                                        ? (e = a)
                                        : "right" === c && b > i - g - f && b < i - g + f
                                          ? (e = a + 1)
                                          : this.op(b, "<", i) &&
                                            this.op(b, ">", h[a + 1] !== d ? h[a + 1] : i - g) &&
                                            (e = "left" === c ? a + 1 : a),
                                    -1 === e
                                );
                            }, this)
                        ),
                    this.settings.loop ||
                        (this.op(b, ">", h[this.minimum()])
                            ? (e = b = this.minimum())
                            : this.op(b, "<", h[this.maximum()]) && (e = b = this.maximum())),
                    e
                );
            }),
            (e.prototype.animate = function (b) {
                var c = this.speed() > 0;
                this.is("animating") && this.onTransitionEnd(),
                    c && (this.enter("animating"), this.trigger("translate")),
                    a.support.transform3d && a.support.transition
                        ? this.$stage.css({
                              transform: "translate3d(" + b + "px,0px,0px)",
                              transition:
                                  this.speed() / 1e3 +
                                  "s" +
                                  (this.settings.slideTransition ? " " + this.settings.slideTransition : ""),
                          })
                        : c
                          ? this.$stage.animate(
                                { left: b + "px" },
                                this.speed(),
                                this.settings.fallbackEasing,
                                a.proxy(this.onTransitionEnd, this)
                            )
                          : this.$stage.css({ left: b + "px" });
            }),
            (e.prototype.is = function (a) {
                return this._states.current[a] && this._states.current[a] > 0;
            }),
            (e.prototype.current = function (a) {
                if (a === d) return this._current;
                if (0 === this._items.length) return d;
                if (((a = this.normalize(a)), this._current !== a)) {
                    var b = this.trigger("change", { property: { name: "position", value: a } });
                    b.data !== d && (a = this.normalize(b.data)),
                        (this._current = a),
                        this.invalidate("position"),
                        this.trigger("changed", { property: { name: "position", value: this._current } });
                }
                return this._current;
            }),
            (e.prototype.invalidate = function (b) {
                return (
                    "string" === a.type(b) && ((this._invalidated[b] = !0), this.is("valid") && this.leave("valid")),
                    a.map(this._invalidated, function (a, b) {
                        return b;
                    })
                );
            }),
            (e.prototype.reset = function (a) {
                (a = this.normalize(a)) !== d &&
                    ((this._speed = 0),
                    (this._current = a),
                    this.suppress(["translate", "translated"]),
                    this.animate(this.coordinates(a)),
                    this.release(["translate", "translated"]));
            }),
            (e.prototype.normalize = function (a, b) {
                var c = this._items.length,
                    e = b ? 0 : this._clones.length;
                return (
                    !this.isNumeric(a) || c < 1
                        ? (a = d)
                        : (a < 0 || a >= c + e) && (a = ((((a - e / 2) % c) + c) % c) + e / 2),
                    a
                );
            }),
            (e.prototype.relative = function (a) {
                return (a -= this._clones.length / 2), this.normalize(a, !0);
            }),
            (e.prototype.maximum = function (a) {
                var b,
                    c,
                    d,
                    e = this.settings,
                    f = this._coordinates.length;
                if (e.loop) f = this._clones.length / 2 + this._items.length - 1;
                else if (e.autoWidth || e.merge) {
                    if ((b = this._items.length))
                        for (
                            c = this._items[--b].width(), d = this.$element.width();
                            b-- && !((c += this._items[b].width() + this.settings.margin) > d);

                        ) {}
                    f = b + 1;
                } else f = e.center ? this._items.length - 1 : this._items.length - e.items;
                return a && (f -= this._clones.length / 2), Math.max(f, 0);
            }),
            (e.prototype.minimum = function (a) {
                return a ? 0 : this._clones.length / 2;
            }),
            (e.prototype.items = function (a) {
                return a === d ? this._items.slice() : ((a = this.normalize(a, !0)), this._items[a]);
            }),
            (e.prototype.mergers = function (a) {
                return a === d ? this._mergers.slice() : ((a = this.normalize(a, !0)), this._mergers[a]);
            }),
            (e.prototype.clones = function (b) {
                var c = this._clones.length / 2,
                    e = c + this._items.length,
                    f = function f(a) {
                        return a % 2 == 0 ? e + a / 2 : c - (a + 1) / 2;
                    };
                return b === d
                    ? a.map(this._clones, function (a, b) {
                          return f(b);
                      })
                    : a.map(this._clones, function (a, c) {
                          return a === b ? f(c) : null;
                      });
            }),
            (e.prototype.speed = function (a) {
                return a !== d && (this._speed = a), this._speed;
            }),
            (e.prototype.coordinates = function (b) {
                var c,
                    e = 1,
                    f = b - 1;
                return b === d
                    ? a.map(
                          this._coordinates,
                          a.proxy(function (a, b) {
                              return this.coordinates(b);
                          }, this)
                      )
                    : (this.settings.center
                          ? (this.settings.rtl && ((e = -1), (f = b + 1)),
                            (c = this._coordinates[b]),
                            (c += ((this.width() - c + (this._coordinates[f] || 0)) / 2) * e))
                          : (c = this._coordinates[f] || 0),
                      (c = Math.ceil(c)));
            }),
            (e.prototype.duration = function (a, b, c) {
                return 0 === c
                    ? 0
                    : Math.min(Math.max(Math.abs(b - a), 1), 6) * Math.abs(c || this.settings.smartSpeed);
            }),
            (e.prototype.to = function (a, b) {
                var c = this.current(),
                    d = null,
                    e = a - this.relative(c),
                    f = (e > 0) - (e < 0),
                    g = this._items.length,
                    h = this.minimum(),
                    i = this.maximum();
                this.settings.loop
                    ? (!this.settings.rewind && Math.abs(e) > g / 2 && (e += -1 * f * g),
                      (a = c + e),
                      (d = ((((a - h) % g) + g) % g) + h) !== a &&
                          d - e <= i &&
                          d - e > 0 &&
                          ((c = d - e), (a = d), this.reset(c)))
                    : this.settings.rewind
                      ? ((i += 1), (a = ((a % i) + i) % i))
                      : (a = Math.max(h, Math.min(i, a))),
                    this.speed(this.duration(c, a, b)),
                    this.current(a),
                    this.isVisible() && this.update();
            }),
            (e.prototype.next = function (a) {
                (a = a || !1), this.to(this.relative(this.current()) + 1, a);
            }),
            (e.prototype.prev = function (a) {
                (a = a || !1), this.to(this.relative(this.current()) - 1, a);
            }),
            (e.prototype.onTransitionEnd = function (a) {
                if (
                    a !== d &&
                    (a.stopPropagation(), (a.target || a.srcElement || a.originalTarget) !== this.$stage.get(0))
                )
                    return !1;
                this.leave("animating"), this.trigger("translated");
            }),
            (e.prototype.viewport = function () {
                var d;
                return (
                    this.options.responsiveBaseElement !== b
                        ? (d = a(this.options.responsiveBaseElement).width())
                        : b.innerWidth
                          ? (d = b.innerWidth)
                          : c.documentElement && c.documentElement.clientWidth
                            ? (d = c.documentElement.clientWidth)
                            : console.warn("Can not detect viewport width."),
                    d
                );
            }),
            (e.prototype.replace = function (b) {
                this.$stage.empty(),
                    (this._items = []),
                    b && (b = b instanceof jQuery ? b : a(b)),
                    this.settings.nestedItemSelector && (b = b.find("." + this.settings.nestedItemSelector)),
                    b
                        .filter(function () {
                            return 1 === this.nodeType;
                        })
                        .each(
                            a.proxy(function (a, b) {
                                (b = this.prepare(b)),
                                    this.$stage.append(b),
                                    this._items.push(b),
                                    this._mergers.push(
                                        1 * b.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1
                                    );
                            }, this)
                        ),
                    this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0),
                    this.invalidate("items");
            }),
            (e.prototype.add = function (b, c) {
                var e = this.relative(this._current);
                (c = c === d ? this._items.length : this.normalize(c, !0)),
                    (b = b instanceof jQuery ? b : a(b)),
                    this.trigger("add", { content: b, position: c }),
                    (b = this.prepare(b)),
                    0 === this._items.length || c === this._items.length
                        ? (0 === this._items.length && this.$stage.append(b),
                          0 !== this._items.length && this._items[c - 1].after(b),
                          this._items.push(b),
                          this._mergers.push(
                              1 * b.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1
                          ))
                        : (this._items[c].before(b),
                          this._items.splice(c, 0, b),
                          this._mergers.splice(
                              c,
                              0,
                              1 * b.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1
                          )),
                    this._items[e] && this.reset(this._items[e].index()),
                    this.invalidate("items"),
                    this.trigger("added", { content: b, position: c });
            }),
            (e.prototype.remove = function (a) {
                (a = this.normalize(a, !0)) !== d &&
                    (this.trigger("remove", { content: this._items[a], position: a }),
                    this._items[a].remove(),
                    this._items.splice(a, 1),
                    this._mergers.splice(a, 1),
                    this.invalidate("items"),
                    this.trigger("removed", { content: null, position: a }));
            }),
            (e.prototype.preloadAutoWidthImages = function (b) {
                b.each(
                    a.proxy(function (b, c) {
                        this.enter("pre-loading"),
                            (c = a(c)),
                            a(new Image())
                                .one(
                                    "load",
                                    a.proxy(function (a) {
                                        c.attr("src", a.target.src),
                                            c.css("opacity", 1),
                                            this.leave("pre-loading"),
                                            !this.is("pre-loading") && !this.is("initializing") && this.refresh();
                                    }, this)
                                )
                                .attr("src", c.attr("src") || c.attr("data-src") || c.attr("data-src-retina"));
                    }, this)
                );
            }),
            (e.prototype.destroy = function () {
                this.$element.off(".owl.core"),
                    this.$stage.off(".owl.core"),
                    a(c).off(".owl.core"),
                    !1 !== this.settings.responsive &&
                        (b.clearTimeout(this.resizeTimer), this.off(b, "resize", this._handlers.onThrottledResize));
                for (var d in this._plugins) {
                    this._plugins[d].destroy();
                }
                this.$stage.children(".cloned").remove(),
                    this.$stage.unwrap(),
                    this.$stage.children().contents().unwrap(),
                    this.$stage.children().unwrap(),
                    this.$stage.remove(),
                    this.$element
                        .removeClass(this.options.refreshClass)
                        .removeClass(this.options.loadingClass)
                        .removeClass(this.options.loadedClass)
                        .removeClass(this.options.rtlClass)
                        .removeClass(this.options.dragClass)
                        .removeClass(this.options.grabClass)
                        .attr(
                            "class",
                            this.$element
                                .attr("class")
                                .replace(new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"), "")
                        )
                        .removeData("owl.carousel");
            }),
            (e.prototype.op = function (a, b, c) {
                var d = this.settings.rtl;
                switch (b) {
                    case "<":
                        return d ? a > c : a < c;
                    case ">":
                        return d ? a < c : a > c;
                    case ">=":
                        return d ? a <= c : a >= c;
                    case "<=":
                        return d ? a >= c : a <= c;
                }
            }),
            (e.prototype.on = function (a, b, c, d) {
                a.addEventListener ? a.addEventListener(b, c, d) : a.attachEvent && a.attachEvent("on" + b, c);
            }),
            (e.prototype.off = function (a, b, c, d) {
                a.removeEventListener ? a.removeEventListener(b, c, d) : a.detachEvent && a.detachEvent("on" + b, c);
            }),
            (e.prototype.trigger = function (b, c, d, f, g) {
                var h = { item: { count: this._items.length, index: this.current() } },
                    i = a.camelCase(
                        a
                            .grep(["on", b, d], function (a) {
                                return a;
                            })
                            .join("-")
                            .toLowerCase()
                    ),
                    j = a.Event(
                        [b, "owl", d || "carousel"].join(".").toLowerCase(),
                        a.extend({ relatedTarget: this }, h, c)
                    );
                return (
                    this._supress[b] ||
                        (a.each(this._plugins, function (a, b) {
                            b.onTrigger && b.onTrigger(j);
                        }),
                        this.register({ type: e.Type.Event, name: b }),
                        this.$element.trigger(j),
                        this.settings && "function" == typeof this.settings[i] && this.settings[i].call(this, j)),
                    j
                );
            }),
            (e.prototype.enter = function (b) {
                a.each(
                    [b].concat(this._states.tags[b] || []),
                    a.proxy(function (a, b) {
                        this._states.current[b] === d && (this._states.current[b] = 0), this._states.current[b]++;
                    }, this)
                );
            }),
            (e.prototype.leave = function (b) {
                a.each(
                    [b].concat(this._states.tags[b] || []),
                    a.proxy(function (a, b) {
                        this._states.current[b]--;
                    }, this)
                );
            }),
            (e.prototype.register = function (b) {
                if (b.type === e.Type.Event) {
                    if ((a.event.special[b.name] || (a.event.special[b.name] = {}), !a.event.special[b.name].owl)) {
                        var c = a.event.special[b.name]._default;
                        (a.event.special[b.name]._default = function (a) {
                            return !c || !c.apply || (a.namespace && -1 !== a.namespace.indexOf("owl"))
                                ? a.namespace && a.namespace.indexOf("owl") > -1
                                : c.apply(this, arguments);
                        }),
                            (a.event.special[b.name].owl = !0);
                    }
                } else
                    b.type === e.Type.State &&
                        (this._states.tags[b.name]
                            ? (this._states.tags[b.name] = this._states.tags[b.name].concat(b.tags))
                            : (this._states.tags[b.name] = b.tags),
                        (this._states.tags[b.name] = a.grep(
                            this._states.tags[b.name],
                            a.proxy(function (c, d) {
                                return a.inArray(c, this._states.tags[b.name]) === d;
                            }, this)
                        )));
            }),
            (e.prototype.suppress = function (b) {
                a.each(
                    b,
                    a.proxy(function (a, b) {
                        this._supress[b] = !0;
                    }, this)
                );
            }),
            (e.prototype.release = function (b) {
                a.each(
                    b,
                    a.proxy(function (a, b) {
                        delete this._supress[b];
                    }, this)
                );
            }),
            (e.prototype.pointer = function (a) {
                var c = { x: null, y: null };
                return (
                    (a = a.originalEvent || a || b.event),
                    (a =
                        a.touches && a.touches.length
                            ? a.touches[0]
                            : a.changedTouches && a.changedTouches.length
                              ? a.changedTouches[0]
                              : a),
                    a.pageX ? ((c.x = a.pageX), (c.y = a.pageY)) : ((c.x = a.clientX), (c.y = a.clientY)),
                    c
                );
            }),
            (e.prototype.isNumeric = function (a) {
                return !isNaN(parseFloat(a));
            }),
            (e.prototype.difference = function (a, b) {
                return { x: a.x - b.x, y: a.y - b.y };
            }),
            (a.fn.owlCarousel = function (b) {
                var c = Array.prototype.slice.call(arguments, 1);
                return this.each(function () {
                    var d = a(this),
                        f = d.data("owl.carousel");
                    f ||
                        ((f = new e(this, "object" == _typeof(b) && b)),
                        d.data("owl.carousel", f),
                        a.each(
                            ["next", "prev", "to", "destroy", "refresh", "replace", "add", "remove"],
                            function (b, c) {
                                f.register({ type: e.Type.Event, name: c }),
                                    f.$element.on(
                                        c + ".owl.carousel.core",
                                        a.proxy(function (a) {
                                            a.namespace &&
                                                a.relatedTarget !== this &&
                                                (this.suppress([c]),
                                                f[c].apply(this, [].slice.call(arguments, 1)),
                                                this.release([c]));
                                        }, f)
                                    );
                            }
                        )),
                        "string" == typeof b && "_" !== b.charAt(0) && f[b].apply(f, c);
                });
            }),
            (a.fn.owlCarousel.Constructor = e);
    })(window.Zepto || window.jQuery, window, document),
        (function (a, b, c, d) {
            var e = function e(b) {
                (this._core = b),
                    (this._interval = null),
                    (this._visible = null),
                    (this._handlers = {
                        "initialized.owl.carousel": a.proxy(function (a) {
                            a.namespace && this._core.settings.autoRefresh && this.watch();
                        }, this),
                    }),
                    (this._core.options = a.extend({}, e.Defaults, this._core.options)),
                    this._core.$element.on(this._handlers);
            };
            (e.Defaults = { autoRefresh: !0, autoRefreshInterval: 500 }),
                (e.prototype.watch = function () {
                    this._interval ||
                        ((this._visible = this._core.isVisible()),
                        (this._interval = b.setInterval(
                            a.proxy(this.refresh, this),
                            this._core.settings.autoRefreshInterval
                        )));
                }),
                (e.prototype.refresh = function () {
                    this._core.isVisible() !== this._visible &&
                        ((this._visible = !this._visible),
                        this._core.$element.toggleClass("owl-hidden", !this._visible),
                        this._visible && this._core.invalidate("width") && this._core.refresh());
                }),
                (e.prototype.destroy = function () {
                    var a, c;
                    b.clearInterval(this._interval);
                    for (a in this._handlers) {
                        this._core.$element.off(a, this._handlers[a]);
                    }
                    for (c in Object.getOwnPropertyNames(this)) {
                        "function" != typeof this[c] && (this[c] = null);
                    }
                }),
                (a.fn.owlCarousel.Constructor.Plugins.AutoRefresh = e);
        })(window.Zepto || window.jQuery, window, document),
        (function (a, b, c, d) {
            var e = function e(b) {
                (this._core = b),
                    (this._loaded = []),
                    (this._handlers = {
                        "initialized.owl.carousel change.owl.carousel resized.owl.carousel": a.proxy(function (b) {
                            if (
                                b.namespace &&
                                this._core.settings &&
                                this._core.settings.lazyLoad &&
                                ((b.property && "position" == b.property.name) || "initialized" == b.type)
                            ) {
                                var c = this._core.settings,
                                    e = (c.center && Math.ceil(c.items / 2)) || c.items,
                                    f = (c.center && -1 * e) || 0,
                                    g =
                                        (b.property && b.property.value !== d
                                            ? b.property.value
                                            : this._core.current()) + f,
                                    h = this._core.clones().length,
                                    i = a.proxy(function (a, b) {
                                        this.load(b);
                                    }, this);
                                for (
                                    c.lazyLoadEager > 0 &&
                                    ((e += c.lazyLoadEager), c.loop && ((g -= c.lazyLoadEager), e++));
                                    f++ < e;

                                ) {
                                    this.load(h / 2 + this._core.relative(g)),
                                        h && a.each(this._core.clones(this._core.relative(g)), i),
                                        g++;
                                }
                            }
                        }, this),
                    }),
                    (this._core.options = a.extend({}, e.Defaults, this._core.options)),
                    this._core.$element.on(this._handlers);
            };
            (e.Defaults = { lazyLoad: !1, lazyLoadEager: 0 }),
                (e.prototype.load = function (c) {
                    var d = this._core.$stage.children().eq(c),
                        e = d && d.find(".owl-lazy");
                    !e ||
                        a.inArray(d.get(0), this._loaded) > -1 ||
                        (e.each(
                            a.proxy(function (c, d) {
                                var e,
                                    f = a(d),
                                    g =
                                        (b.devicePixelRatio > 1 && f.attr("data-src-retina")) ||
                                        f.attr("data-src") ||
                                        f.attr("data-srcset");
                                this._core.trigger("load", { element: f, url: g }, "lazy"),
                                    f.is("img")
                                        ? f
                                              .one(
                                                  "load.owl.lazy",
                                                  a.proxy(function () {
                                                      f.css("opacity", 1),
                                                          this._core.trigger("loaded", { element: f, url: g }, "lazy");
                                                  }, this)
                                              )
                                              .attr("src", g)
                                        : f.is("source")
                                          ? f
                                                .one(
                                                    "load.owl.lazy",
                                                    a.proxy(function () {
                                                        this._core.trigger("loaded", { element: f, url: g }, "lazy");
                                                    }, this)
                                                )
                                                .attr("srcset", g)
                                          : ((e = new Image()),
                                            (e.onload = a.proxy(function () {
                                                f.css({ "background-image": 'url("' + g + '")', opacity: "1" }),
                                                    this._core.trigger("loaded", { element: f, url: g }, "lazy");
                                            }, this)),
                                            (e.src = g));
                            }, this)
                        ),
                        this._loaded.push(d.get(0)));
                }),
                (e.prototype.destroy = function () {
                    var a, b;
                    for (a in this.handlers) {
                        this._core.$element.off(a, this.handlers[a]);
                    }
                    for (b in Object.getOwnPropertyNames(this)) {
                        "function" != typeof this[b] && (this[b] = null);
                    }
                }),
                (a.fn.owlCarousel.Constructor.Plugins.Lazy = e);
        })(window.Zepto || window.jQuery, window, document),
        (function (a, b, c, d) {
            var e = function e(c) {
                (this._core = c),
                    (this._previousHeight = null),
                    (this._handlers = {
                        "initialized.owl.carousel refreshed.owl.carousel": a.proxy(function (a) {
                            a.namespace && this._core.settings.autoHeight && this.update();
                        }, this),
                        "changed.owl.carousel": a.proxy(function (a) {
                            a.namespace &&
                                this._core.settings.autoHeight &&
                                "position" === a.property.name &&
                                this.update();
                        }, this),
                        "loaded.owl.lazy": a.proxy(function (a) {
                            a.namespace &&
                                this._core.settings.autoHeight &&
                                a.element.closest("." + this._core.settings.itemClass).index() ===
                                    this._core.current() &&
                                this.update();
                        }, this),
                    }),
                    (this._core.options = a.extend({}, e.Defaults, this._core.options)),
                    this._core.$element.on(this._handlers),
                    (this._intervalId = null);
                var d = this;
                a(b).on("load", function () {
                    d._core.settings.autoHeight && d.update();
                }),
                    a(b).resize(function () {
                        d._core.settings.autoHeight &&
                            (null != d._intervalId && clearTimeout(d._intervalId),
                            (d._intervalId = setTimeout(function () {
                                d.update();
                            }, 250)));
                    });
            };
            (e.Defaults = { autoHeight: !1, autoHeightClass: "owl-height" }),
                (e.prototype.update = function () {
                    var b = this._core._current,
                        c = b + this._core.settings.items,
                        d = this._core.settings.lazyLoad,
                        e = this._core.$stage.children().toArray().slice(b, c),
                        f = [],
                        g = 0;
                    a.each(e, function (b, c) {
                        f.push(a(c).height());
                    }),
                        (g = Math.max.apply(null, f)),
                        g <= 1 && d && this._previousHeight && (g = this._previousHeight),
                        (this._previousHeight = g),
                        this._core.$stage.parent().height(g).addClass(this._core.settings.autoHeightClass);
                }),
                (e.prototype.destroy = function () {
                    var a, b;
                    for (a in this._handlers) {
                        this._core.$element.off(a, this._handlers[a]);
                    }
                    for (b in Object.getOwnPropertyNames(this)) {
                        "function" != typeof this[b] && (this[b] = null);
                    }
                }),
                (a.fn.owlCarousel.Constructor.Plugins.AutoHeight = e);
        })(window.Zepto || window.jQuery, window, document),
        (function (a, b, c, d) {
            var e = function e(b) {
                (this._core = b),
                    (this._videos = {}),
                    (this._playing = null),
                    (this._handlers = {
                        "initialized.owl.carousel": a.proxy(function (a) {
                            a.namespace &&
                                this._core.register({ type: "state", name: "playing", tags: ["interacting"] });
                        }, this),
                        "resize.owl.carousel": a.proxy(function (a) {
                            a.namespace && this._core.settings.video && this.isInFullScreen() && a.preventDefault();
                        }, this),
                        "refreshed.owl.carousel": a.proxy(function (a) {
                            a.namespace &&
                                this._core.is("resizing") &&
                                this._core.$stage.find(".cloned .owl-video-frame").remove();
                        }, this),
                        "changed.owl.carousel": a.proxy(function (a) {
                            a.namespace && "position" === a.property.name && this._playing && this.stop();
                        }, this),
                        "prepared.owl.carousel": a.proxy(function (b) {
                            if (b.namespace) {
                                var c = a(b.content).find(".owl-video");
                                c.length && (c.css("display", "none"), this.fetch(c, a(b.content)));
                            }
                        }, this),
                    }),
                    (this._core.options = a.extend({}, e.Defaults, this._core.options)),
                    this._core.$element.on(this._handlers),
                    this._core.$element.on(
                        "click.owl.video",
                        ".owl-video-play-icon",
                        a.proxy(function (a) {
                            this.play(a);
                        }, this)
                    );
            };
            (e.Defaults = { video: !1, videoHeight: !1, videoWidth: !1 }),
                (e.prototype.fetch = function (a, b) {
                    var c = (function () {
                            return a.attr("data-vimeo-id") ? "vimeo" : a.attr("data-vzaar-id") ? "vzaar" : "youtube";
                        })(),
                        d = a.attr("data-vimeo-id") || a.attr("data-youtube-id") || a.attr("data-vzaar-id"),
                        e = a.attr("data-width") || this._core.settings.videoWidth,
                        f = a.attr("data-height") || this._core.settings.videoHeight,
                        g = a.attr("href");
                    if (!g) throw new Error("Missing video URL.");
                    if (
                        ((d = g.match(
                            /(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
                        )),
                        d[3].indexOf("youtu") > -1)
                    )
                        c = "youtube";
                    else if (d[3].indexOf("vimeo") > -1) c = "vimeo";
                    else {
                        if (!(d[3].indexOf("vzaar") > -1)) throw new Error("Video URL not supported.");
                        c = "vzaar";
                    }
                    (d = d[6]),
                        (this._videos[g] = { type: c, id: d, width: e, height: f }),
                        b.attr("data-video", g),
                        this.thumbnail(a, this._videos[g]);
                }),
                (e.prototype.thumbnail = function (b, c) {
                    var d,
                        e,
                        f,
                        g = c.width && c.height ? "width:" + c.width + "px;height:" + c.height + "px;" : "",
                        h = b.find("img"),
                        i = "src",
                        j = "",
                        k = this._core.settings,
                        l = function l(c) {
                            (e = '<div class="owl-video-play-icon"></div>'),
                                (d = k.lazyLoad
                                    ? a("<div/>", { class: "owl-video-tn " + j, srcType: c })
                                    : a("<div/>", {
                                          class: "owl-video-tn",
                                          style: "opacity:1;background-image:url(" + c + ")",
                                      })),
                                b.after(d),
                                b.after(e);
                        };
                    if (
                        (b.wrap(a("<div/>", { class: "owl-video-wrapper", style: g })),
                        this._core.settings.lazyLoad && ((i = "data-src"), (j = "owl-lazy")),
                        h.length)
                    )
                        return l(h.attr(i)), h.remove(), !1;
                    "youtube" === c.type
                        ? ((f = "//img.youtube.com/vi/" + c.id + "/hqdefault.jpg"), l(f))
                        : "vimeo" === c.type
                          ? a.ajax({
                                type: "GET",
                                url: "//vimeo.com/api/v2/video/" + c.id + ".json",
                                jsonp: "callback",
                                dataType: "jsonp",
                                success: function success(a) {
                                    (f = a[0].thumbnail_large), l(f);
                                },
                            })
                          : "vzaar" === c.type &&
                            a.ajax({
                                type: "GET",
                                url: "//vzaar.com/api/videos/" + c.id + ".json",
                                jsonp: "callback",
                                dataType: "jsonp",
                                success: function success(a) {
                                    (f = a.framegrab_url), l(f);
                                },
                            });
                }),
                (e.prototype.stop = function () {
                    this._core.trigger("stop", null, "video"),
                        this._playing.find(".owl-video-frame").remove(),
                        this._playing.removeClass("owl-video-playing"),
                        (this._playing = null),
                        this._core.leave("playing"),
                        this._core.trigger("stopped", null, "video");
                }),
                (e.prototype.play = function (b) {
                    var c,
                        d = a(b.target),
                        e = d.closest("." + this._core.settings.itemClass),
                        f = this._videos[e.attr("data-video")],
                        g = f.width || "100%",
                        h = f.height || this._core.$stage.height();
                    this._playing ||
                        (this._core.enter("playing"),
                        this._core.trigger("play", null, "video"),
                        (e = this._core.items(this._core.relative(e.index()))),
                        this._core.reset(e.index()),
                        (c = a(
                            '<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>'
                        )),
                        c.attr("height", h),
                        c.attr("width", g),
                        "youtube" === f.type
                            ? c.attr("src", "//www.youtube.com/embed/" + f.id + "?autoplay=1&rel=0&v=" + f.id)
                            : "vimeo" === f.type
                              ? c.attr("src", "//player.vimeo.com/video/" + f.id + "?autoplay=1")
                              : "vzaar" === f.type &&
                                c.attr("src", "//view.vzaar.com/" + f.id + "/player?autoplay=true"),
                        a(c).wrap('<div class="owl-video-frame" />').insertAfter(e.find(".owl-video")),
                        (this._playing = e.addClass("owl-video-playing")));
                }),
                (e.prototype.isInFullScreen = function () {
                    var b = c.fullscreenElement || c.mozFullScreenElement || c.webkitFullscreenElement;
                    return b && a(b).parent().hasClass("owl-video-frame");
                }),
                (e.prototype.destroy = function () {
                    var a, b;
                    this._core.$element.off("click.owl.video");
                    for (a in this._handlers) {
                        this._core.$element.off(a, this._handlers[a]);
                    }
                    for (b in Object.getOwnPropertyNames(this)) {
                        "function" != typeof this[b] && (this[b] = null);
                    }
                }),
                (a.fn.owlCarousel.Constructor.Plugins.Video = e);
        })(window.Zepto || window.jQuery, window, document),
        (function (a, b, c, d) {
            var e = function e(b) {
                (this.core = b),
                    (this.core.options = a.extend({}, e.Defaults, this.core.options)),
                    (this.swapping = !0),
                    (this.previous = d),
                    (this.next = d),
                    (this.handlers = {
                        "change.owl.carousel": a.proxy(function (a) {
                            a.namespace &&
                                "position" == a.property.name &&
                                ((this.previous = this.core.current()), (this.next = a.property.value));
                        }, this),
                        "drag.owl.carousel dragged.owl.carousel translated.owl.carousel": a.proxy(function (a) {
                            a.namespace && (this.swapping = "translated" == a.type);
                        }, this),
                        "translate.owl.carousel": a.proxy(function (a) {
                            a.namespace &&
                                this.swapping &&
                                (this.core.options.animateOut || this.core.options.animateIn) &&
                                this.swap();
                        }, this),
                    }),
                    this.core.$element.on(this.handlers);
            };
            (e.Defaults = { animateOut: !1, animateIn: !1 }),
                (e.prototype.swap = function () {
                    if (1 === this.core.settings.items && a.support.animation && a.support.transition) {
                        this.core.speed(0);
                        var b,
                            c = a.proxy(this.clear, this),
                            d = this.core.$stage.children().eq(this.previous),
                            e = this.core.$stage.children().eq(this.next),
                            f = this.core.settings.animateIn,
                            g = this.core.settings.animateOut;
                        this.core.current() !== this.previous &&
                            (g &&
                                ((b = this.core.coordinates(this.previous) - this.core.coordinates(this.next)),
                                d
                                    .one(a.support.animation.end, c)
                                    .css({ left: b + "px" })
                                    .addClass("animated owl-animated-out")
                                    .addClass(g)),
                            f && e.one(a.support.animation.end, c).addClass("animated owl-animated-in").addClass(f));
                    }
                }),
                (e.prototype.clear = function (b) {
                    a(b.target)
                        .css({ left: "" })
                        .removeClass("animated owl-animated-out owl-animated-in")
                        .removeClass(this.core.settings.animateIn)
                        .removeClass(this.core.settings.animateOut),
                        this.core.onTransitionEnd();
                }),
                (e.prototype.destroy = function () {
                    var a, b;
                    for (a in this.handlers) {
                        this.core.$element.off(a, this.handlers[a]);
                    }
                    for (b in Object.getOwnPropertyNames(this)) {
                        "function" != typeof this[b] && (this[b] = null);
                    }
                }),
                (a.fn.owlCarousel.Constructor.Plugins.Animate = e);
        })(window.Zepto || window.jQuery, window, document),
        (function (a, b, c, d) {
            var e = function e(b) {
                (this._core = b),
                    (this._call = null),
                    (this._time = 0),
                    (this._timeout = 0),
                    (this._paused = !0),
                    (this._handlers = {
                        "changed.owl.carousel": a.proxy(function (a) {
                            a.namespace && "settings" === a.property.name
                                ? this._core.settings.autoplay
                                    ? this.play()
                                    : this.stop()
                                : a.namespace && "position" === a.property.name && this._paused && (this._time = 0);
                        }, this),
                        "initialized.owl.carousel": a.proxy(function (a) {
                            a.namespace && this._core.settings.autoplay && this.play();
                        }, this),
                        "play.owl.autoplay": a.proxy(function (a, b, c) {
                            a.namespace && this.play(b, c);
                        }, this),
                        "stop.owl.autoplay": a.proxy(function (a) {
                            a.namespace && this.stop();
                        }, this),
                        "mouseover.owl.autoplay": a.proxy(function () {
                            this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause();
                        }, this),
                        "mouseleave.owl.autoplay": a.proxy(function () {
                            this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.play();
                        }, this),
                        "touchstart.owl.core": a.proxy(function () {
                            this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause();
                        }, this),
                        "touchend.owl.core": a.proxy(function () {
                            this._core.settings.autoplayHoverPause && this.play();
                        }, this),
                    }),
                    this._core.$element.on(this._handlers),
                    (this._core.options = a.extend({}, e.Defaults, this._core.options));
            };
            (e.Defaults = { autoplay: !1, autoplayTimeout: 5e3, autoplayHoverPause: !1, autoplaySpeed: !1 }),
                (e.prototype._next = function (d) {
                    (this._call = b.setTimeout(
                        a.proxy(this._next, this, d),
                        this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read()
                    )),
                        this._core.is("interacting") ||
                            c.hidden ||
                            this._core.next(d || this._core.settings.autoplaySpeed);
                }),
                (e.prototype.read = function () {
                    return new Date().getTime() - this._time;
                }),
                (e.prototype.play = function (c, d) {
                    var e;
                    this._core.is("rotating") || this._core.enter("rotating"),
                        (c = c || this._core.settings.autoplayTimeout),
                        (e = Math.min(this._time % (this._timeout || c), c)),
                        this._paused ? ((this._time = this.read()), (this._paused = !1)) : b.clearTimeout(this._call),
                        (this._time += (this.read() % c) - e),
                        (this._timeout = c),
                        (this._call = b.setTimeout(a.proxy(this._next, this, d), c - e));
                }),
                (e.prototype.stop = function () {
                    this._core.is("rotating") &&
                        ((this._time = 0),
                        (this._paused = !0),
                        b.clearTimeout(this._call),
                        this._core.leave("rotating"));
                }),
                (e.prototype.pause = function () {
                    this._core.is("rotating") &&
                        !this._paused &&
                        ((this._time = this.read()), (this._paused = !0), b.clearTimeout(this._call));
                }),
                (e.prototype.destroy = function () {
                    var a, b;
                    this.stop();
                    for (a in this._handlers) {
                        this._core.$element.off(a, this._handlers[a]);
                    }
                    for (b in Object.getOwnPropertyNames(this)) {
                        "function" != typeof this[b] && (this[b] = null);
                    }
                }),
                (a.fn.owlCarousel.Constructor.Plugins.autoplay = e);
        })(window.Zepto || window.jQuery, window, document),
        (function (a, b, c, d) {
            "use strict";
            var e = function e(b) {
                (this._core = b),
                    (this._initialized = !1),
                    (this._pages = []),
                    (this._controls = {}),
                    (this._templates = []),
                    (this.$element = this._core.$element),
                    (this._overrides = { next: this._core.next, prev: this._core.prev, to: this._core.to }),
                    (this._handlers = {
                        "prepared.owl.carousel": a.proxy(function (b) {
                            b.namespace &&
                                this._core.settings.dotsData &&
                                this._templates.push(
                                    '<div class="' +
                                        this._core.settings.dotClass +
                                        '">' +
                                        a(b.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot") +
                                        "</div>"
                                );
                        }, this),
                        "added.owl.carousel": a.proxy(function (a) {
                            a.namespace &&
                                this._core.settings.dotsData &&
                                this._templates.splice(a.position, 0, this._templates.pop());
                        }, this),
                        "remove.owl.carousel": a.proxy(function (a) {
                            a.namespace && this._core.settings.dotsData && this._templates.splice(a.position, 1);
                        }, this),
                        "changed.owl.carousel": a.proxy(function (a) {
                            a.namespace && "position" == a.property.name && this.draw();
                        }, this),
                        "initialized.owl.carousel": a.proxy(function (a) {
                            a.namespace &&
                                !this._initialized &&
                                (this._core.trigger("initialize", null, "navigation"),
                                this.initialize(),
                                this.update(),
                                this.draw(),
                                (this._initialized = !0),
                                this._core.trigger("initialized", null, "navigation"));
                        }, this),
                        "refreshed.owl.carousel": a.proxy(function (a) {
                            a.namespace &&
                                this._initialized &&
                                (this._core.trigger("refresh", null, "navigation"),
                                this.update(),
                                this.draw(),
                                this._core.trigger("refreshed", null, "navigation"));
                        }, this),
                    }),
                    (this._core.options = a.extend({}, e.Defaults, this._core.options)),
                    this.$element.on(this._handlers);
            };
            (e.Defaults = {
                nav: !1,
                navText: [
                    '<span aria-label="' + theme.strings.previous + '">&#x2039;</span>',
                    '<span aria-label="' + theme.strings.next + '">&#x203a;</span>',
                ],
                navSpeed: !1,
                navElement: 'button type="button" role="presentation"',
                navContainer: !1,
                navContainerClass: "owl-nav",
                navClass: ["owl-prev", "owl-next"],
                slideBy: 1,
                dotClass: "owl-dot",
                dotsClass: "owl-dots",
                dots: !0,
                dotsEach: !1,
                dotsData: !1,
                dotsSpeed: !1,
                dotsContainer: !1,
            }),
                (e.prototype.initialize = function () {
                    var b,
                        c = this._core.settings;
                    (this._controls.$relative = (
                        c.navContainer
                            ? a(c.navContainer)
                            : a("<div>").addClass(c.navContainerClass).appendTo(this.$element)
                    ).addClass("disabled")),
                        (this._controls.$previous = a("<" + c.navElement + ">")
                            .addClass(c.navClass[0])
                            .html(c.navText[0])
                            .prependTo(this._controls.$relative)
                            .on(
                                "click",
                                a.proxy(function (a) {
                                    this.prev(c.navSpeed);
                                }, this)
                            )),
                        (this._controls.$next = a("<" + c.navElement + ">")
                            .addClass(c.navClass[1])
                            .html(c.navText[1])
                            .appendTo(this._controls.$relative)
                            .on(
                                "click",
                                a.proxy(function (a) {
                                    this.next(c.navSpeed);
                                }, this)
                            )),
                        c.dotsData ||
                            (this._templates = [
                                a('<button role="button">').addClass(c.dotClass).append(a("<span>")).prop("outerHTML"),
                            ]),
                        (this._controls.$absolute = (
                            c.dotsContainer
                                ? a(c.dotsContainer)
                                : a("<div>").addClass(c.dotsClass).appendTo(this.$element)
                        ).addClass("disabled")),
                        this._controls.$absolute.on(
                            "click",
                            "button",
                            a.proxy(function (b) {
                                var d = a(b.target).parent().is(this._controls.$absolute)
                                    ? a(b.target).index()
                                    : a(b.target).parent().index();
                                b.preventDefault(), this.to(d, c.dotsSpeed);
                            }, this)
                        );
                    for (b in this._overrides) {
                        this._core[b] = a.proxy(this[b], this);
                    }
                }),
                (e.prototype.destroy = function () {
                    var a, b, c, d, e;
                    e = this._core.settings;
                    for (a in this._handlers) {
                        this.$element.off(a, this._handlers[a]);
                    }
                    for (b in this._controls) {
                        "$relative" === b && e.navContainer ? this._controls[b].html("") : this._controls[b].remove();
                    }
                    for (d in this.overides) {
                        this._core[d] = this._overrides[d];
                    }
                    for (c in Object.getOwnPropertyNames(this)) {
                        "function" != typeof this[c] && (this[c] = null);
                    }
                }),
                (e.prototype.update = function () {
                    var a,
                        b,
                        c,
                        d = this._core.clones().length / 2,
                        e = d + this._core.items().length,
                        f = this._core.maximum(!0),
                        g = this._core.settings,
                        h = g.center || g.autoWidth || g.dotsData ? 1 : g.dotsEach || g.items;
                    if (
                        ("page" !== g.slideBy && (g.slideBy = Math.min(g.slideBy, g.items)),
                        g.dots || "page" == g.slideBy)
                    )
                        for (this._pages = [], a = d, b = 0, c = 0; a < e; a++) {
                            if (b >= h || 0 === b) {
                                if (
                                    (this._pages.push({ start: Math.min(f, a - d), end: a - d + h - 1 }),
                                    Math.min(f, a - d) === f)
                                )
                                    break;
                                (b = 0), ++c;
                            }
                            b += this._core.mergers(this._core.relative(a));
                        }
                }),
                (e.prototype.draw = function () {
                    var b,
                        c = this._core.settings,
                        d = this._core.items().length <= c.items,
                        e = this._core.relative(this._core.current()),
                        f = c.loop || c.rewind;
                    this._controls.$relative.toggleClass("disabled", !c.nav || d),
                        c.nav &&
                            (this._controls.$previous.toggleClass("disabled", !f && e <= this._core.minimum(!0)),
                            this._controls.$next.toggleClass("disabled", !f && e >= this._core.maximum(!0))),
                        this._controls.$absolute.toggleClass("disabled", !c.dots || d),
                        c.dots &&
                            ((b = this._pages.length - this._controls.$absolute.children().length),
                            c.dotsData && 0 !== b
                                ? this._controls.$absolute.html(this._templates.join(""))
                                : b > 0
                                  ? this._controls.$absolute.append(new Array(b + 1).join(this._templates[0]))
                                  : b < 0 && this._controls.$absolute.children().slice(b).remove(),
                            this._controls.$absolute.find(".active").removeClass("active"),
                            this._controls.$absolute
                                .children()
                                .eq(a.inArray(this.current(), this._pages))
                                .addClass("active"));
                }),
                (e.prototype.onTrigger = function (b) {
                    var c = this._core.settings;
                    b.page = {
                        index: a.inArray(this.current(), this._pages),
                        count: this._pages.length,
                        size: c && (c.center || c.autoWidth || c.dotsData ? 1 : c.dotsEach || c.items),
                    };
                }),
                (e.prototype.current = function () {
                    var b = this._core.relative(this._core.current());
                    return a
                        .grep(
                            this._pages,
                            a.proxy(function (a, c) {
                                return a.start <= b && a.end >= b;
                            }, this)
                        )
                        .pop();
                }),
                (e.prototype.getPosition = function (b) {
                    var c,
                        d,
                        e = this._core.settings;
                    return (
                        "page" == e.slideBy
                            ? ((c = a.inArray(this.current(), this._pages)),
                              (d = this._pages.length),
                              b ? ++c : --c,
                              (c = this._pages[((c % d) + d) % d].start))
                            : ((c = this._core.relative(this._core.current())),
                              (d = this._core.items().length),
                              b ? (c += e.slideBy) : (c -= e.slideBy)),
                        c
                    );
                }),
                (e.prototype.next = function (b) {
                    a.proxy(this._overrides.to, this._core)(this.getPosition(!0), b);
                }),
                (e.prototype.prev = function (b) {
                    a.proxy(this._overrides.to, this._core)(this.getPosition(!1), b);
                }),
                (e.prototype.to = function (b, c, d) {
                    var e;
                    !d && this._pages.length
                        ? ((e = this._pages.length),
                          a.proxy(this._overrides.to, this._core)(this._pages[((b % e) + e) % e].start, c))
                        : a.proxy(this._overrides.to, this._core)(b, c);
                }),
                (a.fn.owlCarousel.Constructor.Plugins.Navigation = e);
        })(window.Zepto || window.jQuery, window, document),
        (function (a, b, c, d) {
            "use strict";
            var e = function e(c) {
                (this._core = c),
                    (this._hashes = {}),
                    (this.$element = this._core.$element),
                    (this._handlers = {
                        "initialized.owl.carousel": a.proxy(function (c) {
                            c.namespace &&
                                "URLHash" === this._core.settings.startPosition &&
                                a(b).trigger("hashchange.owl.navigation");
                        }, this),
                        "prepared.owl.carousel": a.proxy(function (b) {
                            if (b.namespace) {
                                var c = a(b.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");
                                if (!c) return;
                                this._hashes[c] = b.content;
                            }
                        }, this),
                        "changed.owl.carousel": a.proxy(function (c) {
                            if (c.namespace && "position" === c.property.name) {
                                var d = this._core.items(this._core.relative(this._core.current())),
                                    e = a
                                        .map(this._hashes, function (a, b) {
                                            return a === d ? b : null;
                                        })
                                        .join();
                                if (!e || b.location.hash.slice(1) === e) return;
                                b.location.hash = e;
                            }
                        }, this),
                    }),
                    (this._core.options = a.extend({}, e.Defaults, this._core.options)),
                    this.$element.on(this._handlers),
                    a(b).on(
                        "hashchange.owl.navigation",
                        a.proxy(function (a) {
                            var c = b.location.hash.substring(1),
                                e = this._core.$stage.children(),
                                f = this._hashes[c] && e.index(this._hashes[c]);
                            f !== d && f !== this._core.current() && this._core.to(this._core.relative(f), !1, !0);
                        }, this)
                    );
            };
            (e.Defaults = { URLhashListener: !1 }),
                (e.prototype.destroy = function () {
                    var c, d;
                    a(b).off("hashchange.owl.navigation");
                    for (c in this._handlers) {
                        this._core.$element.off(c, this._handlers[c]);
                    }
                    for (d in Object.getOwnPropertyNames(this)) {
                        "function" != typeof this[d] && (this[d] = null);
                    }
                }),
                (a.fn.owlCarousel.Constructor.Plugins.Hash = e);
        })(window.Zepto || window.jQuery, window, document),
        (function (a, b, c, d) {
            function e(b, c) {
                var e = !1,
                    f = b.charAt(0).toUpperCase() + b.slice(1);
                return (
                    a.each((b + " " + h.join(f + " ") + f).split(" "), function (a, b) {
                        if (g[b] !== d) return (e = !c || b), !1;
                    }),
                    e
                );
            }
            function f(a) {
                return e(a, !0);
            }
            var g = a("<support>").get(0).style,
                h = "Webkit Moz O ms".split(" "),
                i = {
                    transition: {
                        end: {
                            WebkitTransition: "webkitTransitionEnd",
                            MozTransition: "transitionend",
                            OTransition: "oTransitionEnd",
                            transition: "transitionend",
                        },
                    },
                    animation: {
                        end: {
                            WebkitAnimation: "webkitAnimationEnd",
                            MozAnimation: "animationend",
                            OAnimation: "oAnimationEnd",
                            animation: "animationend",
                        },
                    },
                },
                j = {
                    csstransforms: function csstransforms() {
                        return !!e("transform");
                    },
                    csstransforms3d: function csstransforms3d() {
                        return !!e("perspective");
                    },
                    csstransitions: function csstransitions() {
                        return !!e("transition");
                    },
                    cssanimations: function cssanimations() {
                        return !!e("animation");
                    },
                };
            j.csstransitions() &&
                ((a.support.transition = new String(f("transition"))),
                (a.support.transition.end = i.transition.end[a.support.transition])),
                j.cssanimations() &&
                    ((a.support.animation = new String(f("animation"))),
                    (a.support.animation.end = i.animation.end[a.support.animation])),
                j.csstransforms() &&
                    ((a.support.transform = new String(f("transform"))), (a.support.transform3d = j.csstransforms3d()));
        })(window.Zepto || window.jQuery, window, document);
})(theme.jQuery);
